import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
  signal
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { camelCase, cloneDeep, debounce, isArray, isEmpty, isEqual, orderBy, startCase, uniq, uniqBy } from 'lodash-es';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { environment } from 'src/environments/environment';
import { MenuItem, MessageService } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { DialogService } from 'primeng/dynamicdialog';
import { BehaviorSubject, Observable, Subscription, combineLatest, distinctUntilChanged, forkJoin, skip, take } from 'rxjs';
import { RegexPatternConstants } from 'src/app/base/regex-pattern.constants';
import { getGeneratedAppUrl, getSidBasedApps } from 'src/app/STORE/actions/applifecycle.actions';
import { getAllCustomComponentForApp } from 'src/app/STORE/actions/customcomponent.actions';
import { getAllDataModelTables, getForeignKey } from 'src/app/STORE/actions/datamodel.actions';
import * as propertyActions from 'src/app/STORE/actions/propertypane.actions';
import {
  getPropertiesData,
  setCurrentNodeData,
  setPropertiesData,
  setScreenValues,
  triggerLoading
} from 'src/app/STORE/actions/propertypane.actions';
import { setQBProperties } from 'src/app/STORE/actions/queryBuilder.actions';
import { getRoles } from 'src/app/STORE/actions/roles.actions';
import {
  deleteScreens,
  getAppNavigation,
  getChildTables,
  getFieldsInfoForTable,
  getMsScreenData,
  getPagesForQuery,
  getQueryTableData,
  getScreenStructure,
  getScreens,
  getStandardListPages,
  getTableData,
  getTableOrder,
  getTablesForQuery,
  saveScreens,
  setFieldsInfoForTable,
  setLandngScreen,
  setNewlyAddedScreen,
  setPagesForQuery,
  setQueryMapData,
  setQueryTableData,
  setScreenStructure,
  setSelectedScreens,
  setStandardListPages,
  setTableData,
  setTablesForQuery,
  updateScnAndDMCOnfig,
  updateScreenStructure,
  updateScreens
} from 'src/app/STORE/actions/screens.actions';
import { setFieldsForTable } from 'src/app/STORE/actions/services.actions';
import { getTemplates } from 'src/app/STORE/actions/templates.actions';
import {
  appData,
  appDataWithId,
  fsLoginInitiated,
  genUrl,
  metaInfo,
  selectedAppData
} from 'src/app/STORE/selectors/applifecycle.selector';
import { allCCsForApp } from 'src/app/STORE/selectors/customcomponent.selector';
import { allDataModelTables, foreignKeyTbl } from 'src/app/STORE/selectors/datamodel.selector';
import { allPropertiesData, propertiesValues } from 'src/app/STORE/selectors/propertypane.selector';
import { rolesTable } from 'src/app/STORE/selectors/roles.selector';
import {
  allScreens,
  appNav,
  childTables,
  confAndFileCntntSveFail,
  confAndFileCntntSveSucc,
  deletedScreenId,
  deletePageVariableSuccess,
  fiForSelectedScreen,
  landScrId,
  msScreenData,
  newScreen,
  queryPages,
  queryTableData,
  selectedScreen,
  standardPages,
  tableData,
  tableOrder,
  updatedScreenData
} from 'src/app/STORE/selectors/screens.selector';
import { templatesData } from 'src/app/STORE/selectors/templates.selector';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { Operators, VsQueryBuilderService } from 'src/app/components/vs-qb-builder/vs-query-builder.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { FsBaseService } from 'src/app/services/fs-base.service';
import { getPendingService } from 'src/app/services/pendingHttpServices.service';
import * as utilEnum from 'src/app/services/util.enum';
import { UtilService } from 'src/app/services/util.service';
import { ReferenceUtilService } from 'src/app/components/reference-tree-view/reference-util.service';
import { ModelType, ActionType, UiActions } from 'src/app/components/reference-tree-view/reference.enum';
import { v4 as uuidv4 } from 'uuid';
import { DMConstants, nodeType } from '../../designs/data-model/data-model.component';
import { contextMenuItems } from './contextMenuItems';
import { ModelEventType, ModalEvent } from './screens.types';
import { lookupTypes } from 'src/app/components/pg-lookup-configuration/pg-lookup-configuration.component';
import { SplitButton } from 'primeng/splitbutton';
import { TreeTable } from 'primeng/treetable';
import { allInterimScreens, confAndFileCntSveSuccInterim, confAndFileCntSveFailInterim, deletedScreenInterimId, selectedScreenInterim } from 'src/app/STORE/selectors/generations/screen-interim.selectors';
import ScreenInterimActions from 'src/app/STORE/actions/generations/screen-interim.actions';
import { userData } from 'src/app/STORE/selectors/auth.selector';
import { ListPageActionService } from 'src/app/services/list-page-action.service';
import { ScreenIdentifierService } from 'src/app/services/screen-identifier.service';
import { ScreenNode } from 'src/app/base/screen-identifier.constants';
import { ScreensReferenceService, ReferenceContext, PropertyChangeInput } from './screens-reference.service';

export enum pageTableType {
  QUERY_VIEW = 'QUERY_VIEW',
  TRANSACTIONAL = 'TRANSACTIONAL'
}
@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-screens',
  templateUrl: './screens.component.html',
  styleUrls: ['./screens.component.scss'],
  providers: [DialogService],
  standalone: false //NOSONAR
})
export class ScreensComponent implements OnInit, AfterViewInit, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  getTreeSelector(): string {
    return this.pageViewMode === 'list' ? '#screensTree-list' : '#screensTree-pane';
  }

  private store = inject(Store);
  private readonly actions$ = inject(Actions);
  private zone = inject(NgZone);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private messageService = inject(MessageService);
  private appGlobalService = inject(AppGlobalService);
  private loader = inject(AppLoaderService);
  util = inject(UtilService);
  qbService = inject(VsQueryBuilderService);
  private translate = inject(TranslateService);
  private pendingService = inject(getPendingService);
  private bs = inject(HttpBaseService);
  private referenceUtil = inject(ReferenceUtilService);
  private fsService = inject(FsBaseService);
  private cdRef = inject(ChangeDetectorRef);
  private http = inject(HttpClient);
  private readonly listPageActionService = inject(ListPageActionService);
  private readonly identifierService = inject(ScreenIdentifierService);
  private readonly screensReferenceService = inject(ScreensReferenceService);

  @ViewChild('splitter')
  public splitter;
  @ViewChild('cm') cm: ContextMenu;
  @ViewChild('ctxtmenu') ctxtmenu: ContextMenu;
  @Input() contextMenu1: ContextMenu;
  @Input() contextMenu2: ContextMenu;
  @Input() isFromModernize = false;
  @Input() generationId = '';
  @Input() modernizeReadOnly = false;
  private _modernizeStepStatus = '';
  @Input()
  set modernizeStepStatus(value: string) {
    if (this.isFromModernize && value !== this._modernizeStepStatus) {
      this._modernizeStepStatus = value;
    }
  }
  get modernizeStepStatus(): string {
    return this._modernizeStepStatus;
  }

  showCreateScreensModal = false;
  escapeListener: () => void;
  subscriptions: Subscription[] = [];
  popupOpened = false;
  cols: any[] = [];
  tables: any[] = [];
  svgPaths = GlobalConstants.svgPaths;
  cloneGridChildren: any[] = [];
  appNavStructure$: Observable<any> = this.store.select(appNav);
  isLoadingScreens = false;
  isLoadingPagesList = false;
  private activeStructureSub: Subscription | null = null;
  allTables: any[] = [];
  userName: any;
  allTablesSplitted: any = {
    generated: [],
    pending: []
  };
  indexedFields: any[] = [];
  allTablesBackup: any[] = [];
  allFields: any[] = [];
  checkBoxChanged = 0;
  updatedPageData: any;
  allTablesCopy: any[] = [];
  ftree: any;
  showPopup = false;
  showMenuPopup = false;
  showTabsPopup = false;
  showTabViewPopup = false;
  currentTableSid: any;
  applicationType: any;
  currNode: any;
  appForm: FormGroup;
  tabId1: any;
  tabId2: any;
  createScreenForm: FormGroup;
  taskstoSave: any;
  initialSave = false;
  allSelectedScreens: any = {};
  isInitilized = false;
  currentSelectedItem: any;
  @Output() selectedScreen = new EventEmitter<any>();
  currentSelectedTreeNode: any;
  isDesigningScreen = false;
  currentProperties$: Observable<any> = this.store.select(propertiesValues);
  canSaveWhileAddingFields = false;

  get isBetaAccessPrivilegeConsumable(): boolean {
    return this.appGlobalService.betaAccessPrivilegeForApp;
  }

  goBackToPagesList() {
    this.isDesigningScreen = false;
    this.currentSelectedItem = null;
  }

  switchPageView(mode: 'tiles' | 'list'): void {
    if (this.pageViewMode === mode) {
      return;
    }

    this.pageViewMode = mode;

    const currentScreen = this.currentSelectedItem || this.activeScreen;
    const currentScreenSid = currentScreen?.sid;
    if (!currentScreenSid) {
      return;
    }

    const selectedScreen = this.getScreenBySid(currentScreenSid) || currentScreen;
    if (selectedScreen) {
      this.loadStructure(null, selectedScreen, 'screen');
    }
  }

  private getScreenBySid(sid: string): any | null {
    const allScreens = [
      ...(this.allSelectedScreens?.sysGenScreens || []),
      ...(this.allSelectedScreens?.userGenScreens || [])
    ];

    return allScreens.find((screen: any) => screen?.sid === sid) || null;
  }

  showAddFieldsModal = false;
  addFieldsCols: any[] = [];
  showLayoutBuilder = false;
  @ViewChild('svgElement') svgElementRef!: ElementRef;
  showHomePageTooltip = false;
  activeScreen: any;
  attachScreenListnerSubscription: any = [];
  sharedDbId: any;
  suiteId: any;
  layoutdata: any = null;
  defaultScreens: string[] = ['AppNavigation', 'HomePage', 'ApplicationUserList', 'ApplicationUserDetail'];
  allRoles: any;
  appId = '';
  private allDataModelTables$: Subscription;
  private allScreens$: any = null;
  private curContextMenuNode: any = null;
  private allProps: any = null;
  panelSizes: number[] = [30, 30, 40];
  private sizes;
  pageLimitMax = 1000;
  readonly maxSize = 50;
  showCreateScreen = false;
  items: MenuItem[];
  fieldIdMap: any = null;
  tableIdMap: any = null;
  isShowVisualizer = false;
  valueChangeListener: Subscription;
  triggeredScreenCreation = false;
  showDefaultPages = true;
  showCustomPages = true;
  pageViewMode: 'tiles' | 'list' = 'list';
  listPageName;
  showListPagesModal = false;
  showCCModal = false;
  ccInsertMode = 'over';
  listPages: any[] = [];
  allListPages: any[] = [];
  selectedPage: any = null;
  treeSearchMatches = 0;
  isSlideInLeft = false;
  selectedCC: any = null;
  allCCs: any = [];
  allCCsBkp: any = [];
  isModalLoader = false;
  isPopupLoader = false;
  searchTerm: any;
  pageDesignSearchTerm: any;
  fieldSearch: string;
  appUserTableId: any;

  // Track logic coming from main-layout -> 'visualizer' button intent
  originQueryParams: { origin?: string; msgId?: string } = {};

  appUserFields: any;
  qbFields: any;
  currentScreenFieldIds: any[];
  currentPicklist = {
    fields: [],
    tables: [],
    primaryFields: [],
    noImgFAFields: [],
    allFields: [],
    lookupFields: [],
    searchableFields: [],
    buttonFields: []
  };
  currentTableName: any;
  formDefaultValues: any = {};
  filteredDefaultValues: any = {};
  errorFlag = false;
  errorMessages: any = [];
  errorMessage: any;
  genAppUrl = false;
  prototypingAppUrl: any;
  ctxtItems: MenuItem[];
  getConfgFldsCallTrigrd: any = false;
  waitForCongFlsRes = false;
  pageTypeOptions: any[] = [];
  disallowEdit = false;
  screensResData: any = null;
  hasReference = false;
  dataMapParams: any = null;
  dmConfig: any = null;
  iconSize = '13px';
  showPreview = false;
  submitted = false;
  isRDBMS = false;
  foreignKeyData: any[] = [];
  foreignKeyMap: any = {};
  foreignKeys: any[] = [];
  selectedNodeTitle: any = '';
  referencesTasks: { addedReference: any[]; deletedReference: any[] } = { addedReference: [], deletedReference: [] };
  pageModalEvents: ModalEvent[] = [];
  pageSection: { createdPageSectionMap: any; updatedPageSectionMap: any; deletedPageSections: any[] } = {
    createdPageSectionMap: {},
    updatedPageSectionMap: {},
    deletedPageSections: []
  };
  updatedObject;
  messages: any = [];
  blockedMessage: string;
  blockedDocument = false;
  initialLoad: any = true;
  tabId: any;
  editScreenVal = false;
  gridChildrenFlds: any[] = [];
  seletedTemplate = null;
  screenLookupDefinitionDetails;
  dmconstants = DMConstants;
  queryTblProps;
  tblProps = null;
  navigationPageSid: string;
  unSubList: any = [];
  techStack: any;
  tabViewTitles: any = [];
  tabTitles: any = {};
  currentTabParent: string;
  previousType: any;
  isPendingSave = false;
  //referred tables
  orgId: any;
  activeTabIndex = signal(0);
  referredFields: any[] = [];
  referredForeignkeys: any[] = [];
  enrichedReferredFields: any[] = [];
  referredFieldsCols: any[] = [
    {
      field: 'name',
      header: 'FIELD_NAME'
    },
    {
      field: 'addedToTable',
      header: 'SELECTED'
    },
    {
      field: 'fkAliasName',
      header: 'ALIAS_NAME_COMPOSITE_FK'
    }
  ];
  @ViewChild('searchTbl') searchTbl!: TreeTable;

  onMouseEnterHomePageSvg() {
    this.showHomePageTooltip = true;
  }
  onMouseLeaveHomePageSvg() {
    this.showHomePageTooltip = false;
  }

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  createScreens() {
    this.showCreateScreensModal = true;
    this.checkBoxChanged = 0;
    this.cols = [
      {
        field: 'tableName',
        header: 'TABLE_NAME'
      },
      {
        field: 'listPage',
        header: 'LIST_PAGE'
      },
      {
        field: 'detailPage',
        header: 'DETAIL_PAGE'
      }
    ];

    this.isModalLoader = true;
    const datamodelApiConstants = ApiConstants.getAllTables;
    this.store.dispatch(getAllDataModelTables({ datamodelApiConstants }));
    const tableOrderApiConstants = ApiConstants.getTableOrder;
    this.store.dispatch(getTableOrder({ tableOrderApiConstants }));
    const dataModelTables$ = this.store.select(allDataModelTables);
    const tableOrder$ = this.store.select(tableOrder);
    this.allDataModelTables$ = combineLatest(dataModelTables$, tableOrder$).subscribe((res: any) => {
      if (res) {
        const allTables = res[0];
        this.allTablesSplitted.generated = [];
        this.allTablesSplitted.pending = [];
        if (allTables && res[1]) {
          this.allTables = cloneDeep(allTables);
          this.allTablesBackup = cloneDeep(allTables);
          this.allTablesCopy = cloneDeep(allTables);
          try {
            const tableOrdr = JSON.parse(res[1]?.tablesMap);
            let tbls: any[] = [];
            Object.keys(tableOrdr).forEach((id) => {
              const tb = this.allTables.find((tbl) => tbl.tableId === id);
              if (tb) {
                tbls = [...tbls, tb];
              }
            });
            tbls.forEach((tbl: any) => {
              if (tbl.lpNeeded && tbl.dpNeeded) {
                this.allTablesSplitted.generated = [...this.allTablesSplitted.generated, tbl];
              } else if (tbl.tableType !== DMConstants.ANALY_ONLY && tbl.tableType !== DMConstants.TRANSIENT) {
                switch (tbl.tableType) {
                  case DMConstants.QUERY_VIEW:
                    switch (tbl.queryType) {
                      case DMConstants.MULTIPLE_QUERY:
                        if (tbl.createDetailPage || (!tbl.createDetailPage && !tbl.lpNeeded)) {
                          this.allTablesSplitted.pending = [...this.allTablesSplitted.pending, tbl];
                        } else if (!tbl.createDetailPage && tbl.lpNeeded) {
                          this.allTablesSplitted.generated = [...this.allTablesSplitted.generated, tbl];
                        }
                        break;
                      case DMConstants.SINGLE_QUERY:
                        if (tbl.dpNeeded) {
                          this.allTablesSplitted.generated = [...this.allTablesSplitted.generated, tbl];
                        } else {
                          this.allTablesSplitted.pending = [...this.allTablesSplitted.pending, tbl];
                        }
                        break;
                    }
                    break;
                  default:
                    this.allTablesSplitted.pending = [...this.allTablesSplitted.pending, tbl];
                    break;
                }
              }
            });
          } catch (e) {
            console.error(e);
          }
          this.isModalLoader = false;
        }
      }
    });
    this.addToSubscriptionsList(this.allDataModelTables$);
  }
  /**
   * Sets the properties for import menu item.
   *
   * @param {string} menuProps - Menuprops with default values will be assigned with import properties.
   *
   */
  setImportMenuItemProps(menuProps) {
    menuProps.icon = 'menu-item-icon';
    menuProps.key = 'import-menu';
    menuProps.key = 'import-menu';
    const props = menuProps?.properties;
    props.accessControl = ['all'];
    props.customUrl = '/imports/importspage';
    props.label = 'Imports';
    props.onClick = 'navigate_to_url';
    props.currentNode = 'import-menu';
    props.icon = {
      icon: {
        label: 'download-01',
        value: 'download-01.svg'
      },
      iconColor: '#000000',
      iconSize: '18px',
      type: utilEnum.IconType.SYSTEM_ICON
    };
  }
  createScreen(isEditScreenFunc = false) {
    this.messages = [];
    this.editScreenVal = isEditScreenFunc;
    if (!this.editScreenVal) {
      this.createScreenForm.get('tableName')?.enable();
      this.createScreenForm.get('pageType')?.enable();
    }
    this.createScreenForm.reset();
    this.createScreenForm.get('screenType')?.setValue('fromTable');
    this.pageTypeOptions = [
      {
        name: 'List Page',
        value: 'list'
      },
      {
        name: 'Detail Page',
        value: 'detail'
      },
      {
        name: 'Custom Page',
        value: 'custom'
      }
    ];
    const datamodelApiConstants = ApiConstants.getAllTables;
    this.store.dispatch(getAllDataModelTables({ datamodelApiConstants }));
    this.allDataModelTables$ = this.store.select(allDataModelTables).subscribe((allTables: any) => {
      if (allTables) {
        this.allTables = cloneDeep(allTables);
        this.allTablesBackup = cloneDeep(allTables);
        this.allTablesCopy = cloneDeep(allTables);
      }
    });
    this.showCreateScreen = true;
    this.addToSubscriptionsList(this.allDataModelTables$);
  }
  searchForTable(event: any) {
    this.allTablesCopy = this.allTables.filter(
      (table: any) =>
        table?.tableName?.toLowerCase().includes(event?.query?.toLowerCase()) &&
        (table.tableType === DMConstants.TRANS_ONLY ||
          table.tableType === DMConstants.TRANS_ANALY ||
          table.tableType === DMConstants.QUERY_VIEW)
    );
  }
  onclose() {
    this.showCreateScreen = false;
    this.createScreenForm.reset();
    this.createScreenForm.get('screenType')?.setValue('fromTable');
    this.errorFlag = false;
    this.errorMessage = '';
  }

  ontblChange(event) {
    const tbl = this.createScreenForm.get('tableName')?.value;
    const allPageTypes = [
      { name: 'List Page', value: 'list' },
      { name: 'Detail Page', value: 'detail' },
      { name: 'Custom Page', value: 'custom' }
    ];

    const listAndCustomOnly = [
      { name: 'List Page', value: 'list' },
      { name: 'Custom Page', value: 'custom' }
    ];

    const detailAndCustomOnly = [
      { name: 'Detail Page', value: 'detail' },
      { name: 'Custom Page', value: 'custom' }
    ];

    this.pageTypeOptions = allPageTypes;
    if (tbl.tableType === DMConstants.QUERY_VIEW) {
      if (tbl.queryType === DMConstants.MULTIPLE_QUERY) {
        this.pageTypeOptions = tbl.createDetailPage ? allPageTypes : listAndCustomOnly;
      } else {
        this.pageTypeOptions = detailAndCustomOnly;
      }
    }
  }

  generateSelectedScreen() {
    this.errorFlag = false;
    this.errorMessages = [];
    this.errorMessage = '';
    this.messages = [];
    // console.log(this.createScreenForm.value);
    const val = this.createScreenForm.value;
    const errors = [];
    const myRe = RegexPatternConstants.alphanumericNameWithUnderscore;
    if (!val.pageName) {
      this.errorFlag = true;
      this.messages.pageName = 'Page Name is not Valid';
      //errors.push('Page Name');
    }
    if (val.screenType === 'fromTable' && !val.tableName) {
      this.errorFlag = true;
      this.messages.tableName = 'Select a Table';
    }

    if (val.screenType === 'fromTable' && !val.pageType) {
      this.errorFlag = true;
      this.messages.pageType = 'Select the Page Type';
    }

    if (val.pageName && !myRe.test(val.pageName)) {
      this.errorFlag = true;
      this.messages.pageName = this.translate.instant('PAGE_NAME_WITH_UNDERSCORE');
    }

    const allScreens = [...this.allSelectedScreens.sysGenScreens, ...this.allSelectedScreens.userGenScreens];
    const isDuplicate = allScreens.filter(
      (as: any) =>
        as.pageName?.toLowerCase()?.trim().replace(/\s\s+/g, ' ') ==
        val.pageName?.toLowerCase()?.trim().replace(/\s\s+/g, ' ')
    );
    if (isDuplicate.length > 0) {
      this.errorFlag = true;
      this.errorMessages.push('Page already exists');
      this.showMessage('error', this.errorMessages);
    }
    if (this.errorFlag) {
      return;
    }

    const dataToSave = {
      pageName: val.pageName,
      tableName: val.tableName?.tableName,
      tableId: val.tableName?.tableId,
      tableType: val.tableName?.tableType,
      pageType: val.pageType
    };
    const api = { ...ApiConstants.createScreen };
    api.url += `${this.appGlobalService.get('orgId')}/${this.appId}`;
    this.isLoadingScreens = true;
    this.store.dispatch(saveScreens({ saveScreensApiConstants: api, screensData: dataToSave }));
    let newScreenSub$;
    newScreenSub$ = this.store.select(newScreen).subscribe((sc: any) => {
      if (sc) {
        this.allSelectedScreens.userGenScreens.push(sc);
        this.showCreateScreen = false;
        this.isLoadingScreens = false;
        if (this.createScreenForm) {
          this.createScreenForm.reset();
          this.createScreenForm.get('screenType')?.setValue('fromTable');
          this.createScreenForm.patchValue({
            screenType: 'fromTable'
          });
          // console.log(newScreenSub$);
          newScreenSub$.unsubscribe();
        }
        this.store.dispatch(setNewlyAddedScreen({ addedScreen: null }));
        this.allSelectedScreens.userGenScreens = uniqBy(this.allSelectedScreens.userGenScreens, 'sid');
      }
    });
    this.addToSubscriptionsList(newScreenSub$);
  }

  updateSelectedScreen() {
    this.errorFlag = false;
    this.messages = [];
    const val = this.createScreenForm.value;
    const myRe = RegexPatternConstants.alphanumericNameWithUnderscore;
    if (!val.pageName) {
      this.errorFlag = true;
      this.messages.pageName = 'Page Name is not Valid';
    }
    if (val.pageName && !myRe.test(val.pageName)) {
      this.errorFlag = true;
      this.messages.pageName = this.translate.instant('PAGE_NAME_WITH_UNDERSCORE');
    }
    const allScreens = [...this.allSelectedScreens.sysGenScreens, ...this.allSelectedScreens.userGenScreens];
    const isDuplicate = allScreens.filter(
      (as: any) =>
        as.pageName?.toLowerCase()?.trim().replace(/\s\s+/g, ' ') ==
        val.pageName?.toLowerCase()?.trim().replace(/\s\s+/g, ' ')
    );
    if (isDuplicate.length > 0) {
      this.errorFlag = true;
      this.showMessage('error', 'Page already exists');
    }
    if (this.errorFlag) {
      return;
    }
    const api = { ...ApiConstants.updateScreen };
    this.isLoadingScreens = true;
    let pageData: any;
    let responseData: any;
    const loadScreenSub1 = this.store.select(selectedScreen).subscribe((response: any) => {
      if (response) {
        responseData = response;
        pageData = JSON.parse(JSON.stringify(response));
        pageData.pageName = val.pageName;
        pageData.fieldsToTranslate[0] = val.pageName;
        if (!val.pageRenamed) {
          pageData.pageRenamed = true;
        }

        // Update pageView and grid (for list pages) elementIds on page rename
        this.updatePageElementIdsOnRename(pageData, val.pageName);

        this.updatedPageData = [...pageData];
      }
    });
    if (loadScreenSub1) {
      loadScreenSub1.unsubscribe();
    }
    this.updateSelectedScreenVal(api, pageData);
  }

  updateSelectedScreenVal(api: any, pageData: any) {
    this.store.dispatch(updateScreenStructure({ updateStructureApiConstants: api, updatedStructure: pageData }));
    const loadScreenSub2 = this.store.select(selectedScreen).subscribe((data: any) => {
      if (data) {
        let userGenScreens: any[] = [];
        // Use server response data, not request data
        const index = this.allSelectedScreens.userGenScreens.findIndex((fld) => {
          return fld.sid === data.sid;
        });
        if (index > -1) {
          // Update with server response (data), not with request (pageData)
          this.allSelectedScreens.userGenScreens[index] = data;
        }
        userGenScreens = this.allSelectedScreens.userGenScreens;
        userGenScreens = [...uniqBy(userGenScreens, 'pageName')];
        if (userGenScreens.length > 0) {
          this.allSelectedScreens.userGenScreens = [...userGenScreens];
        }
        this.showCreateScreen = false;
        this.cdRef.detectChanges();
        setTimeout(() => {
          if (loadScreenSub2) {
            this.showCreateScreen = false;
            loadScreenSub2.unsubscribe();
          }
           this.loader.hide();
           this.isLoadingScreens = false;
        }, 100);
      }
    });
  }

  handleSelectionChange(e, table, field) {
    table[`temp_${field}`] = true;
    if (e.checked) {
      this.checkBoxChanged += 1;
    } else {
      this.checkBoxChanged -= 1;
    }
    if (field === 'addedToTable') {
      const hasTableFieldsChanges = this.allFields?.some((fld) => fld.addedToTable && fld.temp_addedToTable);
      const hasReferredFieldsChanges = this.referredFields?.some((node: any) =>
        node.children?.some((child: any) => child.data?.addedToTable && child.data?.temp_addedToTable)
      );
      this.canSaveWhileAddingFields = hasTableFieldsChanges || hasReferredFieldsChanges;
    }
  }

  createScreensFromTable() {
    if (this.checkBoxChanged > 50) {
      this.showMessage('error', 'Screens to be generated should be less than 50');
      return;
    }
    // this.isLoadingScreens = true;
    this.loader.show();
    this.triggeredScreenCreation = true;
    // console.log(this.allTables);
    const dataToSend: any[] = [];
    this.allTables.map((tbl) => {
      const obj: any = {};
      Object.keys(tbl).map((key) => {
        if (key.indexOf('temp_') === -1) {
          obj[key] = tbl[key];
        }
      });
      //obj.tabId = this.tabId;
      dataToSend.push(obj);
    });

    const dmSaveApi = ApiConstants.addScreensForTables;
    this.store.dispatch(
      updateScreens({
        screensApiConstants: dmSaveApi,
        screensData: dataToSend
      })
    );
    this.showCreateScreensModal = false;
    this.checkBoxChanged = 0;
  }

  handleScreensModalClose() {
    this.showCreateScreensModal = false;
    if (!this.triggeredScreenCreation) {
      this.loader.hide();
    }
    this.checkBoxChanged = 0;
  }

  handleScreenClick() {
    //this.initTree(this.data);
  }

  showWhereUsed(event: Event, screen: any): void {
    event?.preventDefault?.();

    this.isLoadingScreens = true;
    this.referenceUtil.showWhereUsed(
      {
        id: screen.sid,
        name: screen.pageName,
        type: this.translate.instant('SCREEN')
      },
      { hideLoader: () => (this.isLoadingScreens = false) }
    );
  }

  formConfirmationMessage(pageName, value) {
    const message = this.translate.instant('CONFIRMATION_MESSAGE_DELETE_SCREEN', { pageName: pageName });
    return message;
  }

  confirmDeletion(sid, pageName, value?: any, fromReference?: boolean) {
    const message = this.formConfirmationMessage(pageName, value);
    this.isLoadingScreens = false;
    let confirmationObj;
    if (!fromReference) {
      confirmationObj = {
        message,
        accept: () => {
          this.confirmDelScn(sid, false);
        },
        reject: () => {
          return;
        }
      };
      this.zone.run(() => {
        this.confirmationDialogService.confirm(confirmationObj);
      });
    } else {
      const navigationSid = value.filter((x) => x.modelId === this.activeScreen?.sid);
      this.confirmDelScn(sid, navigationSid.length > 0);
    }
    if (confirmationObj) {
      this.zone.run(() => {
        this.confirmationDialogService.confirm(confirmationObj);
      });
    }
  }

  confirmDelScn(sid, pageSid) {
    this.isLoadingScreens = true;
    if (this.isFromModernize) {
      this.deleteScreenInterimById(sid);
      return;
    }
    this.store.dispatch(deleteScreens({ deleteScreenApi: ApiConstants.deleteScreens, screensId: { id: sid } }));
    const deletedSub = this.store.select(deletedScreenId).subscribe((scid: any) => {
      if (sid === scid?.id) {
        this.allSelectedScreens.userGenScreens = this.allSelectedScreens.userGenScreens.filter(
          (sc: any) => sc.sid !== scid.id && sc.sid
        );
        this.isLoadingScreens = false;
        this.resetPropertyPane();
        if (pageSid) {
          const isActiveDeleted = this.activeScreen?.sid === sid;
          const reloadSid = isActiveDeleted ? this.navigationPageSid : this.activeScreen?.sid;
          if (!reloadSid) {
            return;
          }
          const api: any = { ...ApiConstants.getScrById };
          this.store.dispatch(getScreenStructure({ getScreenStructureApiConstants: api, sid: { sid: reloadSid } }));
          const loadScreenSub = this.store.select(selectedScreen).subscribe((data: any) => {
            this.loader.show();
            if (data && data?.sid === reloadSid) {
              const screenData = data;
              this.currentScreenFieldIds = screenData.fieldIds ? [...screenData.fieldIds] : [];
              let structure = screenData.contentAttachment ? JSON.parse(screenData.contentAttachment) : null;
              this.screensResData = screenData;
              if (structure === undefined) {
                return;
              }
              if (structure === null) {
                structure = [
                  {
                    title: 'No Data to Display',
                    key: 'noData'
                  }
                ];
              }
              if ($('.fancytree-edit-input')) {
                $('.fancytree-edit-input').off('keydown');
              }
              this.initTree(structure);
              if (structure[0].key !== 'loadingData') {
                this.isLoadingScreens = false;
                this.loader.hide();
              }
              if (loadScreenSub) {
                loadScreenSub.unsubscribe();
              }
            }
            setTimeout(() => {
              this.loader.hide();
            }, 500);
          });
          this.addToSubscriptionsList(loadScreenSub);
        }
      }
    });
    this.addToSubscriptionsList(deletedSub);
  }

  deleteScreen(event: any, screen: any) {
    if (this.isFromModernize) {
      this.confirmDeletion(screen.sid, screen.pageName);
      event.preventDefault();
      return;
    }
    this.isLoadingScreens = true;
    this.referenceUtil.handleWithReferences({
      payload: {
        modelId: screen.sid,
        modelType: ModelType.PAGE,
        actionType: ActionType.PAGE_DELETE,
        action: UiActions.DELETE
      },
      node: { name: screen.pageName, type: 'Page' },
      onConfirm: () => this.confirmDelScn(screen.sid, true),
      onNoReferences: () => this.confirmDeletion(screen.sid, screen.pageName),
      onError: () => {
        this.isLoadingScreens = false;
      },
      onCancel: () => {
        this.isLoadingScreens = false;
      }
    });
    // console.log(allScreens);
    event.preventDefault();
  }

  editScreen(event: any, screen: any) {
    event?.preventDefault?.();

    this.editScreenVal = true;
    this.loader.show();
    this.createScreen(this.editScreenVal);
    const api: any = { ...ApiConstants.getScrById };
    this.store.dispatch(getScreenStructure({ getScreenStructureApiConstants: api, sid: { sid: screen.sid } }));
    const loadScreenSub = this.store.select(selectedScreen).subscribe((data: any) => {
      this.loader.show();
      if (data && data?.sid === screen?.sid) {
        this.loader.hide();
        this.createScreenForm.get('pageName')?.setValue(data?.pageName);
        const currentTable = this.allTables?.find((tbl) => tbl.tableId === data?.tableId);
        this.createScreenForm.get('tableName')?.patchValue({
          tableId: data?.tableId,
          tableName: currentTable?.tableName || data?.tableName
        });
        this.createScreenForm.get('tableName')?.disable();
        this.createScreenForm.get('pageType')?.setValue(data?.pageType);
        this.createScreenForm.get('pageType')?.disable();
      }
      setTimeout(() => {
        this.loader.hide();
      }, 500);
    });
    this.addToSubscriptionsList(loadScreenSub);
  }

  loadAppNavigationStructure() {
    this.loader.show();
    this.store.dispatch(getAppNavigation({ appNavApiConstants: ApiConstants.getAppNavigationStructure }));
    const appNavStructureSub = this.appNavStructure$.subscribe((appNav: any) => {
      if (appNav.length) {
        this.initTree(appNav);
        this.isLoadingScreens = false;
        this.loader.hide();
      }
    });
    this.addToSubscriptionsList(appNavStructureSub);
  }

  debounceStructure = debounce(this.loadStructure.bind(this), 1000);
  loadStructure(event: any, screen: any, type?: string) {
    this.isDesigningScreen = true;
    if (this.isFromModernize) {
      this.loadStructureInterim(event, screen, type);
      return;
    }
    const activeElement = document.activeElement as HTMLElement;
    if (
      activeElement &&
      ['INPUT', 'TEXTAREA'].includes(activeElement.tagName) &&
      activeElement.closest('.properties-pane')
    ) {
      activeElement.blur();
    }
    try {
      this.activeScreen = screen;

      // Wait to save the previous screen value and then load the new screen content
      if (this.pendingService.isPending.getValue()) {
        this.isLoadingScreens = true;
        this.debounceStructure(event, screen, type);
        return;
      }
      this.debounceSaveTree.cancel();

      if (this.isPendingSave) {
        this.saveFancyTreeData();
      }
      $(':ui-fancytree').fancytree('destroy');
      this.store.dispatch(setPropertiesData({ propertiesData: null }));
      this.store.dispatch(setScreenStructure({ selectedScreenStructure: null }));

      this.currentSelectedItem = screen;
      this.selectedScreen.emit(this.currentSelectedItem);
      this.selectedNodeTitle = '';
      const currTableId = this.currentSelectedItem.tableId;
      this.currentTableName = this.tableIdMap[currTableId];
      this.appUserTableId = this.appUserTableId ? this.appUserTableId : this.appGlobalService.get('appTableId');
      this.qbService.configureQueryBuilder(this.appUserTableId, currTableId, this.currentTableName);
      this.currentTableName = this.tableIdMap[currTableId];

      // getting screen's content through api call
      this.taskstoSave = null;
      this.isLoadingScreens = true;
      const api: any = { ...ApiConstants.getScrById };
      this.store.dispatch(getScreenStructure({ getScreenStructureApiConstants: api, sid: { sid: screen.sid } }));
      if (this.currentSelectedItem?.pageTableType == pageTableType.QUERY_VIEW) {
        this.store.dispatch(
          setQueryTableData({
            queryTableData: null
          })
        );
        const queryTblDataApiConstants = ApiConstants.getDatamodelTableData;
        const sid = { sid: currTableId };
        this.store.dispatch(
          getQueryTableData({
            queryTblDataApiConstants,
            sid
          })
        );
      } else if (this.currentSelectedItem?.pageType == 'list' || this.currentSelectedItem?.pageType == 'detail') {
        this.store.dispatch(
          setTableData({
            tableData: null
          })
        );
        const tblDataApiConstants = ApiConstants.getDatamodelTableData;
        const sid = { sid: currTableId };
        this.store.dispatch(
          getTableData({
            tblDataApiConstants,
            sid
          })
        );
      }

      const screenSub$ = this.store.select(selectedScreen);
      const foreignkeySub = this.store.select(foreignKeyTbl).subscribe((data: any) => {
        const fkdata = data;
        if (fkdata) {
          if (fkdata.length) {
            this.foreignKeys = [...fkdata];
          }
        }
      });
      this.store.dispatch(
        getForeignKey({
          fkapiConstants: ApiConstants.getAllForeignKeys,
          data: { appId: this.appId, orgId: this.orgId }
        })
      );
      this.foreignKeyData = [];
      this.addToSubscriptionsList(foreignkeySub);
      const loadScreenSub = screenSub$.subscribe((data: any) => {
        if (data) {
          if (data) {
            const screenData = data;
            if (this.currentSelectedItem?.pageType == 'list' || this.currentSelectedItem?.pageType == 'detail') {
              this.formPickListForListandDetailPages(screenData?.tableId, screenData?.pageType);
            }
            this.currentScreenFieldIds = screenData.fieldIds ? [...screenData.fieldIds] : [];
            if (screenData && screenData.sid === screen.sid) {
              let structure = screenData.contentAttachment ? JSON.parse(screenData.contentAttachment) : null;
              this.screensResData = screenData;
              if (structure === undefined) {
                return;
              }
              if (structure === null) {
                structure = [
                  {
                    title: 'No Data to Display',
                    key: 'noData'
                  }
                ];
              }
              if ($('.fancytree-edit-input')) {
                $('.fancytree-edit-input').off('keydown');
              }
              this.initTree(structure);
              if (structure[0].key !== 'loadingData') {
                this.tabViewTitles = [];
                this.tabTitles = {};
                this.getAllTitlesInfo(structure);
                this.isLoadingScreens = false;
                this.loader.hide();
              }
              //this.listenForPropertyChanges()
              if (loadScreenSub) {
                loadScreenSub.unsubscribe();
              }
            }
          }
        }
      });
      this.addToSubscriptionsList(loadScreenSub);
      //}, 10);
      const querytblDataSub = this.store.select(queryTableData).subscribe((data: any) => {
        if (data) {
          this.queryTblProps = data;
        }
      });
      this.addToSubscriptionsList(querytblDataSub);
      const tblDataSub = this.store.select(tableData).subscribe((data: any) => {
        if (data) {
          this.tblProps = data;
        }
      });
      this.addToSubscriptionsList(tblDataSub);
      this.addToSubscriptionsList(querytblDataSub);
    } catch (e) {
      console.error(e);
    }
  }

  filterTree(e) {
    let n;
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    const filterFunc = tree.filterNodes;
    const match = e.target.value;

    if ((e && e.which === $.ui.keyCode.ESCAPE) || $.trim(match as string) === '') {
      tree.clearFilter();
      this.treeSearchMatches = 0;
      return;
    }
    n = filterFunc.call(tree, match);
    this.treeSearchMatches = n;
  }

  isAllowedDrops(node, data) {
    const nodeType = data.node.type;
    if (data.hitMode === 'over') {
      switch (data?.otherNode?.type) {
        case 'menuItem':
        case 'MENU_ITEM':
          return [
            'leftHamburgerMenu',
            'menuGroup',
            'MENU_GROUP',
            'leftMenu',
            'APP_MENU',
            'leftPane',
            'middlePane',
            'rightPane',
            'rightMenu'
          ].includes(nodeType);
        case 'menuGroup':
        case 'MENU_GROUP':
          return [
            'leftHamburgerMenu',
            'menuGroup',
            'MENU_GROUP',
            'leftMenu',
            'APP_MENU',
            'leftPane',
            'middlePane',
            'rightPane',
            'rightMenu'
          ].includes(nodeType);
        case 'tabItem':
          return ['menuGroup', 'MENU_GROUP', 'tabGroup'].includes(nodeType);
        case 'tabGroup':
          return ['menuGroup', 'MENU_GROUP'].includes(nodeType);
        case 'tab':
          return ['tabView'].includes(nodeType);
        case 'formField':
        case 'tabView':
        case 'childList':
        case 'queryView':
        case 'standardDatagrid':
        case 'formSection':
          return ['formSection', 'form', 'tab'].includes(nodeType);
        case 'filterField':
          return ['filterField'].includes(nodeType);
        case 'inlineText':
          return [
            'tabView',
            'tab',
            'inlineText',
            'formField',
            'formSection',
            'customcomponent',
            'customcomp',
            'childList',
            'queryView',
            'pageView',
            'titleBar'
          ].includes(nodeType);
        case 'gridColumn':
          return ['grid'].includes(nodeType);
        case 'captionItem':
          return ['captionBar'].includes(nodeType);
        case 'button':
          if (this.checkWorkflowActionBar(data)) {
            return false;
          }
          return ['actionBar', 'rightActionBar', 'leftActionBar', 'buttonGroup'].includes(nodeType);
        case 'customButton':
          return ['form', 'formSection', 'tab'].includes(nodeType);
        case 'customComponent':
        case 'customcomponent':
        case 'customcomp':
          return ['form', 'formSection', 'tab', 'pageView', 'titleBar'].includes(nodeType);
        case 'htmlContainer':
          return ['form', 'formSection', 'tab', 'pageView', 'titleBar'].includes(nodeType);
        case 'language':
        case 'LANGUAGE':
          let langCheck = ['USER_MENU'].includes(nodeType);
          if (!langCheck) {
            this.showMessage('warn', this.translate.instant('DRAG_DROP_LANG_CHECK'));
          }
          return langCheck;
        case 'user_menu':
        case 'USER_MENU':
          let userMenuCheck = ['USER_MENU', 'LANGUAGE'].includes(nodeType);
          if (!userMenuCheck) {
            this.showMessage('warn', this.translate.instant('USER_MENU_DROP_CHECK'));
          }
          return userMenuCheck;
        default:
          return false;
      }
    } else {
      switch (data?.otherNode?.type) {
        case 'language':
        case 'LANGUAGE':
          let langCheck = ['USER_MENU'].includes(nodeType);
          if (!langCheck) {
            this.showMessage('warn', this.translate.instant('DRAG_DROP_LANG_CHECK'));
          }
          return langCheck;
        case 'user_menu':
        case 'USER_MENU':
          let userMenuCheck = ['USER_MENU', 'LANGUAGE'].includes(nodeType);
          if (!userMenuCheck) {
            this.showMessage('warn', this.translate.instant('USER_MENU_DROP_CHECK'));
          }
          return userMenuCheck;
        case 'menuGroup':
        case 'MENU_GROUP':
          if (this.canHaveMenuGroup(data.node.parent)) {
            return ['menuItem', 'MENU_ITEM', 'menuGroup', 'MENU_GROUP'].includes(nodeType);
          }
          this.showMessage('warn', this.translate.instant('Only one Menu Group can be nested in topbar.'));
          return false;
        case 'menuItem':
        case 'MENU_ITEM':
          return ['menuItem', 'MENU_ITEM', 'menuGroup', 'MENU_GROUP'].includes(nodeType);
        case 'tabGroup':
          return ['tabItem', 'tabGroup'].includes(nodeType);
        case 'tabItem':
          return ['tabItem', 'tabGroup'].includes(nodeType);
        case 'tab':
          return [
            'tabView',
            'tab',
            'formField',
            'formSection',
            'customcomponent',
            'customcomp',
            'childList',
            'queryView',
            'standardDatagrid',
            'inlineText',
            'htmlContainer'
          ].includes(nodeType);
        case 'logo':
          return false;
        case 'inlineText':
          return [
            'tabView',
            'tab',
            'inlineText',
            'formField',
            'formSection',
            'customcomponent',
            'customcomp',
            'customComponent',
            'childList',
            'queryView',
            'htmlContainer',
            'actionBar',
            'pageTitle',
            'breadCrumb',
            'titleBar',
            'captionBar',
            'form',
            'description',
            'filtersAndSearch',
            'table',
            'grid',
            'totalRecordsCount'
          ].includes(nodeType);
        case 'appTitle':
        case 'APP_NAME':
          return false;
        case 'formField':
        case 'tabView':
          return [
            'tabView',
            'tab',
            'formSection',
            'formField',
            'customcomponent',
            'customcomp',
            'childList',
            'queryView',
            'standardDatagrid',
            'inlineText',
            'htmlContainer'
          ].includes(nodeType);
        case 'formSection':
          return [
            'formSection',
            'formField',
            'customcomponent',
            'customcomp',
            'childList',
            'queryView',
            'standardDatagrid',
            'tabView',
            'inlineText',
            'htmlContainer'
          ].includes(nodeType);
        case 'searchField':
          return ['searchField'].includes(nodeType);
        case 'filterField':
          return ['filterField'].includes(nodeType);
        case 'grid':
          return ['listPage', 'captionBar'].includes(nodeType);
        case 'gridColumn':
          return ['gridColumn'].includes(nodeType);
        case 'captionBar':
          return ['listPage', 'grid', 'searchField', 'form'].includes(nodeType);
        case 'captionItem':
          return ['captionItem'].includes(nodeType);
        case 'button':
        case 'buttonGroup':
          if (this.checkWorkflowActionBar(data)) {
            return false;
          }
          return ['button', 'buttonGroup'].includes(nodeType);
        case 'customButton':
          return [
            'customButton',
            'htmlContainer',
            'formSection',
            'tab',
            'formField',
            'customcomponent',
            'customcomp',
            'childlist',
            'queryView'
          ].includes(nodeType);
        case 'htmlContainer':
          return [
            'customButton',
            'htmlContainer',
            'formSection',
            'tab',
            'formField',
            'customcomponent',
            'customcomp',
            'customComponent',
            'childlist',
            'queryView',
            'inlineText',
            'tabView',
            'actionBar',
            'pageTitle',
            'breadCrumb',
            'titleBar',
            'captionBar',
            'form',
            'description',
            'filtersAndSearch',
            'table',
            'grid',
            'totalRecordsCount'
          ].includes(nodeType);
        case 'customComponent':
        case 'customcomponent':
        case 'customcomp':
          return [
            'customComponent',
            'customcomponent',
            'customcomp',
            'htmlContainer',
            'inlineText',
            'breadCrumb',
            'titleBar',
            'captionBar',
            'form',
            'formSection',
            'formField',
            'tabView',
            'childList',
            'queryView',
            'actionBar',
            'pageTitle',
            'description',
            'filtersAndSearch',
            'table',
            'grid',
            'totalRecordsCount'
          ].includes(nodeType);
        case 'childList':
        case 'standardDatagrid':
          return [
            'formSection',
            'formField',
            'customcomponent',
            'customcomp',
            'childList',
            'queryView',
            'standardDatagrid',
            'tabView',
            'inlineText',
            'htmlContainer'
          ].includes(nodeType);
        case 'queryView':
          return [
            'formSection',
            'tab',
            'formField',
            'customcomponent',
            'customcomp',
            'childList',
            'queryView'
          ].includes(nodeType);
        case 'homeTile':
          return ['homeTile'].includes(nodeType);
        case 'userMenu':
          return ['userMenu'].includes(nodeType);
        default:
          return false;
      }
    }
  }
  checkWorkflowActionBar(data) {
    const isWorkflowActionBar = (node) =>
      node?.key === 'workflowActionBar' ||
      node?.parent?.key === 'workflowActionBar' ||
      node?.parent?.parent?.key === 'workflowActionBar';

    const otherNodeInWorkflow = isWorkflowActionBar(data?.otherNode);
    const nodeInWorkflow = isWorkflowActionBar(data?.node);

    if ((otherNodeInWorkflow && !nodeInWorkflow) || (!otherNodeInWorkflow && nodeInWorkflow)) {
      return true;
    }
    return false;
  }
  processTreeDataWithIDMapping() {
    // TODO: based on the id mapping in the datamodel, title will be changed
  }

  isNodeAvailable(paneNode, type) {
    if (paneNode.children.find((child) => child?.type.toLowerCase() === type.toLowerCase())) {
      return true;
    }
    return false;
  }

  searchInPane(type) {
    const panes = ['leftPane', 'rightPane', 'middlePane'];
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    let val = false;
    panes.find((pane) => {
      const paneNode = tree.getNodeByKey(pane);
      if (pane && paneNode.children) {
        // there was compilation while trying to access type of node, so writing in a separate method.
        val = this.isNodeAvailable(paneNode, type);
      }
      return val;
    });
    return val;
  }

  // getMenu() {
  //   // let node = tree.getNodeBy(val.sid);
  //   let types = ['language', 'logout']
  //   let menu = {};
  //   types.forEach(type => {
  //     if (!this.searchInPane(type)) {
  //       switch (type) {
  //         case 'language':
  //           menu = { ...menu, ...{ "addLangDrop": { 'name': 'Add Language Dropdown', 'icon': 'add' } } };
  //           break;
  //         case 'logout':
  //           menu = { ...menu, ...{ "addLogout": { 'name': 'Add Logout', 'icon': 'add' } } };
  //           break;
  //       }
  //     }
  //   })
  //   return menu;
  // }

  initTree(treedata) {
    try {
      $(':ui-fancytree').fancytree('destroy');
      const $$: any = $;
      const _self = this;
      _self.ftree = $(this.getTreeSelector()).fancytree({
        treeId: '1',
        source: treedata,
        minExpandLevel: 2,
        extensions: ['edit', 'dnd5', 'table', 'gridnav', 'contextMenu', 'filter', 'multi'],
        tooltip: true,
        glyph: {
          preset: 'awesome4',
          map: {}
        },
        multi: {
          mode: 'sameParent'
        },
        beforeActivate: function (e, data) {
          const activeElement = document.activeElement as HTMLElement;
          if (
            activeElement &&
            ['INPUT', 'TEXTAREA'].includes(activeElement.tagName) &&
            activeElement.closest('.properties-pane')
          ) {
            activeElement.blur();
          }
          return true;
        },
        activate: function (e, data) {
          const node = data.node;
          // since multiple node selection is possible, while activation the propeties has to be reset else there will be incorrect data at the properties level
          _self.resetProperties();
        },
        filter: {
          autoApply: true, // Re-apply last filter if lazy data is loaded
          autoExpand: true, // Expand all branches that contain matches while filtered
          counter: true, // Show a badge with number of matching child nodes near parent icons
          fuzzy: false, // Match single characters in order, e.g. 'fb' will match 'FooBar'
          hideExpandedCounter: false, // Hide counter badge if parent is expanded
          hideExpanders: false, // Hide expanders if all child nodes are hidden by filter
          highlight: true, // Highlight matches by wrapping inside <mark> tags
          leavesOnly: false, // Match end nodes only
          nodata: true, // Display a 'no data' status node if result is empty
          mode: 'dimm' // Grayout unmatched nodes (pass "hide" to remove unmatched node instead)
        },
        contextMenu: {
          menu: (node) => {
            // Hide context menu when opened from modernize popup for list pages only
            // Exception: allow delete for gridColumn nodes
            if (_self.isFromModernize && _self.currentSelectedItem?.pageType === 'list') {
              if (node.type?.toLowerCase() === 'gridcolumn') {
                return contextMenuItems.delete;
              }
              return {};
            }
            // Hide context menu entirely when modernize step is COMPLETED or IN_PROGRESS
            if (_self.isFromModernize && (_self.modernizeReadOnly || _self._modernizeStepStatus === 'IN_PROGRESS')) {
              return {};
            }
            let menu;
            if (!_self.disallowEdit) {
              switch (node.type.toLowerCase()) {
                case 'leftmenu': {
                  if (_self.isFromModernize) {
                    const { addmenuitems, addimportmenuitem, ...rest } = contextMenuItems.leftmenu;
                    menu = rest;
                  } else {
                    menu = contextMenuItems.leftmenu;
                  }
                  break;
                }
                case 'appheader': {
                  if (!_self.isFromModernize) {
                    menu = contextMenuItems.appHeader;
                  }
                  break;
                }
                case 'leftpane':
                case 'middlepane':
                case 'rightpane':
                  menu = contextMenuItems[node.type.toLowerCase()];
                  if (!this.searchInPane('language')) {
                    menu = { ...menu, addlangdrop: { name: 'Add Language', icon: 'add' } };
                  }
                  break;
                case 'rightmenu': {
                  menu = contextMenuItems.rightpane;
                  break;
                }
                case 'lefthamburgermenu': {
                  menu = contextMenuItems.rightpane;
                  break;
                }
                case 'menugroup': {
                  if (node.children) {
                    for (const child of node.children) {
                      if (child.type.toLowerCase() === 'menuitem' || child.type.toLowerCase() === 'menu_item') {
                        menu = { ...contextMenuItems.menugroupwithmenu };
                        break;
                      }
                    }
                  }
                  if (isEmpty(menu)) {
                    menu = { ...contextMenuItems.menugroup };
                  }
                  if (node?.data?.sysGen && menu?.adddelete) {
                    menu.adddelete.disabled = true;
                  } else {
                    menu.adddelete.disabled = false;
                  }

                  // Restrict creation of a third level menu group
                  if (!_self.canHaveMenuGroup(node)) {
                    delete menu.addmenugroup;
                  }

                  // Hide tab-related items for appNavigation pages
                  if (_self.currentSelectedItem?.pageType === 'appNavigation') {
                    delete menu.addtabgroup;
                    delete menu.addchildtabitem;
                    delete menu.addtabitems;
                    delete menu.addtabgroupabove;
                    delete menu.addtabgroupafter;
                    // Clean up orphaned separators
                    if (menu.sep1 && !menu.addtabgroup && !menu.addchildtabitem && !menu.addtabitems) {
                      delete menu.sep1;
                    }
                  }
                  break;
                }
                case 'menuitem': {
                  menu = contextMenuItems.menuitem;
                  if (node?.data?.sysGen && menu.adddelete) {
                    menu.adddelete.disabled = true;
                  } else {
                    menu.adddelete.disabled = false;
                  }
                  break;
                }
                case 'tabgroup': {
                  // Hide tab context menus for appNavigation pages
                  if (_self.currentSelectedItem?.pageType === 'appNavigation') {
                    break;
                  }
                  const parentNode = node.parent;
                  if (
                    parentNode.type.toLowerCase() === 'tabgroup' &&
                    parentNode.parent &&
                    parentNode.parent.type.toLowerCase() === 'tabgroup'
                  ) {
                    menu = contextMenuItems.tabgroup;
                  } else {
                    menu = contextMenuItems.tabgroupnested;
                  }
                  break;
                }
                case 'tabitem': {
                  // Hide tab context menus for appNavigation pages
                  if (_self.currentSelectedItem?.pageType === 'appNavigation') {
                    break;
                  }
                  menu = contextMenuItems.tabitem;
                  break;
                }
                case 'user': {
                  menu = contextMenuItems.user;
                  if (node.children === null || node.children.filter((x) => x.type === 'logout').length === 0) {
                    menu = { ...menu, addLogout: { name: 'Add Logout', icon: 'add' } };
                  }
                  break;
                }
                case 'page': {
                  if (
                    this.currentSelectedItem?.pageType === 'detail' ||
                    this.currentSelectedItem?.pageType === 'list'
                  ) {
                    menu = contextMenuItems?.page;
                  }
                  break;
                }
                case 'grid': {
                  menu = contextMenuItems.grid;
                  break;
                }
                case 'actionbar': {
                  menu = contextMenuItems.actionbar;
                  break;
                }

                case 'leftactionbar': {
                  menu = contextMenuItems.leftactionbar;
                  break;
                }

                case 'rightactionbar': {
                  menu = contextMenuItems.rightactionbar;
                  break;
                }

                case 'buttongroup': {
                  //E20PS-1269
                  const childNodes = node.children;
                  const pNode = node.parent;
                  if (
                    childNodes?.find(
                      (n) =>
                        n.key === 'workflowHistoryBtn' ||
                        n.key === 'workflowTimelineBtn' ||
                        n.key === 'workflowInstanceBtn'
                    )
                  ) {
                    menu = contextMenuItems.restrictedbuttongroup;
                  }
                  //E20PS-2498
                  else if (pNode?.key === 'workflowActionBar') {
                    menu = null;
                  } else {
                    menu = contextMenuItems.buttongroup;
                  }
                  break;
                }

                case 'dropdownbutton': {
                  menu = contextMenuItems.dropdownbutton;
                  break;
                }

                case 'captionbar': {
                  menu = contextMenuItems.captionbar;
                  break;
                }
                case 'form': {

                  if (this.isFromModernize) {
                    const fullMenu = contextMenuItems.form;
                    menu = {
                      addformfields: fullMenu.addformfields,
                      addformsection: fullMenu.addformsection,
                      addformtab: fullMenu.addformtab,
                      adddatagrid: fullMenu.adddatagrid,
                      addstandardgrid: fullMenu.addstandardgrid,
                      addcustombuttons: fullMenu.addcustombuttons
                    };
                  } else {
                    menu = contextMenuItems.form;
                  }

                  break;
                }
                case 'formfield': {
                  menu = contextMenuItems.formfield;
                  break;
                }
                case 'tabview': {
                  menu = contextMenuItems.tabview;
                  break;
                }
                case 'tab': {
                  if (this.isFromModernize) {
                    const fullMenu = contextMenuItems.tab;
                    menu = {
                      addformfields: fullMenu.addformfields,
                      addformsection: fullMenu.addformsection,
                      addformtab: fullMenu.addformtab,
                      adddatagrid: fullMenu.adddatagrid,
                      addstandardgrid: fullMenu.addstandardgrid,
                      addcustombuttons: fullMenu.addcustombuttons,
                      delete: fullMenu.delete
                    };
                  } else {
                    menu = contextMenuItems.tab;
                  }
                  break;
                }
                case 'formsection': {
                  if (this.isFromModernize) {
                    const fullMenu = contextMenuItems.formsection;
                    menu = {
                      addformfields: fullMenu.addformfields,
                      addformsection: fullMenu.addformsection,
                      addformtab: fullMenu.addformtab,
                      sep1: fullMenu.sep1,
                      adddatagrid: fullMenu.adddatagrid,
                      addstandardgrid: fullMenu.addstandardgrid,
                      addcustombuttons: fullMenu.addcustombuttons
                    };
                  } else {
                    menu = contextMenuItems.formsection;
                  }
                  break;
                }
                case 'gridcolumn':
                case 'captionitem': {
                  menu = contextMenuItems.delete;
                  break;
                }
                case 'button': {
                  //E20PS-1269
                  if (
                    node.key !== 'workflowHistoryBtn' &&
                    node.parent?.key !== 'workflowActionBar' &&
                    node.parent?.parent?.key !== 'workflowActionBar'
                  ) {
                    menu = contextMenuItems.delete;
                  }
                  if (node.key === 'workflowTimelineBtn' || node.key === 'workflowInstanceBtn') {
                    menu = contextMenuItems.delete;
                    menu.delete.disabled = true;
                  } else {
                    menu.delete.disabled = false;
                  }
                  break;
                }
                case 'tablesearch': {
                  menu = contextMenuItems.tablesearch;
                  break;
                }
                case 'searchfield': {
                  menu = contextMenuItems.searchfilter;
                  break;
                }
                case 'quickfilter': {
                  menu = contextMenuItems.quickfilter;
                  break;
                }
                case 'filtersandsearch': {
                  menu = contextMenuItems.filtersandsearch;
                  break;
                }
                case 'homepage': {
                  menu = contextMenuItems.homepage;
                  break;
                }
                case 'hometile': {
                  menu = contextMenuItems.delete;
                  break;
                }
                case 'childlist':
                case 'queryview':
                case 'standarddatagrid': {
                  menu = contextMenuItems.delete;
                  break;
                }
                case 'htmlcontainer': {
                  menu = contextMenuItems.htmlcontainer;
                  break;
                }
                case 'inlinetext': {
                  menu = contextMenuItems.inlinetext;
                  break;
                }
                case 'custombutton': {
                  menu = contextMenuItems.delete;
                  break;
                }
                case 'customcomp':
                case 'customcomponent': {
                  menu = contextMenuItems.customcomponent;
                  break;
                }
                case 'breadcrumb': {
                  menu = contextMenuItems.breadcrumb;
                  break;
                }
                case 'pagetitle': {
                  menu = contextMenuItems.pagetitle;
                  break;
                }
                case 'workflowactionbar': {
                  menu = contextMenuItems.workflowactionbar;
                  break;
                }
                case 'totalrecordscount': {
                  menu = contextMenuItems.totalrecordscount;
                  break;
                }
                case 'filterfield': {
                  if (
                    !(
                      this.currentSelectedItem?.pageTableType === pageTableType.QUERY_VIEW &&
                      this.queryTblProps?.t_mandatory_filters?.includes(node?.key)
                    ) &&
                    !node?.data?.properties.fromDefaultFilter
                  ) {
                    menu = contextMenuItems.delete;
                  }
                  break;
                }
                case 'navigationtabs': {
                  // Hide navigation tab items for appNavigation pages
                  if (_self.currentSelectedItem?.pageType === 'appNavigation') {
                    break;
                  }
                  menu = contextMenuItems.navigationtabs;
                  break;
                }
                case 'language': {
                  menu = contextMenuItems.delete;
                  break;
                }
                case 'logout': {
                  menu = contextMenuItems.delete;
                  break;
                }
                case 'usermenu': {
                  menu = contextMenuItems.usermenu;
                  break;
                }
                // ========================================
                // NEW ANGULAR 21 APP NAVIGATION TYPES
                // ========================================
                case 'app_navigation': {
                  menu = contextMenuItems.app_navigation;
                  break;
                }
                case 'app_menu': {
                  // Main menu container - same functionality as leftmenu
                  menu = contextMenuItems.app_menu;
                  break;
                }
                case 'menu_item': {
                  // Menu item - same as old menuitem
                  menu = contextMenuItems.menu_item;
                  if (node?.data?.sysGen && menu.adddelete) {
                    menu.adddelete.disabled = true;
                  } else {
                    menu.adddelete.disabled = false;
                  }
                  break;
                }
                case 'menu_group': {
                  // Menu group - same logic as old menugroup
                  if (node.children) {
                    for (const child of node.children) {
                      if (child.type.toLowerCase() === 'menu_item') {
                        menu = { ...contextMenuItems.menu_group_with_menu };
                        break;
                      }
                    }
                  }
                  if (isEmpty(menu)) {
                    menu = { ...contextMenuItems.menu_group };
                  }
                  if (node?.data?.sysGen && menu?.adddelete) {
                    menu.adddelete.disabled = true;
                  } else {
                    menu.adddelete.disabled = false;
                  }
                  // Restrict creation of a third level menu group
                  if (!_self.canHaveMenuGroup(node)) {
                    delete menu.addmenugroup;
                  }
                  break;
                }
                case 'user_menu_group': {
                  // User menu group - can add child menus
                  menu = { ...contextMenuItems.user_menu_group };
                  // Add "Add Language" option if language is not already in children
                  if (!node.children?.find((child) => child.type?.toLowerCase() === 'language')) {
                    menu = { ...menu, addlangdrop: { name: 'Add Language', icon: 'add' } };
                  }
                  break;
                }
                case 'user_settings': {
                  // User settings container (Angular 21) - can add logout if not present
                  menu = { ...contextMenuItems.user_settings };
                  // Add "Add Logout" option if logout is not already in children
                  if (!node.children?.find((child) => child.type?.toLowerCase() === 'logout')) {
                    menu = { ...menu, addlogout: { name: 'Add Logout', icon: 'add' } };
                  }
                  break;
                }
                case 'user_menu': {
                  // User menu - same as old usermenu
                  menu = contextMenuItems.user_menu;
                  break;
                }
                case 'pageview': {
                  menu = contextMenuItems.pageview;
                  break;
                }
                case 'titlebar': {
                  menu = contextMenuItems.titlebar;
                  break;
                }
                default:
              }
            }
            // menu["delete"] = { name: "Delete", icon: "delete", disabled: false };
            if (!menu || Object.keys(menu).length === 0) {
              return false;
            }
            return menu;
          },
          actions: (node, action, options) => {
            // console.log(node, action, options);
            _self.createNode(node, action, options, false);
          }
        },
        edit: {
          triggerStart: ['dblclick', 'f2', 'mac+enter'],
          beforeEdit: (event: any, data: any) => {
            // Return false to prevent edit mode
            const rejectedTypes = [
              'gridColumn',
              'formField',
              'pageView',
              'titleBar',
              'actionBar',
              'tableSearch',
              'quickFilter',
              'grid',
              'form',
              'leftMenu',
              'APP_MENU',
              'appHeader',
              'APP_MENU_HEADER',
              'logo',
              'APP_LOGO',
              'appTitle',
              'APP_NAME',
              'leftPane',
              'middlePane',
              'rightPane',
              'user',
              'USER_SETTINGS',
              'USER_INFO',
              'USER_MENU_GROUP',
              'rightMenu',
              'homePage',
              'breadCrumb',
              'searchField',
              'filterField',
              'captionBar',
              'captionItem',
              'APP_NAVIGATION'
            ];
            const nType = data.node.type;
            const pNode = data.node.parent;
            if (
              rejectedTypes.includes(nType) ||
              _self.disallowEdit ||
              !nType ||
              (nType === 'button' &&
                (data.node.key === 'workflowHistoryBtn' ||
                  data.node.key === 'workflowTimelineBtn' ||
                  data.node.key === 'workflowInstanceBtn' ||
                  pNode?.key === 'workflowActionBar' ||
                  pNode?.parent?.key === 'workflowActionBar'))
            ) {
              return false;
            } //E20PS-2498
            return true;
          },
          edit: (event: any, data: any) => {
            // Editor was opened (available as data.input)
          },
          beforeClose: (event: any, data: any) => {
            // Return false to prevent cancel/save (data.input is available)
            //console.log(event.type, event, data);
            if ($(this.getTreeSelector()).length === 0) {
              return true;
            }
            if ($('.fancytree-edit-input').length === 0) {
              return true;
            }
            if (!data.isNew && !data.save && !data.dirty) {
              return true;
            }
            const nodeTitle = $(data.input).val();
            if (!nodeTitle) {
              return true;
            }
            if (!data.originalEvent) {
              return false;
            }
            // Check if click originated from toast close button (prevent re-validation on toast close)
            const eventTarget = data.originalEvent.target;
            if (eventTarget) {
              const isToastClose =
                eventTarget.classList.contains('p-toast-icon-close-icon') ||
                eventTarget.classList.contains('p-toast-icon-close') ||
                eventTarget.classList.contains('pi-times') ||
                eventTarget.closest('.p-toast-icon-close') ||
                eventTarget.closest('.p-toast');
              if (isToastClose) {
                return false;
              }
            }
            const rename = !data.isNew && data.save;
            let oldTitleToCheck = '';
            if (rename) {
              oldTitleToCheck = data.orgTitle.toLowerCase();
              oldTitleToCheck = this.removeExtraWhiteSpace(oldTitleToCheck);
            }

            const title: any = $(data.input).val();
            let titleToCheck = title.toLowerCase();
            titleToCheck = this.removeExtraWhiteSpace(titleToCheck);
            if (data.originalEvent?.type === 'blur') {
              data.originalEvent.preventDefault();
              return false;
            }
            if (data.originalEvent?.type === 'keydown') {
              if (data.originalEvent?.keyCode === '27') {
                return true;
              }
            }
            if (!title) {
              return true;
            }
            const myRe = /^[a-zA-Z]+[a-zA-Z0-9_\s]*[a-zA-Z0-9_]*$/g; // NOSONAR
            const array = myRe.exec(title);
            if (!array) {
              const nodeTypeLabel = startCase(camelCase(data.node.type || 'Item'));
              _self.zone.run(() => {
                _self.showMessage('error', _self.translate.instant('INVALID_NODE_NAME', { nodeType: nodeTypeLabel }));
              });
              //data.node.setTitle('');
              data.originalEvent.preventDefault();
              //data.save = false;
              return false;
            }

            if (data.node.type === 'tabView') {
              if (this.tabViewTitles.includes(titleToCheck) && titleToCheck !== oldTitleToCheck) {
                this.zone.run(() => {
                  this.showMessage('error', _self.translate.instant('DUPLICATE_TABVIEWNAME'));
                });
                data.originalEvent.preventDefault();
                return false;
              }

              if (rename && oldTitleToCheck && oldTitleToCheck !== titleToCheck) {
                const oldIndex = this.tabViewTitles.indexOf(oldTitleToCheck);
                if (oldIndex > -1) {
                  this.tabViewTitles.splice(oldIndex, 1);
                }

                if (this.tabTitles[oldTitleToCheck]) {
                  this.tabTitles[titleToCheck] = this.tabTitles[oldTitleToCheck];
                  delete this.tabTitles[oldTitleToCheck];
                }
              }

              if (!this.tabViewTitles.includes(titleToCheck)) {
                this.tabViewTitles.push(titleToCheck);
              }

              if (!this.tabTitles[titleToCheck]) {
                this.tabTitles[titleToCheck] = ['tab 1', 'tab 2'];
              }
            }

            if (data.node.type === 'tab') {
              const parentNode = this.getParentTabView(data.node).title.toLowerCase();
              const tabFields = this.tabTitles[parentNode];
              if (tabFields && tabFields.includes(titleToCheck)) {
                this.zone.run(() => {
                  this.showMessage('error', this.translate.instant('DUPLICATE_TABNAME'));
                });
                data.originalEvent.preventDefault();
                return false;
              }
              if (tabFields) {
                if (rename && tabFields.includes(oldTitleToCheck)) {
                  const i = this.tabTitles[parentNode].indexOf(oldTitleToCheck);
                  this.tabTitles[parentNode][i] = titleToCheck;
                } else {
                  this.tabTitles[parentNode].push(titleToCheck);
                }
              } else {
                this.tabTitles[parentNode] = [titleToCheck];
              }
            }

            $(data.input).off('keydown'); //To avoid memory leak
            return true;
          },
          save: function (event: any, data: any) {
            // Save data.input.val() or return false to keep editor open
            //console.log("save...", this, data);
            setTimeout(function () {
              data.node.setTitle(data.node.title);
              data.node.data.properties = { ...data.node.data.properties, ...{ label: data.node.title } };
              // Auto-generate Html Properties (identifier and styleClass) from label when label is entered/changed
              _self.updateHtmlPropsFromLabel(data.node);

              // When TabView is named, update child tab identifiers with parent TabView name as prefix
              const type = data?.node?.type?.toLowerCase();
              if (type === 'tabview') {
                _self.updateTabViewChildIdentifiers(data.node);
              }

              const node = data?.node;
              if (
                type === 'buttongroup' ||
                type === 'button' ||
                type === 'formsection' ||
                type === 'tab' ||
                type === 'tabview' ||
                type === 'menugroup' ||
                type === 'menu_group' ||
                type === 'menuitem' ||
                type === 'menu_item' ||
                type === 'tabgroup' ||
                type === 'tabitem' ||
                type === 'hometile' ||
                type === 'custombutton' ||
                type === 'navigationtabs'
              ) {
                if (data.isNew) {
                  _self.pageSection.createdPageSectionMap = {
                    ..._self.pageSection.createdPageSectionMap,
                    ...{ [node.data.id]: data.node.title }
                  };
                  if (type === 'tabview') {
                    _self.pageSection.createdPageSectionMap = {
                      ..._self.pageSection.createdPageSectionMap,
                      ...{ [_self.tabId1]: 'Tab 1' },
                      ...{ [_self.tabId2]: 'Tab 2' }
                    };
                  }
                } else {
                  _self.pageSection.updatedPageSectionMap = {
                    ..._self.pageSection.updatedPageSectionMap,
                    ...{ [node.data.id]: data.node.title }
                  };
                }
              }
              _self.saveFancyTree('tree save');
              _self.debounceSaveTree('tree save');
            }, 100);
            // We return true, so ext-edit will set the current user input
            // as title

            _self.rearrageTreeLegIndicator(50);
            return true;
          },
          close: function (event: any, data: any) {
            // Editor was removed
            if (data.save && data.isNew) {
              // Since we started an async request, mark the node as preliminary
              $(data.node.span).addClass('pending');
              let command = 'addChildField';
              switch (data.node.type.toLowerCase()) {
                case 'menuitem':
                case 'menu_item':
                  command = 'addMenuitem';
                  break;
                case 'tabitem':
                  command = 'addtabitem';
                  break;
                case 'menugroup':
                case 'menu_group':
                  command = 'addmenugroupafter';
                  break;
                case 'tabgroup':
                  command = 'addtabgroupafter';
                  break;
                case 'gridcolumn':
                  command = 'addtablecolumns';
                  break;
                case 'button':
                  command = 'addbuttons';
                  break;
                case 'custombutton':
                  command = 'addcustombuttons';
                  break;
                case 'captionitem':
                  command = 'addcaptions';
                  break;
                case 'addformfields':
                  command = 'addformfields';
                  break;
                case 'formsection':
                  command = 'addformsection';
                  break;
                case 'tabView':
                  command = 'addformtab';
                  break;
                case 'tab':
                  command = 'addtabs';
                  break;
                case 'hometile':
                  command = 'addtiles';
                  break;
                default:
                  break;
              }
              setTimeout(function () {
                const node: any = data.isNew ? data.node.parent : data.node;
                const $tdList = $(node.tr).find('>td');

                const childs = node.children || [];
                const levelClassc = `level${node.getLevel()}`;
                let nodeVerticalBarHeight = 36 * (childs.length - 1) - 12; //+ 13 + 20;

                if (node.isFolder()) {
                  const verticalLine = $('<div>')
                    .addClass(`vertical-line ${levelClassc}`)
                    .css({
                      height: `${nodeVerticalBarHeight}px`
                    });

                  if (!node.isExpanded()) {
                    verticalLine.hide();
                  }

                  $($tdList[1]).append(verticalLine);

                  if (levelClassc !== 'level1') {
                    const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
                    $($tdList[1]).append(horizondalLine);
                  }
                } else {
                  if (node.children) {
                    nodeVerticalBarHeight = node.children.length * 36 - 12;
                    const verticalLine = $('<div>')
                      .addClass(`vertical-line ${levelClassc}`)
                      .css({
                        height: `${nodeVerticalBarHeight}px`
                      });
                    if (!node.isExpanded()) {
                      verticalLine.hide();
                    }
                    $($tdList[1]).append(verticalLine);
                  }

                  const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
                  $($tdList[1]).append(horizondalLine);
                }

                $(data.node.span).trigger('nodeCommand', {
                  cmd: command,
                  data: data,
                  event: event
                });
              }, 100);
            }
          }
        },
        dnd5: {
          // autoExpandMS: 400,
          // preventForeignNodes: true,
          preventNonNodes: true,
          preventRecursion: true, // Prevent dropping nodes on own descendants
          // preventSameParent: true,
          preventVoidMoves: true, // Prevent moving nodes 'before self', etc.
          //effectAllowed: "all",
          // dropEffectDefault: "move", // "auto",
          scroll: true,
          multiSource: true,

          // --- Drag-support:

          dragStart: (node, data: any) => {
            // Disable drag-and-drop in modernize (screen interim) mode
            if (_self.isFromModernize) {
              return false;
            }
            /* This function MUST be defined to enable dragging for the tree.
             *
             * Return false to cancel dragging of node.
             * data.dataTransfer.setData() and .setDragImage() is available
             * here.
             */
            node.debug(
              `T1: dragStart: ` +
              `data: ${data.dropEffect}/${data.effectAllowed}, dataTransfer: ${data.dataTransfer.dropEffect}/${data.dataTransfer.effectAllowed
              }`
            );

            // Set the allowed effects (i.e. override the 'effectAllowed' option)
            data.effectAllowed = 'all';
            // console.log('dragStart--data', data);
            // console.log('dragStart--node', node);
            // Set a drop effect (i.e. override the 'dropEffectDefault' option)
            // data.dropEffect = "link";
            data.dropEffect = 'move';

            return true;
          },

          dragEnter: (node, data) => {
            console.log('dragEnter--data', data);
            node.debug(
              `T1: dragEnter: ` +
              `data: ${data.dropEffect}/${data.effectAllowed}, dataTransfer: ${data.dataTransfer.dropEffect}/${data.dataTransfer.effectAllowed
              }`
            );
            // console.log('dragEnter--data', data);
            // console.log('dragEnter--node', node);
            // data.dropEffect = "copy";
            return true;
          },
          dragOver: (node, data) => {
            console.log('dragOver--data', data);
            /*logLazy("dragOver", null, 2000,
              "T1: dragOver: " + "data: " + data.dropEffect + "/" + data.effectAllowed +
              ", dataTransfer: " + data.dataTransfer.dropEffect + "/" + data.dataTransfer.effectAllowed);*/
            // console.log('dragOver--data', data);
            // console.log('dragOver--node', node);
            // Assume typical mapping for modifier keys
            data.dropEffect = data.dropEffectSuggested;
            // data.dropEffect = "move";
          },
          dragDrop: (node, data) => {
            console.log('dragDrop--data', data);
            const sourceNodes = data.otherNodeList;
            $.each(sourceNodes, function (i, o) {
              o.info(`move to ${node}: ${data.hitMode}`);
              if (_self.isAllowedDrops(node, data) && !o?.data?.sysGen) {
                o.moveTo(node, data.hitMode);
              }
            });
            _self.saveFancyTree('Drag Drop');
            _self.debounceSaveTree('Drag Drop');

            /* if (this.isAllowedDrops(node, data)) {
              data.otherNode.moveTo(node, data.hitMode);
              _self.saveFancyTree(data);
              _self.debounceSaveTree('Drag Drop');
            } */
            return false;
          }
        },
        table: {
          indentation: 40,
          nodeColumnIdx: 1,
          checkboxColumnIdx: 0
        },
        gridnav: {
          autofocusInput: false,
          handleCursorKeys: true
        },
        renderTitle: (event, data) => {
          const node: any = data.node;
          const nodeType: string = node?.type?.toLowerCase();
          /* Display the title based on the field id */
          /* for queryview, child table, standard data grid, the value will be in id because same instance can be present in tree where node.key is unique*/
          const _id =
            nodeType === 'childlist' || nodeType === 'queryview' || nodeType === 'standarddatagrid'
              ? data.node?.data?.id
              : data?.node?.key;
          if (
            _id &&
            this.fieldIdMap &&
            (nodeType === 'formfield' ||
              nodeType === 'gridcolumn' ||
              nodeType === 'captionitem' ||
              nodeType === 'searchfield' ||
              nodeType === 'filterfield' ||
              nodeType === 'childlist' ||
              nodeType === 'queryview' ||
              nodeType === 'standarddatagrid')
          ) {
            const title = this.fieldIdMap[_id] ? this.fieldIdMap[_id] : this.foreignKeyMap[_id];
            if (title) {
              data.node.title = title;

              // Update HTML properties (elementId) when field/action is renamed
              // Only for field-based nodes and workflow action buttons
              if (
                nodeType === 'formfield' ||
                nodeType === 'gridcolumn' ||
                nodeType === 'searchfield' ||
                nodeType === 'filterfield' ||
                nodeType === 'captionitem'
              ) {
                const currentNodes = this.getCurrentTreeNodes();
                const wasUpdated = this.identifierService.updateHtmlPropsOnFieldRename(
                  data.node as unknown as ScreenNode,
                  title,
                  currentNodes
                );
                // If properties were updated, trigger debounced save
                if (wasUpdated) {
                  this.debounceSaveTree('fieldRenameUpdate');
                }
              }
            }
          }
        },
        createNode: function (event, data) {
          const node: any = data.node;
          const $tdList = $(node.tr).find('>td');
          let nodeType: string = node?.type?.toLowerCase();
          const formattedType = startCase(camelCase(node?.type || ''));
          const _nodeType: string = formattedType === 'Child List' ? 'Child Datagrid' : formattedType;
          const id = node.data.id;
          let shouldHideContextMenu = false;
          const childs = node.children || [];
          const levelClassc = `level${node.getLevel()}`;
          let nodeVerticalBarHeight = 36 * (childs.length - 1) - 12; //+ 13 + 20;
          const noContextmenuNodes: string[] = [
            'App Logo',
            'App Name',
            'Detail View',
            'Title Bar',
            'Bread Crumb',
            'Workflow Action Bar',
            'List View'
          ];
          const noContextmenuTypes: string[] = [
            'filtersandsearch',
            'pagetitle',
            'app_navigation',
            'appheader',
            'app_menu_header',
            'user_info',
            'breadcrumb',
            'workflowactionbar',
            'totalrecordscount'
          ];
          shouldHideContextMenu = noContextmenuNodes.includes(node.title);
          if (!shouldHideContextMenu && noContextmenuTypes.includes(node.type?.toLowerCase())) {
            shouldHideContextMenu = true;
          }
          if (!shouldHideContextMenu && node.type?.toLowerCase() === 'user_settings') {
            const hasLogout = node.children?.find((child: any) => child.type?.toLowerCase() === 'logout');
            if (hasLogout) {
              shouldHideContextMenu = true;
            }
          }
          if (_self.isFromModernize && _self.currentSelectedItem?.pageType === 'list') {
            shouldHideContextMenu = node.type?.toLowerCase() !== 'gridcolumn';
          }
          if (_self.isFromModernize && (_self.modernizeReadOnly || _self._modernizeStepStatus === 'IN_PROGRESS')) {
            shouldHideContextMenu = true;
          }
          const hasContextMenuItems = _self.hasContextMenuItems(node);
          let hideContextMenu = shouldHideContextMenu || !hasContextMenuItems;
          if ((nodeType = 'filterfield')) {
            if (node?.data?.properties?.addedFromDefaultFilter) {
              shouldHideContextMenu = true;
              hideContextMenu = true;
            }
          }
          if (node.isFolder()) {
            const verticalLine = $('<div>')
              .addClass(`vertical-line ${levelClassc}`)
              .css({
                height: `${nodeVerticalBarHeight}px`
              });
            if (!node.isExpanded()) {
              verticalLine.hide();
            }
            $($tdList[1]).append(verticalLine);
            if (levelClassc !== 'level1') {
              const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
              $($tdList[1]).append(horizondalLine);
            }
            $tdList.eq(1).prop('colspan', 1).addClass(`screens-editable-cell`);
            $tdList
              .eq(2)
              .prop('colspan', 1)
              //.html('<i class="fa fa-th gridster-trigger" aria-hidden="true"></i>')
              .html(`<span id=${id} class="col-type">${_nodeType}</span>`)
              .addClass('col-type');
            $tdList
              .eq(3)
              .html(
                `<div class="dropdown contextMenu ${hideContextMenu ? 'd-none' : ''}">
                      <p-button icon="pi pi-ellipsis-v" type="button" class="p-element btn dropdown-toggle toggle-button context-menu-trigger-btn">
                        <button pripple="" class="p-ripple p-element p-button p-component p-button-icon-only" type="button">
                          <span class="pi pi-ellipsis-v p-button-icon ng-star-inserted" aria-hidden="true"></span>
                        </button>
                      </p-button>
                    </div>`
              )
              .addClass('context-menu-td')
              .toggleClass('has-context-items', !hideContextMenu);
            /*
            .nextAll()
            .remove();*/
          } else {
            if (node.children) {
              console.log('node.children');
              console.log(node.children);
              nodeVerticalBarHeight = node.children.length * 36 - 12;
              const verticalLine = $('<div>')
                .addClass(`vertical-line ${levelClassc}`)
                .css({
                  height: `${nodeVerticalBarHeight}px`
                });
              if (!node.isExpanded()) {
                verticalLine.hide();
              }
              $($tdList[1]).append(verticalLine);
            }
            if (node && node.data && Object.keys(node.data).length > 0) {
              const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
              $($tdList[1]).append(horizondalLine);
            }
            if (_nodeType) {
              $tdList
                .eq(2)
                .prop('colspan', 1)
                .addClass('col-type')
                .html(`<span id=${id} class="col-type">${_nodeType}</span>`);
              $tdList
                .eq(3)
                .html(
                  `<div class="dropdown contextMenu ${hideContextMenu ? 'd-none' : ''}">
                <p-button  icon="pi pi-ellipsis-v" type="button" class="p-element btn dropdown-toggle toggle-button context-menu-trigger-btn">
                <button pripple="" class="p-ripple p-element p-button p-component p-button-icon-only" type="button">
                  <span class="pi pi-ellipsis-v p-button-icon ng-star-inserted" aria-hidden="true"></span>
                </button>
                </p-button>
                </div>`
                )
                .addClass('context-menu-td')
                .toggleClass('has-context-items', !hideContextMenu);
            } else {
              $tdList.eq(1).prop('colspan', 3).nextAll().remove();
            }
          }
          switch (nodeType) {
            case 'menuitem':
            case 'menu_item':
              node.icon = 'menu-item-icon';
              break;
            case 'tabitem':
              node.icon = 'tab-item-icon';
              break;
            case 'menugroup':
            case 'menu_group':
              node.icon = 'menu-group-icon';
              break;
            case 'tabgroup':
              node.icon = 'tab-group-icon';
              break;
            case 'leftmenu':
            case 'app_menu':
              node.icon = 'menu-icon';
              break;
            case 'rightmenu':
              node.icon = 'menu-icon';
              break;
            case 'appheader':
            case 'app_menu_header':
              node.icon = 'menu-icon';
              break;
            case 'gridcolumn':
              node.icon = 'fa pen-field ';
              break;
            case 'button':
            case 'customButton':
              node.icon = 'fa pen-field field-icon';
              break;
            case 'captionitem':
              node.icon = 'fa pen-field field-icon';
              break;
            case 'formfield':
              node.icon = 'fa pen-field field-icon';
              break;
            case 'formsection':
              node.icon = 'fa pen-field field-icon';
              break;
            case 'tabView':
              node.icon = 'tab-view-icon';
              break;
            case 'page':
              node.icon = 'page-icon';
              break;
            case 'pageview':
              node.icon = 'detail-view-icon';
              break;
            case 'titlebar':
              node.icon = 'title-bar-icon';
              break;
            case 'actionbar':
              node.icon = 'left-action-bar-icon';
              break;
            case 'form':
              node.icon = 'form-icon';
              break;
            case 'captionbar':
              node.icon = 'caption-bar-icon';
              break;
            default:
              break;
          }
          node.renderTitle();
        },
        renderColumns: function (event, data) {
          const node: any = data.node;
          const $tdList = $(node.tr).find('>td');
          const nodeType: string = node?.type?.toLowerCase();
          const $contextCell = $(node.tr).find('>td.context-menu-td');
          const $title = $(node.tr).find('.fancytree-title');
          $title.off('contextmenu.screensContextMenu');
          if (!$contextCell.hasClass('has-context-items')) {
            $title.on('contextmenu.screensContextMenu', (evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              return false;
            });
          }
          if (nodeType === 'childlist') {
            $(node.tr).addClass(nodeType);
          }
          $tdList.eq(3).off('click').on('click', '.context-menu-trigger-btn', _self.openContextMenu.bind(_self));
        },
        collapse: function (event, data) {
          // Update connector lines (FancyTree manages DOM)
          _self.rearrageTreeLegIndicator(50);
        },
        expand: function (event, data) {
          // Update connector lines
          _self.rearrageTreeLegIndicator(50);
        },
        modifyChild: function (event: any, data: any) {
          data.tree.info(event.type, data);
          _self.rearrageTreeLegIndicator(50);
        },
        click: (event: any, data: any) => {
          this.selectedNodeTitle =
            data && data.node && data.node.title && data.node.type
              ? `${startCase(camelCase(data.node.type)) /*(data.node.type =="TABLE"  ? "Table" : "Field" )*/
              }  Properties :  ${data.node.title}`
              : '';
          // this.selectedNodeTitle = data && data.node && data.node.title  ? " : " + data.node.title : '';
          const tree = $.ui.fancytree.getTree(this.getTreeSelector());
          const selectedNodes: any[] = tree.getSelectedNodes();
          if (event.originalEvent.ctrlKey || event.originalEvent.metaKey || event.originalEvent) {
            if (selectedNodes.length > 0) {
              this.previousType = selectedNodes[0].type;
            }
            if (this.previousType && this.previousType !== data.node.type) {
              data.tree.getSelectedNodes().forEach((n) => n.setSelected(false));
            }
          }
          const target = event.originalEvent?.target;

          const row$ = $(data.node.tr);

          if (data.targetType === 'expander') {
            if (data.node.isExpanded()) {
              row$.find('.vertical-line').hide();
            } else {
              row$.find('.vertical-line').show();
            }
            //_self.rearrageTreeLegIndicator(50);
          }

          // if ($(target).hasClass('fancytree-expander')) {
          //   return true;
          // }
          this.zone.run(() => {
            if ($(target).hasClass('gridster-trigger')) {
              this.triggerGridster(event, data);
            } else if (Object.keys(data?.node?.data).length || data.node.type) {
              // Skip re-loading properties if the same node is clicked again (avoids blocking double-click for rename)
              if (this.currentSelectedTreeNode === data.node && !this.isPendingSave) {
                return;
              }
              this.handleNodeClick(event, data);
            }
          });

          this.rearrageTreeLegIndicator();

          return true;
        },
        init: (event: any, data: any) => {
          //console.log('TREE Initialized');
          //this.isLoadingScreens = false;
        }
      });

      //$(".fancytree-container").addClass("fancytree-connectors");
      $(_self.ftree)
        .off('nodeCommand')
        .on('nodeCommand', function (event, data) {
          // console.log(data);
          const node = data.data.node;
          _self.createNode(node, data.cmd, data.data.options, true);
        });

      /* $(_self.ftree).off("mousedown").on("mousedown", ".fancytree-title", (event, data) => {
        var node = data.data.node;
      }); */

      _self.rearrageTreeLegIndicator(50);
    } catch (error) {
      console.log(error);
    }
  }

  triggerGridster(event: any, data: any) {
    if (!data?.node?.children) {
      return;
    }
    const children = data.node.children;
    const nodesToSend: any[] = [];
    children.map((child: any) => {
      nodesToSend.push({
        label: child.title,
        id: child.key
      });
    });
    //setTimeout(() => {
    this.layoutdata = {
      containerName: 'tableName',
      items: nodesToSend
    };
    //}, 1000);
    this.zone.run(() => {
      this.showLayoutBuilder = true;
    });
  }

  handleCSSChangeFromGridster(event: any) {
    // console.log('STYLES : ', event);
    this.showLayoutBuilder = false;
  }

  tocamelCase(field: string) {
    /* First Name -> firstName  */
    return camelCase(field);
  }

  getLookupTemps(apiName, obj) {
    const promise = new Promise<void>((resolve, reject) => {
      const tempRef = this.bs.get(ApiConstants[apiName], obj).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (err: any) => {
          reject(err);
        },
        complete: () => {
          console.log('complete');
        }
      });
      this.addToSubscriptionsList(tempRef);
    });
    return promise;
  }

  triggerSaveFlds(nodeType, config, idsToAdd, fieldsToAdd) {
    const parNodes = ['grid', 'form', 'formSection', 'tab', 'searchField', 'quickFilter', 'tableSearch', 'captionBar'];
    if (nodeType === 'grid') {
      if (!config.tbl) {
        config.tbl = [];
      }
      config.tbl = [...new Set([...config.tbl, ...idsToAdd])];
    } else if (nodeType === 'form' || nodeType === 'formSection' || nodeType === 'tab') {
      if (!config.form) {
        config.form = [];
      }
      config.form = [...new Set([...config.form, ...idsToAdd])];
    } else if (nodeType === 'searchField') {
      if (!config.searchField) {
        config.searchField = [];
      }
      config.searchField = [...new Set([...config.searchField, ...idsToAdd])];
    } else if (nodeType === 'quickFilter') {
      if (!config.quickFilter) {
        config.quickFilter = [];
      }
      config.quickFilter = [...new Set([...config.quickFilter, ...idsToAdd])];
    } else if (nodeType === 'tableSearch') {
      if (!config.tableSearch) {
        config.tableSearch = [];
      }
      config.tableSearch = [...new Set([...config.tableSearch, ...idsToAdd])];
    } else if (nodeType === 'captionBar') {
      if (!config.captionBar) {
        config.captionBar = [];
      }
      config.captionBar = [...new Set([...config.captionBar, ...idsToAdd])];
    }
    const dataToSend = { ...this.curContextMenuNode?.configuredFields };
    dataToSend.config = JSON.stringify(config);
    dataToSend.tableId = this.currentSelectedItem.tableId;
    dataToSend.screenId = this.currentSelectedItem.sid;
    let fieldSids: any[] = [];
    const keys = Object.keys(config);
    keys.forEach((key) => {
      if (Array.isArray(config[key])) {
        fieldSids = [...fieldSids, ...config[key]];
      }
    });
    const uniqFldSids = uniq(fieldSids);
    // This condition is to avoid adding field as children except for grid/tableSearch/QuickFilter/CaptionBar/FormField
    // E20PS-2217 - was because of captionItem is added inside captionItem
    if (parNodes.includes(this.curContextMenuNode.node?.type)) {
      this.curContextMenuNode.node.addChildren(fieldsToAdd);
      this.screensResData = { ...this.screensResData, ...{ fieldIds: uniqFldSids } };
      this.dmConfig = dataToSend;
      this.isLoadingScreens = true;
      this.saveFancyTree('updateFieldsToTable');
      this.debounceSaveTree('updateFieldsToTable');
      this.showAddFieldsModal = false;
      this.fieldSearch = '';
      /* Re-load properties pane for the current node silently to avoid UI blinking */
      this.handleNodeClick(null, { node: this.curContextMenuNode.node }, true);
    }
  }

  updateFieldsToTable() {
    const nodeType = this.curContextMenuNode.node.type;
    const config = JSON.parse(this.curContextMenuNode?.configuredFields?.config || '{}');
    const idsToAdd: any[] = [];
    const fieldsToAdd: any[] = [];
    let type;
    switch (nodeType.toLowerCase()) {
      case 'form':
      case 'formsection':
      case 'tab':
        type = 'formField';
        break;
      case 'grid':
        type = 'gridColumn';
        break;
      case 'tablesearch':
        type = 'searchField';
        break;
      case 'quickfilter':
        type = 'filterField';
        break;
      case 'captionbar':
        type = 'captionItem';
        break;
      default:
        break;
    }
    //condition to check adv search and quick filter doesnot have fields
    let ids = this.allFields?.filter((fld) => fld.addedToTable && fld.temp_addedToTable)?.map((f) => f.sid);
    ids = [
      ...ids,
      ...(this.referredFields
        ?.flatMap((fk) => fk.children || [])
        ?.filter((fld) => fld?.data?.addedToTable && fld.data?.temp_addedToTable)
        ?.map((f) => f.data?.id) || [])
    ];
    if (type == 'filterField') {
      const flds = ids
        .filter((i) => config?.tableSearch?.includes(i))
        ?.map((f) => this.fieldIdMap[f])
        ?.join(',');
      if (flds.length) {
        const flds = ids
          .filter((i) => config?.tableSearch.includes(i))
          ?.map((f) => this.fieldIdMap[f])
          ?.join(',');
        this.showMessage('error', this.translate.instant('ADV_SRH_WARN')?.replace('{field}', flds));
        return;
      }
    } else if (type === 'searchField') {
      const flds = ids
        .filter((i) => config?.quickFilter?.includes(i))
        ?.map((f) => this.fieldIdMap[f])
        ?.join(',');
      if (flds.length) {
        this.showMessage('error', this.translate.instant('QUIK_FLT_WARN')?.replace('{field}', flds));
        return;
      }
    }
    let mandatoryFilters;
    if (type === 'filterField') {
      if (this.queryTblProps && this.queryTblProps.t_mandatory_filters) {
        mandatoryFilters = this.queryTblProps.t_mandatory_filters;
      }
    }
    //TODO: if the parent is a form field, then type should be formField
    const n =
      this.allFields.filter((fld) => fld.addedToTable && fld.temp_addedToTable).length +
      this.referredFields
        ?.flatMap((fk) => fk.children || [])
        ?.filter((fld) => fld?.data?.addedToTable && fld.data?.temp_addedToTable)?.length || 0;
    const allFieldsToProcess = [
      ...this.allFields.filter((af: any) => af.addedToTable && af.temp_addedToTable),
      ...(this.referredFields
        ?.flatMap((fk) => fk.children || [])
        ?.filter((fld) => fld?.data?.addedToTable && fld.data?.temp_addedToTable) || [])
    ];

    allFieldsToProcess.map((af: any) => {
      const fieldData = af.data || af; // Handle referred fields
      idsToAdd.push(fieldData.sid);
      const id = fieldData.sid;
      this.getDefaultValues(type);
      const fldName = fieldData.fkAliasName ? fieldData.fkAliasName : fieldData.name;
      const nodeObj = {
        title: fldName,
        type: type,
        key: fieldData.sid,
        id: id,
        data: {
          properties: {
            ...this.formDefaultValues,
            data: fldName,
            field: fieldData.fieldId || fieldData.field, // eg: firstName - It has to be alias name
            type: fieldData.f_hasFK && !fieldData?.fkId ? 'foreignkey' : undefined,
            mandatory: mandatoryFilters?.includes(fieldData.sid)
          }
        }
      };

      // when ES is enabled and referred fields are added - additionally properties are added
      if (fieldData && fieldData.sid.includes('_$_')) {
        nodeObj.data.properties = {
          ...nodeObj.data.properties,
          fkTableSid: fieldData.tableId || '',
          fkId:
            typeof fieldData.sid === 'string' && fieldData.sid.includes('_$_')
              ? fieldData.sid.split('_$_')[0]
              : fieldData.sid || '',
          fkAppId: fieldData.aid
        };
      }
      this.configureDisplayAs(nodeObj);
      // Assign identifier and styleClass to the node, passing parent for prefix determination
      const nodeWithIdentifier = this.assignHtmlPropsToNode(nodeObj, this.curContextMenuNode?.node);
      fieldsToAdd.push(nodeWithIdentifier);
      this.pageSection.createdPageSectionMap = { ...this.pageSection.createdPageSectionMap, ...{ [id]: fldName } };
      this.referencesTasks.addedReference.push(
        this.util.createReference(
          this.currentSelectedItem.sid,
          utilEnum.modelType.PAGE,
          nodeObj.key,
          utilEnum.modelType.FIELD,
          this.appId,
          this.screensReferenceService.getAdditionalPath(this.curContextMenuNode.node),
          this.screensReferenceService.getPropName(nodeType.toLowerCase()),
          false
        )
      );
      if (n == fieldsToAdd.length) {
        this.triggerSaveFlds(nodeType, config, idsToAdd, fieldsToAdd);
      }
    });
  }

  configureDisplayAs(nodeObj) {
    if ((nodeObj?.type == 'filterField' || nodeObj?.type == 'searchField') && !nodeObj?.data?.properties?.displayAs) {
      const fType =
        this.allFields.find((f) => f.sid == nodeObj.key)?.f_type.toLowerCase() ||
        this.referredFields
          ?.flatMap((fk) => fk.children || [])
          ?.find((fld) => fld?.data?.sid === nodeObj.key)
          ?.data?.f_type?.toLowerCase();
      switch (fType) {
        case 'string':
          nodeObj.data.properties.displayAs = 'string';
          break;
        case 'dropdown':
        case 'checkboxgroup':
        case 'radio':
          nodeObj.data.properties.displayAs = 'single dropdown';
          break;
        case 'date':
          nodeObj.data.properties.displayAs = 'date';
          break;
        case 'datetime':
          if (this.currentSelectedItem.pageTableType === pageTableType.QUERY_VIEW) {
            nodeObj.data.properties.displayAs = 'datetime';
          } else {
            nodeObj.data.properties.displayAs = 'datetimerange';
          }
          break;
        case 'number':
        case 'auto-number':
          nodeObj.data.properties.displayAs = 'number';
          break;
        case 'double':
          nodeObj.data.properties.displayAs = 'double';
          break;
        case 'currency':
          nodeObj.data.properties.displayAs = 'currency';
          break;
        case 'lookup':
          nodeObj.data.properties.displayAs = 'single value lookup';
          break;
        default:
          break;
      }
    }
  }
  constructFieldDataBasedOnElementType(key: string, config: any, fields: any[] = [], data: any) {
    const tblFields = config[key] || [];
    const excludeComplexTypes = ['quickFilter', 'tbl', 'tableSearch', 'captionBar'];
    const hasToExcludeComplexType = excludeComplexTypes.includes(key);
    const searchableFields = data.searchableFields || [];
    const confFields: any[] = [];
    fields.map((f: any) => {
      const quickFilterRestricted =
        (key === 'quickFilter' || key === 'tableSearch') &&
        (f.f_type.toLowerCase() === 'file attachments' ||
          f.f_type.toLowerCase() === 'image carousel' ||
          f.f_transientField);
      const isElasticSearch = this.techStack?.textSearch === GlobalConstants.searchDbEs;
      const tblTransientRestricted = key === 'tbl' && isElasticSearch && f.f_transientField;
      if (hasToExcludeComplexType) {
        if (f.f_type !== DMConstants.COMPLEX_TYPE && !quickFilterRestricted && !tblTransientRestricted) {
          confFields.push({
            ...f,
            name: f.name,
            searchable: searchableFields.includes(f.sid) || f.f_transientField,
            indexed: data.indexedFields.includes(f.sid) || f.f_transientField,
            addedToTable: tblFields.indexOf(f.sid) > -1
          });
        }
      } else {
        confFields.push({
          ...f,
          name: f.name,
          searchable: searchableFields.includes(f.sid),
          addedToTable: tblFields.indexOf(f.sid) > -1
        });
      }
    });
    return confFields;
  }

  constructDataForFieldsDisplay(inputParams) {
    const node = inputParams.node;
    const fi = inputParams.fi;
    const type = inputParams.type;
    const searchableFieldsData = inputParams.searchableFieldsData;

    if (!fi.configuredFields) {
      fi.configuredFields = {
        config: JSON.stringify({
          tbl: [],
          form: [],
          captionBar: []
        })
      };
    }

    const config = JSON.parse(fi.configuredFields?.config) || {};
    const fields = fi.fields;
    this.curContextMenuNode = {
      node,
      configuredFields: fi.configuredFields
    };
    let popupFlds: any[] = [];
    this.enrichedReferredFields = [];
    if (node.type == 'grid') {
      popupFlds = this.constructFieldDataBasedOnElementType('tbl', config, fields, searchableFieldsData);
    } else if (node.type === 'form' || node.type === 'tab' || node.type === 'formSection') {
      popupFlds = this.constructFieldDataBasedOnElementType('form', config, fields, searchableFieldsData);
    } else if (node.type === 'searchField') {
      popupFlds = this.constructFieldDataBasedOnElementType('tableSearch', config, fields, searchableFieldsData);
    } else if (node.type === 'quickFilter') {
      popupFlds = this.constructFieldDataBasedOnElementType('quickFilter', config, fields, searchableFieldsData);
    } else if (node.type === 'tableSearch') {
      popupFlds = this.constructFieldDataBasedOnElementType('tableSearch', config, fields, searchableFieldsData);
    } else if (node.type === 'captionBar') {
      popupFlds = this.constructFieldDataBasedOnElementType('captionBar', config, fields, searchableFieldsData);
    } else {
      popupFlds = fields;
    }
    if (type === 'foreignkey') {
      this.foreignKeyData = [...popupFlds];
    } else if (type === 'fkFields') {
      this.enrichedReferredFields = [...popupFlds];
      // this.referredFields = [...popupFlds];
    } else {
      this.allFields = [...popupFlds];
    }
    if (!isArray(fi)) {
      this.isPopupLoader = false;
    }
  }

  getFldsForFK(fkdata, flds) {
    fkdata.forEach((fk) => {
      if (!fk.parentChildTableFk) {
        if (fk.mappings && fk.mappings.length) {
          fk.mappings.forEach((mapdt) => {
            const i = flds.findIndex((d) => d.sid === mapdt.child);
            if (i > -1) {
              flds.splice(i, 1);
            }
          });
        }
        this.foreignKeyData = [...this.foreignKeyData, { name: fk.fkName, sid: fk.sid, f_type: null }];
      }
    });
    return flds;
  }

  addFieldsToElement(node) {
    this.isPopupLoader = true;
    this.currNode = node;
    this.foreignKeyData = [];
    this.allFields = [];
    this.referredFields = [];
    this.canSaveWhileAddingFields = false;
    this.store.dispatch(setFieldsInfoForTable({ fieldsInfo: null }));
    const getFIApiConstants = this.isFromModernize
      ? { ...ApiConstants.getFieldForPagesInterim }
      : { ...ApiConstants.getFieldForPages };
    const tableId = node?.data?.tableId ? node.data.tableId : this.currentSelectedItem.tableId;
    const screenId = this.currentSelectedItem.sid;
    if (this.isFromModernize) {
      getFIApiConstants.url = `${getFIApiConstants.url}${screenId}/${this.currentSelectedItem?.tableId}`;
    } else {
      getFIApiConstants.url = `${getFIApiConstants.url}${tableId}/${screenId}/${this.appId}`;
    }

    this.store.dispatch(
      getFieldsInfoForTable({
        getFIApiConstants
      })
    );

    this.zone.run(() => {
      this.fieldSearch = '';
      this.showAddFieldsModal = true;
      this.activeTabIndex.set(0);
      this.addFieldsCols = [
        {
          field: 'name',
          header: 'FIELD_NAME'
        },
        {
          field: 'addedToTable',
          header: 'SELECTED'
        }
      ];
    });

    const selectedScreenSub = this.store.select(fiForSelectedScreen).subscribe((fi: any) => {
      if (fi) {
        if (this.activeScreen?.pageTableType === 'QUERY_VIEW') {
          this.zone.run(() => {
            this.constructDataForFieldsDisplay({
              node: node,
              fi: fi,
              type: 'fields',
              searchableFieldsData: { searchableFields: [], indexedFields: [] }
            });
          });
        } else {
          // Transactional table pages - add indexed fields for RDBMS search and searchable Fields for elastic search
          let indexedFields: any = [];
          const searchableFields: any = [];
          const isRdbmsSearch = this.techStack?.textSearch === GlobalConstants.searchDbRdbms;
          const isElasticSearch = this.techStack?.textSearch === GlobalConstants.searchDbEs;

          if (isRdbmsSearch) {
            const indexSub = this.bs
              .get(ApiConstants.getIndex, { appId: this.appId, orgId: this.orgId, tableId: tableId })
              .subscribe({
                next: (indexData) => {
                  if (Array.isArray(indexData)) {
                    indexedFields = indexData.flatMap((item: any) => {
                      if (item && Array.isArray(item.fields)) {
                        return item.fields;
                      }
                      return [];
                    });
                  }
                  this.zone.run(() => {
                    this.constructDataForFieldsDisplay({
                      node: node,
                      fi: fi,
                      type: 'fields',
                      searchableFieldsData: { searchableFields: searchableFields, indexedFields: indexedFields }
                    });
                  });
                }
              });
            this.addToSubscriptionsList(indexSub);
          }

          // get Referred Table Fields if it is elasticSearchapp and pagetype is list
          if (isElasticSearch) {
            if (this.activeScreen?.pageType == 'list') {
              this.getReferredTableFields(tableId, node, fi);
            } else {
              const searahableFldsSub = this.bs
                .get(ApiConstants.getSearchableIndexFields, { tableId: tableId })
                .subscribe({
                  next: (searchableFieldsData) => {
                    if (searchableFieldsData) {
                      Object.values(searchableFieldsData).forEach((field: any) => searchableFields.push(field.sid));
                    }
                    this.zone.run(() => {
                      this.constructDataForFieldsDisplay({
                        node: node,
                        fi: fi,
                        type: 'fields',
                        searchableFieldsData: { searchableFields: searchableFields, indexedFields: indexedFields }
                      });
                    });
                  }
                });
              this.addToSubscriptionsList(searahableFldsSub);
            }
          }

          // Fallback for modernize/interim mode or when techStack is not set
          if (!isRdbmsSearch && !isElasticSearch) {
            this.zone.run(() => {
              this.constructDataForFieldsDisplay({
                node: node,
                fi: fi,
                type: 'fields',
                searchableFieldsData: { searchableFields: [], indexedFields: [] }
              });
            });
          }
        }
        if (selectedScreenSub) {
          selectedScreenSub.unsubscribe();
        }
      }
    });
    this.unSubList.fisub = selectedScreenSub;
    this.addToSubscriptionsList(selectedScreenSub);
    // }
    this.addToSubscriptionsList(selectedScreenSub);
  }

  getReferredTableFields(tableId: string, node: any, fi: any) {
    const refTblSub = this.bs[ApiConstants.getSearchableFieldsByTableId.method](
      ApiConstants.getSearchableFieldsByTableId,
      {
        tableId: tableId
      }
    ).subscribe({
      next: (value: any) => {
        if (value) {
          const referredTableFieldsInfo = cloneDeep(value);
          if (referredTableFieldsInfo?.currentTableSearchableField) {
            const searchableFields = referredTableFieldsInfo?.currentTableSearchableField?.fields
              ? Object.keys(referredTableFieldsInfo?.currentTableSearchableField?.fields)
              : [];
            this.zone.run(() => {
              this.constructDataForFieldsDisplay({
                node: node,
                fi: fi,
                type: 'fields',
                searchableFieldsData: { searchableFields: searchableFields, indexedFields: [] }
              });
            });
          }
          this.referredForeignkeys = referredTableFieldsInfo?.currentTableForeignKeys;
          if (this.referredForeignkeys?.length) {
            const referredTableFields = this.referredForeignkeys.map((fk) => ({
              foreignKey: fk,
              fields: referredTableFieldsInfo?.foreignTableFields?.[fk.parentTableSid] || []
            }));
            const searchableFieldsData = referredTableFieldsInfo?.currentTableSearchableField || {};
            this.getTreeStucturedFields(referredTableFields, fi, searchableFieldsData, node);
          } else {
            this.referredFields = [];
          }
        }
      },
      error: (e) => {
        this.isLoadingScreens = false;
        console.log(e);
      }
    });
    this.addToSubscriptionsList(refTblSub);
  }

  onNodeExpand(event) {
    const rowData = event.node.data;
    this.handleNodeStateChange(rowData, true); // Expand the relevant node
  }

  onNodeCollapse(event) {
    const rowData = event.node.data;
    this.handleNodeStateChange(rowData, false);
  }

  handleNodeStateChange(rowData, expanded: boolean) {
    const lastNode = this.findLastNodeByFkLabel(rowData.fkLabel);

    if (rowData.isFirst) {
      if (lastNode && lastNode.expanded !== expanded) {
        lastNode.expanded = expanded;
      }
    }

    if (rowData.isLast) {
      if (!expanded) {
        console.log(`Last node collapsed: ${rowData.name}`);
      }
    }
  }

  findLastNodeByFkLabel(fkLabel: string) {
    if (this.allFields.length > 0 && fkLabel) {
      const filteredFields = this.allFields.filter((field) => field.data.fkLabel === fkLabel && field.data.isLast);
      if (filteredFields.length > 0) {
        // const sortedFields = filteredFields.slice().sort((a, b) => {
        //   return a.data.fkLabel.localeCompare(b.data.fkLabel);
        // });

        // Return the last node in the sorted filtered list
        return filteredFields[0];
      }
    }
    return null;
  }

  getTreeStucturedFields(referredTableFields: any, fi: any, searchableFieldsData: any, treedata: any) {
    this.referredFields = [];
    const metadata = this.appGlobalService.get('appmetaInfo') || {};
    referredTableFields.forEach((fk) => {
      const fkTblSearchableFields = searchableFieldsData?.foreignKeyFields?.[fk.foreignKey?.sid];
      const lastMapping = fk.foreignKey.mappings[fk.foreignKey.mappings.length - 1];
      // Exclude transient fields from referenced tables in Elastic Search as they are index-only and always empty in data
      const parentTableFields = [...fk.fields].filter((fld) => !fld.f_transientField);
      const node = {
        data: {
          name: `${fk.foreignKey.fkName} + (${this.tableIdMap[fk.foreignKey.parentTableSid]})`,
          id: fk.foreignKey.sid,
          tableId: fk.foreignKey.parentTableSid,
          fkMapId: fk.foreignKey.sid,
          fkIndexId: fk.foreignKey.indexRefAppId,
          fkLastField: lastMapping?.child,
          showChild: true,
          isSelfReferred: false
        },
        children:
          parentTableFields
            .map((fld) => {
              const field = fld;
              let formattedFkData;
              // Use metaData to get the id based on alias name if available
              let aliasName;
              const fieldData = Object.values(fkTblSearchableFields).find((f: any) => f?.fieldSid === field.sid) as any;
              if (fieldData) {
                aliasName = fieldData?.foreignKeyAliasName;
              }
              const manipulated_Id = `${fk.foreignKey.sid}_$_${field.sid}`;
              formattedFkData = {
                name: `${field.name} ${field?.f_transientField ? '(Transient Field)' : ''}`,
                id: manipulated_Id,
                sid: manipulated_Id,
                field: field.sid,
                searchable: !!fieldData,
                isTransient: field?.f_transientField,
                isForeignkeyField: true,
                tableId: fk.foreignKey.parentTableSid,
                fkLabel: fk.foreignKey.fkName,
                isSelfReferred: fk.foreignKey.mappings.find((mapping) => mapping?.child === field.sid),
                mappedField: fk.foreignKey.mappings.find((mapping) => mapping.parent === field?.sid)?.child,
                fkAliasName: aliasName // from searchable field it has to be taken
              };
              return {
                data: { ...field, ...formattedFkData },
                children: []
              };
              // }
            })
            .filter((node) => node !== null) || [],
        expanded: true
      };
      const formattedFields = node.children.map((child) => child.data);
      const searchableFields = fkTblSearchableFields
        ? Object.values(fkTblSearchableFields).map((field: any) => field.sid)
        : [];
      this.constructDataForFieldsDisplay({
        node: treedata,
        fi: { fields: formattedFields, configuredFields: fi.configuredFields },
        type: 'fkFields',
        searchableFieldsData: { searchableFields: searchableFields, indexedFields: [] }
      });
      // now merge enrichedReferredFields in the correct structure
      const enrichedChildren = this.enrichedReferredFields.map((field) => ({
        data: field,
        children: [] // or field.children if it has children
      }));
      // Step 1: Create a map from node.children
      const childMap = new Map<string, any>();
      node.children.forEach((child) => {
        childMap.set(child.data.sid, child);
      });

      // Step 2: Merge or override with enriched children
      enrichedChildren.forEach((enriched) => {
        childMap.set(enriched.data.sid, enriched); // overrides if sid exists
      });

      // Step 3: Final merged children
      node.children = Array.from(childMap.values());
      this.referredFields.push(node);
    });
    this.referredFields = [...this.referredFields];
  }

  getListOfPages(node: any, nodeType) {
    this.zone.run(() => {
      this.errorMessage = '';
      this.errorFlag = false;
      this.selectedPage = null;
      this.isLoadingScreens = true;
      this.showListPagesModal = true;
      this.listPageName = nodeType;
      this.currNode = node;
      switch (this.listPageName) {
        case 'childgrid': {
          const childTableApi = this.isFromModernize
            ? { ...ApiConstants.getChildTablesInterim, url: ApiConstants.getChildTablesInterim.url.replace('{generationId}', this.generationId).replace('{parentTableId}', this.currentSelectedItem.tableId) }
            : ApiConstants.getChildTablesByParentTableId;
          this.store.dispatch(
            getChildTables({ getChildTableApi: childTableApi, tableId: this.currentSelectedItem.tableId })
          );
          const childTables$ = this.store.select(childTables);
          const allScreensSub$ = this.isFromModernize ? this.store.select(allInterimScreens) : this.store.select(allScreens);
          const childTableSub = combineLatest(childTables$, allScreensSub$).subscribe((data: any) => {
            if (data[0] && data[1]) {
              const _ct = cloneDeep(data[0]);
              const _as = cloneDeep(data[1]);
              const _tempArr: any[] = [];
              _as.map((sc: any) => {
                _ct.map((ct: any) => {
                  if (ct?.sid === sc?.tableId && sc?.pageType === 'list') {
                    _tempArr.push({
                      ...ct,
                      pageName: sc.pageName,
                      id: sc.sid,
                      sid: sc.sid,
                      tableId: sc.tableId,
                      pageType: sc.pageType
                    });
                  }
                });
              });
              this.listPages = cloneDeep(_tempArr);
              this.allListPages = cloneDeep(_tempArr);
              this.isLoadingScreens = false;
            }
          });
          this.addToSubscriptionsList(childTableSub);
          break;
        }
        case 'queryview':
          const queryViewPages = ApiConstants.getAllScreens;
          this.store.dispatch(setPagesForQuery({ queryPages: null }));
          this.store.dispatch(getPagesForQuery({ queryPagesApiConstants: queryViewPages }));
          const queryViewSub = this.store.select(queryPages).subscribe((data: any) => {
            if (data) {
              this.allListPages = data?.filter(
                (d) => d?.pageType === 'list' && d?.pageTableType === pageTableType.QUERY_VIEW
              );
              this.listPages = cloneDeep(this.allListPages);
              this.isLoadingScreens = false;
            }
          });
          this.addToSubscriptionsList(queryViewSub);
          break;
        case 'standardgrid': {
          const stListApi = this.isFromModernize
            ? { ...ApiConstants.getStandardPagesInterim, url: ApiConstants.getStandardPagesInterim.url.replace('{generationId}', this.generationId).replace('{tableId}', this.currentSelectedItem?.tableId) }
            : { ...ApiConstants.getStandardListPages };
          if (!this.isFromModernize) {
            stListApi.url = `${stListApi.url}/${this.appId}/${this.currentSelectedItem?.tableId}/${this.appGlobalService.get('orgId')}`;
          }
          this.store.dispatch(setStandardListPages({ standardPages: null }));
          this.store.dispatch(getStandardListPages({ stdPagesApiConstants: stListApi }));
          const satndardPagesSub = this.store.select(standardPages).subscribe((data: any) => {
            if (data) {
              this.allListPages = cloneDeep(data);
              this.listPages = cloneDeep(this.allListPages);
              this.isLoadingScreens = false;
            }
          });
          this.addToSubscriptionsList(satndardPagesSub);
          break;
        }
        default:
          break;
      }
    });
  }

  searchForListPage(event: any) {
    switch (this.listPageName) {
      case 'childgrid':
        this.listPages = this.allListPages.filter(
          (table: any) => table?.name?.includes(event.query) && table?.pageType === 'list'
        );
        break;
      case 'queryview':
        this.listPages = this.allListPages.filter((pg: any) => pg?.pageName?.includes(event.query));
        break;
      case 'standardgrid':
        this.listPages = this.allListPages.filter((pg: any) => pg?.pageName?.includes(event.query));
        break;
      default:
        break;
    }
  }

  addSelectedPageToNode() {
    this.submitted = true;
    this.errorFlag = false;
    this.errorMessage = '';
    if (!this.selectedPage) {
      this.errorFlag = true;
      switch (this.listPageName) {
        case 'childgrid':
          this.errorMessage = this.translate.instant('CHILD_PAGE_ERR');
          break;
        case 'queryview':
          this.errorMessage = this.translate.instant('QUERY_PAGE_ERR');
          break;
        case 'standardgrid':
          this.errorMessage = this.translate.instant('STAND_PAGE_ERR');
          break;
        default:
          break;
      }
      return;
    }
    switch (this.listPageName) {
      case 'childgrid':
        const childGridConfigurationId = uuidv4();
        let childGridConfig: any = {
          type: 'childList',
          title: this.selectedPage.pageName,
          key: this.selectedPage.sid,
          id: this.selectedPage.sid,
          tableId: this.selectedPage.tableId,
          data: {
            properties: {
              childGridConfigurationId: childGridConfigurationId,
              childPageLimit: '10'
            }
          },
          children: []
        };
        childGridConfig = this.assignHtmlPropsToNode(childGridConfig, this.currNode);
        this.currNode.addNode(childGridConfig, 'over');
        let additionalInfo: Record<string, unknown> | undefined = {
          tableId: this.selectedPage.tableId,
          childScreenId: this.selectedPage.sid,
          path: this.screensReferenceService.getAdditionalPath(this.currNode)
        };
        const params = { detailPageId: this.currentSelectedItem.sid };
        additionalInfo = this.util.enrichAdInfo(additionalInfo, params);
        this.referencesTasks.addedReference.push(
          this.util.createReference(
            this.currentSelectedItem.sid,
            utilEnum.modelType.PAGE,
            this.selectedPage.sid,
            utilEnum.modelType.PAGE,
            this.appId,
            this.screensReferenceService.getAdditionalPath(this.currNode),
            this.screensReferenceService.getPropName(this.currNode?.type?.toLowerCase()),
            false,
            additionalInfo
          )
        );
        this.updScrIds(this.selectedPage.sid, 'add');
        this.pageModalEvents.push({ modelId: this.selectedPage.sid, event: ModelEventType.EMBEDDED_LIST_PAGE_ADDED });
        break;
      case 'queryview':
        // assign static value for query mapping if it is present in parameter mapping
        let querymapping;
        let paramMappingForQueryList;
        this.isLoadingScreens = true;
        const tblInfo = combineLatest(
          this.bs.get(ApiConstants.getDatamodelTableData, { sid: this.selectedPage.tableId }),
          this.bs.get(ApiConstants.getFieldInfo, { tableId: this.selectedPage.tableId })
        ).subscribe({
          next: (value: any) => {
            if (value[0] && value[1]) {
              this.isLoadingScreens = false;
              const mFilters = value[0]?.t_mandatory_filters;
              if (mFilters?.length) {
                const queryScr = this.allSelectedScreens?.userGenScreens?.find(
                  (scr) => scr.pageTableType === pageTableType.QUERY_VIEW && scr?.sid === this.selectedPage.sid
                );
                querymapping = mFilters
                  ?.split(',')
                  .map((mf) => {
                    const fld = value[1].find((f) => f.sid === mf);
                    let holdFilterValue;
                    let type = 'field';
                    let staticValue;
                    let tableField;
                    try {
                      const paramMapping = this.util.findNodeByKeyValue(JSON.parse(queryScr?.contentAttachment), 'type', 'grid')?.data?.properties?.parameterMappingForQueryList;
                      if (paramMapping?.length) {
                        paramMappingForQueryList = paramMapping;
                        const pmfld = paramMapping.find((m) => m.listField?.sid === mf);
                        if (pmfld && pmfld.staticValue) {
                          type = 'value';
                          staticValue = pmfld.staticValue?.valueSid;
                        }
                        // if (pmfld && pmfld.detailField) {
                        //   type = pmfld?.detailField?.type;
                        //   tableField = pmfld?.detailField;
                        // }
                      }
                    } catch (e) {
                      console.error(e);
                    }
                    return {
                      lookupField: {
                        sid: fld.sid,
                        name: fld.name,
                        f_type: fld.f_type,
                        tableId: fld.f_tableId,
                        appId: fld.appId
                      },
                      holdFilterValue: holdFilterValue,
                      type: type,
                      staticValue: staticValue
                    };
                  })
                  .filter((qm) => qm.staticValue);
              }
              const queryViewConfigurationId = uuidv4();
              let queryViewConfig: any = {
                type: 'queryView',
                title: this.selectedPage.pageName,
                key: this.selectedPage.sid,
                id: this.selectedPage.sid,
                data: {
                  properties: {
                    queryViewConfigurationId: queryViewConfigurationId,
                    queryViewTableId: this.selectedPage.tableId,
                    queryViewAppId: this.selectedPage.appId,
                    queryViewMapping: querymapping?.length ? querymapping : null,
                    parameterMappingForQueryList: paramMappingForQueryList?.length ? paramMappingForQueryList : null,
                    queryTblmandatoryFilterSid: value[0]?.t_mandatory_filters_sid,
                    childPageLimit: '10'
                  }
                },
                children: []
              };
              queryViewConfig = this.assignHtmlPropsToNode(queryViewConfig, this.currNode);
              this.currNode.addNode(queryViewConfig, 'over');
              this.referencesTasks.addedReference.push(
                this.util.createReference(
                  this.currentSelectedItem.sid,
                  utilEnum.modelType.PAGE,
                  this.selectedPage.sid,
                  utilEnum.modelType.PAGE,
                  this.appId,
                  this.screensReferenceService.getAdditionalPath(this.currNode),
                  utilEnum.propertyName.QUERY_VIEW,
                  false,
                  undefined,
                  undefined,
                  undefined,
                  queryViewConfigurationId
                )
              );
              if (querymapping?.length) {
                const nodeData: any = {
                  key: this.selectedPage.sid,
                  data: {
                    id: this.selectedPage.sid,
                    properties: {
                      queryViewMapping: querymapping
                    }
                  }
                };
                this.screensReferenceService.createOrDelRefForMapping(
                  querymapping,
                  null,
                  'queryViewMapping',
                  nodeData,
                  'lookupField',
                  null,
                  true,
                  undefined,
                  this.getReferenceContext()
                );
                this.screensReferenceService.createOrDelRefForMapping(
                  querymapping,
                  null,
                  'queryViewMapping',
                  nodeData,
                  'tableField',
                  null,
                  true,
                  undefined,
                  this.getReferenceContext()
                );
              }
              if (paramMappingForQueryList?.length) {
                const nodeData: any = {
                  key: this.selectedPage.sid,
                  data: {
                    id: this.selectedPage.sid,
                    properties: {
                      parameterMappingForQueryList: paramMappingForQueryList
                    }
                  }
                };
                const baseAdInfo = this.util.enrichAdInfo(
                  { menu: nodeData.data?.id },
                  {
                    props: { currentNode: nodeData.data?.id },
                    node: nodeData,
                    detailPageId: this.currentSelectedItem?.sid
                  }
                );
                const hasStaticValues = paramMappingForQueryList.some((m) => m?.staticValue);
                if (hasStaticValues) {
                  const staticMaps = paramMappingForQueryList.filter((m) => m?.staticValue);
                  this.screensReferenceService.createOrDelRefForMapping(
                    null,
                    staticMaps,
                    'parameterMappingForQueryList',
                    nodeData,
                    'listField',
                    this.util.updateAdInfoForMapping(baseAdInfo, 'listField', 'parameterMappingForQueryList'),
                    undefined,
                    queryViewConfigurationId
                  );
                } else {
                  this.screensReferenceService.createOrDelRefForMapping(
                    null,
                    paramMappingForQueryList,
                    'parameterMappingForQueryList',
                    nodeData,
                    'listField',
                    this.util.updateAdInfoForMapping(baseAdInfo, 'listField', 'parameterMappingForQueryList'),
                    undefined,
                    queryViewConfigurationId
                  );
                  this.screensReferenceService.createOrDelRefForMapping(
                    null,
                    paramMappingForQueryList,
                    'parameterMappingForQueryList',
                    nodeData,
                    'detailField',
                    this.util.updateAdInfoForMapping(baseAdInfo, 'detailField', 'parameterMappingForQueryList'),
                    undefined,
                    queryViewConfigurationId
                  );
                }
              }
              this.pageModalEvents.push({
                modelId: this.selectedPage.sid,
                event: ModelEventType.EMBEDDED_LIST_PAGE_ADDED
              });
              this.showListPagesModal = false;
              this.saveFancyTree('screenid');
              this.debounceSaveTree('screenid');
              this.selectedPage = null;
            }
          },
          error: (e) => {
            console.log(e);
          }
        });
        this.addToSubscriptionsList(tblInfo);
        break;
      case 'standardgrid':
        const id = uuidv4();
        let stdGridConfig: any = {
          type: 'standardDatagrid',
          title: this.selectedPage.pageName,
          key: id,
          id: this.selectedPage.sid,
          data: {
            properties: {
              stdGridConfigurationId: id,
              parameterMapping: null,
              standardGridTableId: this.selectedPage.tableId,
              standardGridAppId: this.selectedPage.appId,
              standardGridOrgId: this.selectedPage.orgId,
              childPageLimit: '10'
            }
          },
          children: []
        };
        stdGridConfig = this.assignHtmlPropsToNode(stdGridConfig, this.currNode);
        this.currNode.addNode(stdGridConfig, 'over');
        this.pageSection.createdPageSectionMap = {
          ...this.pageSection.createdPageSectionMap,
          ...{ [id]: this.selectedPage.pageName }
        };
        this.referencesTasks.addedReference.push(
          this.util.createReference(
            this.currentSelectedItem.sid,
            utilEnum.modelType.PAGE,
            this.selectedPage.sid,
            utilEnum.modelType.PAGE,
            this.appId,
            this.screensReferenceService.getAdditionalPath(this.currNode),
            utilEnum.propertyName.STANDARD_DATAGRID,
            false
          )
        );
        this.pageModalEvents.push({ modelId: this.selectedPage.sid, event: ModelEventType.EMBEDDED_LIST_PAGE_ADDED });
        break;
      default:
        break;
    }
    if (this.listPageName !== 'queryview') {
      this.showListPagesModal = false;
      this.saveFancyTree('screenid');
      this.debounceSaveTree('screenid');
      this.selectedPage = null;
    }
  }

  closeListPagesDialogue() {
    this.showListPagesModal = false;
    this.listPages = [];
    this.listPageName = null;
    this.allListPages = [];
    this.selectedPage = null;
  }

  closeCCModalDialogue() {
    this.showCCModal = false;
  }

  closeAddFieldsModalDialogue() {
    this.showAddFieldsModal = false;
  }

  closeMenuPopup() {
    this.showMenuPopup = false;
    this.errorFlag = false;
    this.errorMessage = '';
    this.appForm = new FormGroup({
      name: new FormControl('')
    });
  }

  closeTabsPopup() {
    this.showTabsPopup = false;
    this.errorFlag = false;
    this.errorMessage = '';
    this.appForm = new FormGroup({
      name: new FormControl('')
    });
  }

  addCustomComponent(node: any, insertMode = 'over') {
    this.zone.run(() => {
      this.errorMessage = '';
      this.errorFlag = false;
      this.isLoadingScreens = true;
      this.selectedCC = null;
      this.ccInsertMode = insertMode;
      this.showCCModal = true;
      this.currNode = node;
      const getCCApi = ApiConstants.getCustomComponentsForApp;
      this.store.dispatch(getAllCustomComponentForApp({ getAllCCForApp: getCCApi }));
      const ccSub$ = this.store.select(allCCsForApp).subscribe((ccs: any) => {
        if (ccs) {
          this.allCCs = cloneDeep(ccs);
          this.allCCsBkp = cloneDeep(ccs);
          this.isLoadingScreens = false;
        }
      });

      this.addToSubscriptionsList(ccSub$);
    });
  }

  searchForCC(event: any) {
    this.allCCs = this.allCCsBkp.filter((cc: any) =>
      cc?.componentName?.toLowerCase().includes(event.query.toLowerCase())
    );
  }

  updCusComIds(id, operation) {
    const order = this.taskstoSave ? this.taskstoSave?.orders : this.screensResData.contentAttachment;
    if (operation === 'add') {
      if (order && !order.includes(id)) {
        if (this.screensResData.componentIds) {
          const ids = [...this.screensResData.componentIds, id];
          this.screensResData = { ...this.screensResData, ...{ componentIds: ids } };
        } else {
          this.screensResData = { ...this.screensResData, ...{ componentIds: [id] } };
        }
      }
    } else if (operation === 'delete') {
      if (order && !order.includes(id) && this.screensResData.componentIds) {
        const i = this.screensResData.componentIds.indexOf(id);
        if (i > -1) {
          const ids = [...this.screensResData.componentIds];
          ids.splice(i, 1);
          this.screensResData = { ...this.screensResData, ...{ componentIds: ids } };
        }
      }
    }
  }

  addSelectedCCToNode() {
    this.errorFlag = false;
    this.errorMessage = '';
    if (!this.selectedCC) {
      this.errorFlag = true;
      this.errorMessage = 'Custom Component should be selected';
      return;
    }
    const customComponentConfigurationId = uuidv4();
    let customCompConfig: any = {
      type: 'customComponent',
      folder: false,
      title: this.selectedCC.componentName,
      key: this.selectedCC.sid,
      id: this.selectedCC.sid,
      tableId: this.selectedCC.sid,
      data: {
        properties: {
          customComponentConfigurationId: customComponentConfigurationId,
          type: 'customComponent'
        }
      }
    };
    customCompConfig = this.assignHtmlPropsToNode(customCompConfig, this.currNode);
    this.currNode.addNode(customCompConfig, this.ccInsertMode);
    this.referencesTasks.addedReference.push(
      this.util.createReference(
        this.currentSelectedItem.sid,
        utilEnum.modelType.PAGE,
        this.selectedCC.sid,
        utilEnum.modelType.CUSTOM_COMPONENT,
        this.appId,
        this.screensReferenceService.getAdditionalPath(this.currNode),
        this.screensReferenceService.getPropName(this.currNode?.type?.toLowerCase())
      )
    );
    this.showCCModal = false;
    this.updCusComIds(this.selectedCC.sid, 'add');
    this.saveFancyTree('custom component');
    this.debounceSaveTree('custom component');
    this.selectedCC = null;
  }

  checkMaxPagesInForm(node, count, nodeTyp) {
    if (count === 10) {
      return count;
    }
    if (node.children) {
      node.children.forEach((n) => {
        if (n.type === nodeTyp) {
          ++count;
        } else if (n.children) {
          count = this.checkMaxPagesInForm(n, count, nodeTyp);
        }
      });
    }
    return count;
  }

  createNode(node, action, options, fromCommand) {
    const ctx = this.buildCreateNodeContext(fromCommand);
    const handler = this.getNodeActionHandler(action.toLowerCase());
    handler?.(node, ctx, action, options, fromCommand);
  }

  private buildCreateNodeContext(fromCommand: boolean) {
    const AFTER = 'after';
    const OVER = fromCommand ? 'after' : 'over';
    const BEFORE = 'before';
    const id = uuidv4();
    this.tabId1 = uuidv4();
    this.tabId2 = uuidv4();

    const baseProperties = { title: '', id, new: true, key: id };
    const baseFolderProperties = { ...baseProperties, folder: true };
    const defaultIcon = {
      icon: {
        label: 'grid-01',
        value: 'grid-01.svg'
      },
      iconColor: '#000000',
      iconSize: '13px',
      type: utilEnum.IconType.SYSTEM_ICON
    };

    return {
      AFTER: 'after',
      OVER: fromCommand ? 'after' : 'over',
      BEFORE: 'before',
      baseProperties,
      baseFolderProperties,
      menuProps: {
        properties: {
          accessControl: this.isFromModernize ? ['all'] : [this.allRoles?.find((role) => role.name === 'App Admin')?.sid].filter(Boolean),
          icon: defaultIcon,
          ...(this.isFromModernize ? { onClick: 'navigate_to_page' } : {})
        }
      }
    };
  }

  private getNodeActionHandler(action: string): ((node, ctx, action?, options?, fromCommand?) => void) | undefined {
    const handlers: Record<string, (node, ctx, action?, options?, fromCommand?) => void> = {
      addmenugroup: (n, c) => this.handleMenuGroup(n, c.OVER, c),
      addmenugroupabove: (n, c) => this.handleMenuGroup(n, c.BEFORE, c),
      addmenugroupafter: (n, c) => this.handleMenuGroup(n, c.AFTER, c),
      addmenuitem: (n, c) => this.handleMenuItem(n, c.AFTER, c),
      addmenuitemabove: (n, c) => this.handleMenuItem(n, c.BEFORE, c),
      addchildmenuitem: (n, c) => this.handleMenuItem(n, c.OVER, c),
      addimportmenuitem: (n, c) => this.handleImportMenuItem(n, c),
      addmenuitembelow: (n, c) => this.handleMenuItem(n, c.AFTER, c),
      addmenuitems: (n) => this.handleShowMenuPopup(n),
      addusermenus: (n) => this.handleShowMenuPopup(n),
      addsiblingtable: (n, c) => this.handleSiblingTable(n, c),
      addsiblingfield: (n, c) => this.handleSiblingField(n, c),
      addfieldgroup: (n, c) => this.handleFieldGroup(n, c),
      addtablecolumns: (n) => this.addFieldsToElement(n),
      addbuttons: (n, c) => this.handleButton(n, c),
      addbutton: (n, c) => this.handleButton(n, c),
      addcustombuttons: (n, c) => this.handleCustomButton(n, c),
      addbuttongroup: (n, c) => this.handleButtonGroup(n, c),
      adddropdownbutton: (n, c) => this.handleDropdownButton(n, c),
      addcaptions: (n) => this.addFieldsToElement(n),
      addformfields: (n) => this.addFieldsToElement(n),
      addsiblingformfields: (n, c) => this.handleSiblingFormFields(n, c),
      addformsection: (n, c) => this.handleFormSection(n, c),
      addformtab: (n) =>
        this.zone.run(() => {
          this.showTabViewPopup = true;
          this.currNode = n;
        }),
      addtabs: (n, c) => this.handleTabs(n, c),
      converttosection: (n) => this.handleConvertToSection(n),
      converttotab: (n) => this.handleConvertToTab(n),
      addsearchfields: (n) => this.addFieldsToElement(n),
      addquickfilterfields: (n) => this.addFieldsToElement(n),
      adddatagrid: (n) => this.getListOfPages(n, 'childgrid'),
      addqueryview: (n) => this.getListOfPages(n, 'queryview'),
      addstandardgrid: (n) => this.handleStandardGrid(n),
      adddcustomcomponent: (n) => this.addCustomComponent(n),
      adddcustomcomponentabove: (n, c) => this.addCustomComponent(n, c.BEFORE),
      adddcustomcomponentbelow: (n, c) => this.addCustomComponent(n, c.AFTER),
      addform: (n, c) => this.handleForm(n, c),
      addtiles: (n, c) => this.handleTiles(n, c),
      htmlcontainer: (n, c) => this.handleHtmlContainer(n, c.OVER, c),
      htmlcontainerabove: (n, c) => this.handleHtmlContainer(n, c.BEFORE, c),
      htmlcontainerbelow: (n, c) => this.handleHtmlContainer(n, c.AFTER, c),
      inlinetext: (n, c) => this.handleInlineText(n, c.OVER, c),
      inlinetextabove: (n, c) => this.handleInlineText(n, c.BEFORE, c),
      inlinetextbelow: (n, c) => this.handleInlineText(n, c.AFTER, c),
      addlangdrop: (n, c) => this.handleLangDrop(n, c),
      addlogout: (n, c) => this.handleLogout(n, c),
      addusermenuabove: (n, c) => this.handleUserMenu(n, c.BEFORE, c),
      addchildusermenu: (n, c) => this.handleUserMenu(n, c.OVER, c),
      addusermenubelow: (n, c) => this.handleUserMenu(n, c.AFTER, c),
      delete: (n, c, a, o, f) => this.handleDelete(n, a, o, f),
      adddelete: (n, c, a, o, f) => this.handleDelete(n, a, o, f)
    };
    return handlers[action];
  }

  private handleMenuGroup(node, position, ctx) {
    this.getDefaultValues('menuGroup');
    this.createNodeWithHtmlProps(node, position, {
      type: 'MENU_GROUP',
      ...ctx.baseFolderProperties,
      data: { properties: { ...this.formDefaultValues, ...ctx.menuProps.properties } }
    });
  }

  private handleMenuItem(node, position, ctx) {
    this.getDefaultValues('menuItem');
    this.createNodeWithHtmlProps(node, position, {
      type: 'MENU_ITEM',
      ...ctx.baseProperties,
      data: { properties: { ...this.formDefaultValues, ...ctx.menuProps.properties } }
    });
  }

  private handleImportMenuItem(node, ctx) {
    this.getDefaultValues('menuItem');
    this.setImportMenuItemProps(ctx.menuProps);
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'MENU_ITEM',
      ...ctx.baseProperties,
      data: { properties: { ...this.formDefaultValues, ...ctx.menuProps.properties } }
    });
  }

  private handleShowMenuPopup(node) {
    this.zone.run(() => {
      this.errorMessage = '';
      this.errorFlag = false;
      this.showMenuPopup = true;
      this.currNode = node;
    });
  }

  private handleSiblingTable(node, ctx) {
    this.getDefaultValues('table');
    this.createNodeWithHtmlProps(node, ctx.AFTER, {
      ...ctx.baseFolderProperties,
      data: { properties: this.formDefaultValues },
      type: 'table'
    });
  }

  private handleSiblingField(node, ctx) {
    this.getDefaultValues('formField');
    this.createNodeWithHtmlProps(node, ctx.AFTER, {
      type: 'formField',
      data: { properties: this.formDefaultValues },
      ...ctx.baseProperties
    });
  }

  private handleFieldGroup(node, ctx) {
    this.getDefaultValues('fieldGroup');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'fieldGroup',
      ...ctx.baseFolderProperties,
      data: { properties: this.formDefaultValues }
    });
  }

  private handleButton(node, ctx) {
    this.getDefaultValues('button');
    if (this.isFromModernize && !this.formDefaultValues.action) {
      this.formDefaultValues.action = 'call_a_backend_webservice';
    }
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'button',
      ...ctx.baseProperties,
      data: { properties: this.formDefaultValues }
    });
  }

  private handleCustomButton(node, ctx) {
    this.getDefaultValues('customButton');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'customButton',
      ...ctx.baseProperties,
      data: { properties: this.formDefaultValues }
    });
  }

  private handleButtonGroup(node, ctx) {
    this.getDefaultValues('buttonGroup');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'buttonGroup',
      ...ctx.baseFolderProperties,
      data: { properties: this.formDefaultValues }
    });
  }

  private handleDropdownButton(node, ctx) {
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'splitButton',
      ...ctx.baseProperties
    });
  }

  private handleSiblingFormFields(node, ctx) {
    this.getDefaultValues('formField');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'formField',
      data: { properties: this.formDefaultValues },
      ...ctx.baseFolderProperties
    });
  }

  private handleFormSection(node, ctx) {
    this.getDefaultValues('formSection');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'formSection',
      data: { properties: this.formDefaultValues },
      ...ctx.baseFolderProperties
    });
  }

  private handleTabs(node, ctx) {
    this.getDefaultValues('tab');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'tab',
      ...ctx.baseFolderProperties,
      data: { properties: this.formDefaultValues }
    });
  }

  private handleConvertToSection(node) {
    node.type = 'formSection';
    this.saveFancyTree('converttosection');
    this.debounceSaveTree('converttosection');
    $(`#${node.data.id}`)[0].innerText = 'Form Section';
  }

  private handleConvertToTab(node) {
    node.type = 'tabView';
    this.saveFancyTree('converttotab');
    this.debounceSaveTree('converttotab');
    $(`#${node.data.id}`)[0].innerText = 'Tab View';
  }

  private handleStandardGrid(node) {
    const formNode = $.ui.fancytree.getTree(this.getTreeSelector()).getNodeByKey('detailForm');
    const count = this.checkMaxPagesInForm(formNode, 0, 'standardDatagrid');
    if (count >= 10) {
      this.showMessage('error', this.translate.instant('MAX_PAGES_GRID'));
    } else {
      this.getListOfPages(node, 'standardgrid');
    }
  }

  private handleForm(node, ctx) {
    this.getDefaultValues('form');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'form',
      ...ctx.baseFolderProperties,
      title: 'Form',
      data: { properties: this.formDefaultValues }
    });
  }

  private handleTiles(node, ctx) {
    this.getDefaultValues('homeTile');
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'homeTile',
      ...ctx.baseProperties,
      data: { properties: { ...this.formDefaultValues, ...ctx.menuProps.properties } }
    });
  }

  private handleHtmlContainer(node, position, ctx) {
    this.getDefaultValues('htmlContainer');
    this.createNodeWithHtmlProps(node, position, {
      type: 'htmlContainer',
      ...ctx.baseFolderProperties,
      data: { properties: this.formDefaultValues }
    });
  }

  private handleInlineText(node, position, ctx) {
    this.getDefaultValues('inlineText');
    if (Object.prototype.hasOwnProperty.call(this.formDefaultValues, 'content') && !this.formDefaultValues.content) {
      this.formDefaultValues.content = '';
    }
    this.createNodeWithHtmlProps(node, position, {
      type: 'inlineText',
      ...ctx.baseProperties,
      data: { properties: this.formDefaultValues }
    });
  }

  private handleLangDrop(node, ctx) {
    ctx.baseProperties.title = 'Language';
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'LANGUAGE',
      ...ctx.baseProperties,
      data: {
        properties: {
          label: 'Language',
          icon: {
            icon: { label: 'translate-01', value: 'translate-01.svg' },
            iconColor: '#000000',
            iconSize: '13px',
            type: utilEnum.IconType.SYSTEM_ICON
          }
        }
      }
    });
  }

  private handleLogout(node, ctx) {
    ctx.baseProperties.title = 'Logout';
    this.createNodeWithHtmlProps(node, ctx.OVER, {
      type: 'LOGOUT',
      ...ctx.baseProperties,
      data: {
        properties: {
          label: 'Logout',
          icon: {
            icon: { label: 'log-out-01', value: 'log-out-01.svg' },
            iconColor: '#000000',
            iconSize: '13px',
            type: utilEnum.IconType.SYSTEM_ICON
          }
        }
      }
    });
  }

  private handleUserMenu(node, position, ctx) {
    this.getDefaultValues('userMenu');
    this.createNodeWithHtmlProps(node, position, {
      type: 'USER_MENU',
      ...ctx.baseProperties,
      data: { properties: { ...this.formDefaultValues, ...ctx.menuProps.properties } }
    });
  }

  private handleDelete(node, action, options, fromCommand) {
    if (node.type.toLowerCase() === 'gridcolumn') {
      this.checkGridColumn(node, action, options, fromCommand);
    } else {
      this.zone.run(() => {
        this.deleteConfirmation(node, action, options, fromCommand);
      });
    }
  }

  deleteConfirmation(node, action, options, fromCommand) {
    // Build the display label: use all currently selected nodes (same resolution logic as
    // deleteNode) so the confirmation reflects every item that will be removed.
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    let selectedNodes = tree.getSelectedNodes();
    const currentNodeInList = selectedNodes.some((e) => e.data.id === node.data.id);
    if (selectedNodes.length === 0 || !currentNodeInList) {
      selectedNodes = [node];
    }
    const titles = selectedNodes.map((n: any) => n.title);
    const elementName = titles.length > 10 ? titles.slice(0, 10).join(', ') + ', ...' : titles.join(', ');
    this.zone.run(() => {
      this.confirmationDialogService.confirm({
        message: this.translate.instant('DELETE_PAGE_ELEMENT_CONFIRMATION', { elementName }),
        header: 'Confirmation',
        accept: () => {
          this.deleteNode(node, action, options, fromCommand);
        },
        reject: () => {
          console.log('rejected');
        }
      });
    });
  }

  private convertToTabGroup(node: any, menuProps: any): void {
    this.getDefaultValues('tabGroup');
    node.type = 'tabGroup';
    node.data = { ...node.data, ...{ properties: { ...this.formDefaultValues, ...menuProps.properties } } };
    $(`#${node.data.id}`)[0].innerText = 'Tab Group';
    if (node.children && node.children.length > 0) {
      this.getDefaultValues('tabItem');
      node.children.forEach((child) => {
        child.type = 'tabItem';
        child.data = { ...child.data, ...{ properties: { ...this.formDefaultValues, ...menuProps.properties } } };
        $(`#${child.data.id}`)[0].innerText = 'Tab Item';
      });
    }
    this.saveFancyTree('converttabgroup');
    this.debounceSaveTree('converttabgroup');
  }

  private handleAddStandardGrid(node: any): void {
    const formNode = $.ui.fancytree.getTree(this.getTreeSelector()).getNodeByKey('detailForm');
    const count = this.checkMaxPagesInForm(formNode, 0, 'standardDatagrid');
    if (count >= 10) {
      this.showMessage('error', this.translate.instant('MAX_PAGES_GRID'));
    } else {
      this.getListOfPages(node, 'standardgrid');
    }
  }

  private handleAddFormTab(node: any, baseTabProperties: any, position: string): void {
    this.getDefaultValues('tabView');
    node.editCreateNode(position, {
      type: 'tabView',
      ...baseTabProperties,
      data: {
        properties: this.formDefaultValues
      }
    });
    if (!this.isFromModernize) {
      setTimeout(() => {
        $.ui.fancytree.getTree(this.getTreeSelector()).activateKey(baseTabProperties.key).setExpanded();
        const children = baseTabProperties.children;
        if (children) {
          const lastChild = children[children.length - 1];
          const treeNode = $.ui.fancytree.getTree(this.getTreeSelector()).getNodeByKey(lastChild.key);
          treeNode.makeVisible({ scrollIntoView: true });
        }
      }, 100);
    }
  }

  private handleDeleteAction(node: any, action: any, options: any, fromCommand: any): void {
    if (node.type.toLowerCase() === 'gridcolumn') {
      this.checkGridColumn(node, action, options, fromCommand);
    } else {
      this.zone.run(() => {
        this.deleteConfirmation(node, action, options, fromCommand);
      });
    }
  }

  checkGridColumn(node, action, options, fromCommand) {
    const fieldId = node.key;
    const parNode = node?.parent;
    let message = `${this.fieldIdMap[fieldId]} is used in`;
    let errFlg = false;
    if (parNode) {
      const props = { ...parNode.data?.properties };
      if (
        (props.sortField && props.sortField?.sid === fieldId) ||
        (props.sortFields && props.sortFields?.map((item) => item.sid)?.includes(fieldId))
      ) {
        message += ' Default Sort,';
        errFlg = true;
      }
      if (props.groupsOnColumn && props.groupsOnColumn.includes(fieldId)) {
        message += ' Group By Field,';
        errFlg = true;
      }
      if (props.alignColumns && props.alignColumns?.raw && props.alignColumns.raw.find((f) => f.id === fieldId)) {
        message += ' Align Columns,';
        errFlg = true;
      }
      if (errFlg) {
        message = `${message.substring(
          0,
          message.lastIndexOf(',')
        )}. On deleting the Grid Column will also remove the field from the properties. Are you sure want to delete?`;
        this.zone.run(() => {
          this.confirmationDialogService.confirm({
            message: message,
            header: 'Confirmation',
            acceptIcon: 'pi pi-check',
            rejectIcon: 'pi pi-times',
            accept: () => {
              if (props.sortField && props.sortField?.sid === fieldId) {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    fieldId,
                    utilEnum.propertyName.DEFAULT_SORT_ON
                  )
                );
                props.sortField = null;
              }
              if (props.groupsOnColumn && props.groupsOnColumn.includes(fieldId)) {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    fieldId,
                    utilEnum.propertyName.GROUPS_ON_COLUMN
                  )
                );
                props.groupsOnColumn = props.groupsOnColumn.replace(fieldId, '');
                props.groupsOnColumn = props.groupsOnColumn.replace(',,', ',');
              }
              if (props.sortFields && props.sortFields?.map((item) => item.sid)?.includes(fieldId)) {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    fieldId,
                    utilEnum.propertyName.DEFAULT_SORT_ON
                  )
                );
                props.sortFields = props.sortFields?.filter((item) => item.sid !== fieldId);
              }
              if (
                props.alignColumns &&
                props.alignColumns?.raw &&
                props.alignColumns.raw.find((f) => f.id === fieldId)
              ) {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    fieldId,
                    utilEnum.propertyName.ALIGN_COLUMNS
                  )
                );
                const i = props.alignColumns.raw.findIndex((f) => f.id === fieldId);
                const rawData = props.alignColumns.raw;
                rawData.splice(i, 1);
                props.alignColumns = { ...props.alignColumns, ...{ raw: rawData } };
              }
              parNode.data.properties = props;
              this.deleteNode(node, action, options, fromCommand);
            },
            reject: () => {
              console.log('rejected');
            }
          });
        });
      } else {
        this.deleteConfirmation(node, action, options, fromCommand);
      }
    }
  }

  // method to delete references when menu item/ tab item/ tile
  handlePageAndRoleDeletion(node) {
    const data = node.data?.properties || {};
    if (Object.prototype.hasOwnProperty.call(data, 'page') && data.page) {
      // E20PS-1443
      // delete 'navigate page' reference by uniquesid because during reference creation below uniquesid was formed
      // uniquesid:  "appID modelID referredAppId referredmodelid propertyname menuitemsid"
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          data.page?.sid,
          utilEnum.propertyName.NAVIGATION_PAGE,
          { menu: node.data?.id }
        )
      );
      this.saveFancyTree('deletescreenid', data.page?.sid);
    } else {
      this.saveFancyTree('deleteNode');
    }
    // E20PS-1443
    // delete 'access control' reference by uniquesid because during reference creation below uniquesid was formed
    // uniquesid:  "appID modelID referredAppId referredmodelid propertyname menuitemsid"
    if (Object.prototype.hasOwnProperty.call(data, 'accessControl')) {
      let rolesTorem = [...data.accessControl];
      if (rolesTorem.includes('all')) {
        rolesTorem = this.allRoles?.map((role) => role.sid) || [];
      }
      const appAdminSid = this.allRoles?.find((role) => role.name === 'App Admin')?.sid;
      if (rolesTorem?.length && rolesTorem !== null) {
        rolesTorem.forEach((sid) => {
          if (sid !== 'all' && sid !== appAdminSid) {
            this.referencesTasks.deletedReference.push(
              this.util.createObjForDelRef(
                this.currentSelectedItem.sid,
                sid,
                utilEnum.propertyName.ACCESS_CONTROL,
                { menu: node.data?.id },
                undefined,
                this.allRoles[0].appId
              )
            );
          }
        });
      }
    }
  }

  updateConditonalRef(node) {
    let addInfo = this.screensReferenceService.getAdditionalPath(node) as any;
    addInfo = { ...addInfo, button: node.data.id };
    if (node?.data?.properties.conditionForButtonEnable) {
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          JSON.parse(node?.data?.properties.conditionForButtonEnable).sid,
          utilEnum.propertyName.BUTTON_ENABLED_CONDITIONAL,
          { menu: node.data?.id, path: this.screensReferenceService.getAdditionalPath(node) }
        )
      );
    }
    if (node?.data?.properties.conditionForButtonVisiblity) {
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          JSON.parse(node?.data?.properties.conditionForButtonVisiblity).sid,
          utilEnum.propertyName.BUTTON_VISIBILITY_CONDITIONAL,
          { menu: node.data?.id, path: this.screensReferenceService.getAdditionalPath(node) }
        )
      );
    }
  }

  private deleteParameterMappingReferences(node: any, props: any): void {
    const stdGridConfigurationId = node.data?.properties?.stdGridConfigurationId;

    if (props?.parameterMapping) {
      const baseAdInfo = this.util.updateAdInfoForMapping(
        { menu: node.data?.id },
        'listField',
        'parameterMapping'
      );
      this.screensReferenceService.createOrDelRefForMapping(props.parameterMapping, null, 'parameterMapping', node, 'listField', baseAdInfo, undefined, stdGridConfigurationId);
      this.screensReferenceService.createOrDelRefForMapping(props.parameterMapping, null, 'parameterMapping', node, 'detailField', this.util.updateAdInfoForMapping(baseAdInfo, 'detailField', 'parameterMapping'), undefined, stdGridConfigurationId);
    }

    if (props?.parameterMappingPageVariables) {
      const baseAdInfo = this.util.updateAdInfoForMapping(
        { menu: node.data?.id },
        'listField',
        'parameterMappingPageVariables'
      );
      this.screensReferenceService.createOrDelRefForMapping(props.parameterMappingPageVariables, null, 'parameterMappingPageVariables', node, 'listField', baseAdInfo, undefined, stdGridConfigurationId);
      this.screensReferenceService.createOrDelRefForMapping(props.parameterMappingPageVariables, null, 'parameterMappingPageVariables', node, 'detailField', this.util.updateAdInfoForMapping(baseAdInfo, 'detailField', 'parameterMappingPageVariables'), undefined, stdGridConfigurationId);
    }
  }

  private deleteConditionalReference(node: any, props: any, condition: string, propName: string): void {
    if (!condition) return;

    try {
      const qbSid = JSON.parse(condition)?.sid;
      if (qbSid) {
        this.referencesTasks.deletedReference.push(
          this.util.createObjForDelRef(
            this.currentSelectedItem.sid,
            qbSid,
            propName,
            this.util.enrichAdInfo(
              { menu: node.data?.id, path: this.screensReferenceService.getAdditionalPath(node) },
              { props: props, node: node }
            )
          )
        );
      }
    } catch {
      // swallow JSON parse errors silently
    }
  }

  private deleteConditionalEditViewReferences(node: any, props: any): void {
    if (props?.allowEditing === 'conditional') {
      this.deleteConditionalReference(node, props, props?.allowEditingCondition, utilEnum.propertyName.EDIT_CONDITIONAL);
    }
    if (props?.allowViewing === 'conditional') {
      this.deleteConditionalReference(node, props, props?.allowViewingCondition, utilEnum.propertyName.VIEW_CONDITIONAL);
    }
  }

  // Handle deletion of standard datagrid and its references
  handleStandardDatagridDeletion(node) {
    this.saveFancyTree('deletescreenid', node.data.id);
    this.referencesTasks.deletedReference.push(
      this.util.createObjForDelRef(
        this.currentSelectedItem.sid,
        node.data.id,
        this.screensReferenceService.getPropName(node.type.toLowerCase())
      )
    );

    const standardGridProps = node.data?.properties;
    if (standardGridProps) {
      this.deleteParameterMappingReferences(node, standardGridProps);
      this.deleteConditionalEditViewReferences(node, standardGridProps);
    }

    this.pageSection.deletedPageSections = [...this.pageSection.deletedPageSections, node.data.key];
  }

  private deleteParameterMappingRefs(props: any, node: any) {
    const stdGridConfigurationId = node.data?.properties?.stdGridConfigurationId;
    const mappings = [
      { data: props?.parameterMapping, name: 'parameterMapping' },
      { data: props?.parameterMappingPageVariables, name: 'parameterMappingPageVariables' }
    ];
    mappings.forEach(({ name, data }) => {
      if (!data) return;
      const baseAdInfo = this.util.updateAdInfoForMapping(
        { menu: node?.data?.id },
        'listField',
        name
      );
      this.screensReferenceService.createOrDelRefForMapping(data, null, name, node, 'listField', baseAdInfo, undefined, stdGridConfigurationId);
      this.screensReferenceService.createOrDelRefForMapping(data, null, name, node, 'detailField', this.util.updateAdInfoForMapping(baseAdInfo, 'detailField', name), undefined, stdGridConfigurationId);
    });
  }

  private deleteConditionalEditViewRefs(props: any, node: any) {
    const conditions = [
      {
        flag: props?.allowEditing,
        condition: props?.allowEditingCondition,
        propName: utilEnum.propertyName.EDIT_CONDITIONAL
      },
      {
        flag: props?.allowViewing,
        condition: props?.allowViewingCondition,
        propName: utilEnum.propertyName.VIEW_CONDITIONAL
      }
    ];
    conditions.forEach(({ flag, condition, propName }) => {
      if (flag !== 'conditional' || !condition) {
        return;
      }
      const qbSid = this.parseConditionSid(condition);
      if (!qbSid) {
        return;
      }
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          qbSid,
          propName,
          this.util.enrichAdInfo(
            { menu: node.data?.id, path: this.screensReferenceService.getAdditionalPath(node) },
            { props, node }
          )
        )
      );
    });
  }

  private parseConditionSid(condition: string): string | null {
    try {
      return JSON.parse(condition)?.sid || null;
    } catch {
      return null;
    }
  }

  // Handle deletion of query view and its references
  handleQueryViewDeletion(node) {
    this.saveFancyTree('deletescreenid', node.key);
    const queryViewConfigurationId = node.data?.properties?.queryViewConfigurationId;
    this.referencesTasks.deletedReference.push(
      this.util.createObjForDelRef(
        this.currentSelectedItem.sid,
        node.key,
        this.screensReferenceService.getPropName(node.type.toLowerCase()),
        undefined,
        undefined,
        undefined,
        queryViewConfigurationId
      )
    );
    if (node.data?.properties) {
      const querMappingProps = node.data?.properties;
      if (querMappingProps?.queryViewMapping) {
        this.screensReferenceService.createOrDelRefForMapping(
          querMappingProps?.queryViewMapping,
          null,
          'queryViewMapping',
          node,
          'lookupField',
          undefined,
          undefined,
          queryViewConfigurationId,
          this.getReferenceContext()
        );
        this.screensReferenceService.createOrDelRefForMapping(
          querMappingProps?.queryViewMapping,
          null,
          'queryViewMapping',
          node,
          'tableField',
          undefined,
          undefined,
          queryViewConfigurationId,
          this.getReferenceContext()
        );
      }
      if (querMappingProps?.queryViewMappingPageVariables) {
        this.screensReferenceService.createOrDelRefForMapping(
          querMappingProps?.queryViewMappingPageVariables,
          null,
          'queryViewMappingPageVariables',
          node,
          'lookupField',
          undefined,
          undefined,
          queryViewConfigurationId,
          this.getReferenceContext()
        );
        this.screensReferenceService.createOrDelRefForMapping(
          querMappingProps?.queryViewMappingPageVariables,
          null,
          'queryViewMappingPageVariables',
          node,
          'tableField',
          undefined,
          undefined,
          queryViewConfigurationId,
          this.getReferenceContext()
        );
      }
      if (querMappingProps?.parameterMappingForQueryList) {
        const baseAdInfo = this.util.updateAdInfoForMapping(
          { menu: node.data?.id },
          'listField',
          'parameterMappingForQueryList'
        );
        this.screensReferenceService.createOrDelRefForMapping(
          querMappingProps?.parameterMappingForQueryList,
          null,
          'parameterMappingForQueryList',
          node,
          'listField',
          baseAdInfo,
          undefined,
          queryViewConfigurationId
        );
        this.screensReferenceService.createOrDelRefForMapping(
          querMappingProps?.parameterMappingForQueryList,
          null,
          'parameterMappingForQueryList',
          node,
          'detailField',
          this.util.updateAdInfoForMapping(baseAdInfo, 'detailField', 'parameterMappingForQueryList'),
          undefined,
          queryViewConfigurationId
        );
      }
    }
  }

  //Handle Button and its properties reference deletion on delete node
  handleButtonDeletion(node) {
    const btnProps = node.data?.properties;
    if (btnProps?.pageName) {
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          btnProps?.pageName?.sid,
          utilEnum.propertyName.NAVIGATION_PAGE,
          { menu: node.data.id }
        )
      );
    }
    if (btnProps?.service) {
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          btnProps?.service?.sid,
          utilEnum.propertyName.SERVICE,
          { menu: node.data.id }
        )
      );
      if (btnProps?.service.apiGroupId) {
        this.referencesTasks.deletedReference.push(
          this.util.createObjForDelRef(
            this.currentSelectedItem.sid,
            btnProps?.service?.apiGroupId,
            utilEnum.propertyName.APIGROUP_SERVICE_BUTTON,
            { menu: node.data.id }
          )
        );
      }
    }
    if (btnProps?.fields?.length) {
      btnProps?.fields?.split(',')?.forEach((sid) => {
        this.referencesTasks.deletedReference.push(
          this.util.createObjForDelRef(this.currentSelectedItem.sid, sid, utilEnum.propertyName.PAGE_FIELDS, {
            menu: node.data.id
          })
        );
      });
    }
    if (btnProps?.navigatePageValueMapping) {
      this.screensReferenceService.createOrDelRefForMapping(
        btnProps?.navigatePageValueMapping,
        null,
        'navigatePageValueMapping',
        node,
        'sourceKey',
        { menu: node.data?.id },
        undefined,
        undefined,
        this.getReferenceContext()
      );
      this.screensReferenceService.createOrDelRefForMapping(
        btnProps?.navigatePageValueMapping,
        null,
        'navigatePageValueMapping',
        node,
        'targetKey',
        { menu: node.data?.id },
        undefined,
        undefined,
        this.getReferenceContext()
      );
    }
    if (btnProps?.action && btnProps.action.includes('-')) {
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          btnProps?.action,
          utilEnum.propertyName.PAGE_ACTION,
          { menu: node.data.id }
        )
      );
    }
  }

  // Process node children BEFORE node.remove() for groups
  processNodeChildrenBeforeDeletion(node) {
    const nodeType = node.type.toLowerCase();

    // Handle menu/tab groups - process children first
    if ((nodeType === 'menugroup' || nodeType === 'menu_group' || nodeType === 'tabgroup') && node.children) {
      node.children.forEach((childNode) => {
        const childNType = childNode.type.toLowerCase();
        if (childNType == 'menugroup' || childNType === 'menu_group' || childNType === 'tabgroup') {
          this.processNodeChildrenBeforeDeletion(childNode);
        } else {
          this.handlePageAndRoleDeletion(childNode);
        }
      });
    }

    // Handle button groups - process children first
    if (nodeType === 'buttongroup' && node.children) {
      node.children.forEach((childNode) => {
        if (childNode.type.toLowerCase() === 'button') {
          this.updateConditonalRef(childNode);
          this.handleButtonDeletion(childNode);
        }
      });
    }
  }

  deleteNode(node, action, options, fromCommand) {
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    let removeFromNodeOnly = false;
    let selectedNodes = tree.getSelectedNodes();
    const currentNodeinList = selectedNodes.some((e) => e.data.id === node.data.id);
    if (selectedNodes.length === 0 || !currentNodeinList) {
      // Hack :since multi select is enabled on right click previous node is not getting deactivated and wrong node is getting deleted
      selectedNodes = [node];
    }
    switch (node.type.toLowerCase()) {
      case 'gridcolumn':
      case 'formfield':
      case 'menuitem':
      case 'menu_item':
      case 'tabview':
      case 'tab':
      case 'formsection':
      case 'button':
      case 'captionitem':
        removeFromNodeOnly = true;
        break;
      default:
        break;
    }
    //update fieldids for screen if the field node is removed from form/grid/advsearc/quickfilter
    if (
      (node.type.toLowerCase() === 'formsection' && node.children) ||
      (node.type.toLowerCase() === 'tab' && node.children) ||
      (node.type.toLowerCase() === 'tabview' && node.children) ||
      node.type.toLowerCase() === 'gridcolumn' ||
      node.type.toLowerCase() === 'formfield' ||
      node.type.toLowerCase() === 'captionitem' ||
      node.type.toLowerCase() === 'searchfield' ||
      node.type.toLowerCase() === 'filterfield'
    ) {
      this.updateConfigAfterDelete(node, selectedNodes);
      if (node.type.toLowerCase() === 'gridcolumn') {
        if (node.data?.properties) {
          if (node.data.properties?.gridColumnDetailPage) {
            this.referencesTasks.deletedReference.push(
              this.util.createObjForDelRef(
                this.currentSelectedItem.sid,
                node.data.properties.gridColumnDetailPage.sid,
                this.screensReferenceService.getPropName('gridColumnDetailPage'),
                { menu: node.data?.id }
              )
            );
            const holdValMap = node.data?.properties?.holdValueParams;
            if (holdValMap) {
              this.screensReferenceService.createOrDelRefForMapping(
                holdValMap,
                null,
                'holdValueParams',
                node,
                'detailField',
                {
                  menu: node?.data?.id
                },
                undefined,
                undefined,
                this.getReferenceContext()
              );
              this.screensReferenceService.createOrDelRefForMapping(
                holdValMap,
                null,
                'holdValueParams',
                node,
                'listField',
                {
                  menu: node?.data?.id
                },
                undefined,
                undefined,
                this.getReferenceContext()
              );
            }
            const detViewMap = node.data?.properties?.detailPageMapping;
            if (detViewMap) {
              this.screensReferenceService.createOrDelRefForMapping(
                detViewMap,
                null,
                'detailViewParams',
                node,
                'tableField',
                {
                  menu: node?.data?.id
                },
                undefined,
                undefined,
                this.getReferenceContext()
              );
              this.screensReferenceService.createOrDelRefForMapping(
                detViewMap,
                null,
                'detailViewParams',
                node,
                'lookupField',
                {
                  menu: node?.data?.id
                },
                undefined,
                undefined,
                this.getReferenceContext()
              );
            }
          }
        }
      }
    }
    if (selectedNodes.length) {
      selectedNodes.map((node: any) => {
        const nodeType = node.type.toLowerCase();

        if (
          nodeType === 'buttongroup' ||
          nodeType === 'button' ||
          nodeType === 'formsection' ||
          nodeType === 'tab' ||
          nodeType === 'tabview' ||
          nodeType === 'menugroup' ||
          nodeType === 'menu_group' ||
          nodeType === 'menuitem' ||
          nodeType === 'menu_item' ||
          nodeType === 'tabgroup' ||
          nodeType === 'tabitem' ||
          nodeType === 'hometile' ||
          node.type === 'custombutton'
        ) {
          this.pageSection.deletedPageSections = [...this.pageSection.deletedPageSections, node.data.id];
        }

        // selected node is cleaned up, not just the originally right-clicked node.
        if (nodeType === 'tab') {
          const tabParent = node.parent?.title?.toLowerCase();
          if (tabParent && this.tabTitles[tabParent]) {
            const index = this.tabTitles[tabParent].indexOf(node.title.toLowerCase());
            if (index > -1) {
              this.tabTitles[tabParent].splice(index, 1);
            }
          }
        } else if (nodeType === 'tabview') {
          const index = this.tabViewTitles.indexOf(node.title.toLowerCase());
          if (index > -1) {
            this.tabViewTitles.splice(index, 1);
          }
          delete this.tabTitles[node.title.toLowerCase()];
        }

        // update children ids for groups
        this.processNodeChildrenBeforeDeletion(node);

        //update customcomponentids for screen if the customComponent is deleted
        if (nodeType === 'customcomponent') {
          this.saveFancyTree('customComponentdelete', node.key);
          this.referencesTasks.deletedReference.push(
            this.util.createObjForDelRef(
              this.currentSelectedItem.sid,
              node.key,
              this.screensReferenceService.getPropName(nodeType)
            )
          );
        }
        //update screenIds for screen if the menu/tab/hometile item is deleted
        else if (
			node.type.toLowerCase() === 'menuitem' ||node.type.toLowerCase() === 'menu_item' ||
          node.type.toLowerCase() === 'tabitem' ||
          node.type.toLowerCase() === 'hometile'
        ) {
          this.handlePageAndRoleDeletion(node);
        }
        //update screenIds for screen if the menugrp/tabgrp item is deleted (children already processed above)
        else if (nodeType === 'menugroup' || nodeType === 'menu_group' || nodeType === 'tabgroup') {
          this.handlePageAndRoleDeletion(node);
        }
        //update screenIds for screen if the child table is deleted
        else if (nodeType === 'childlist') {
          this.saveFancyTree('deletescreenid', node.key);
          this.referencesTasks.deletedReference.push(
            this.util.createObjForDelRef(
              this.currentSelectedItem.sid,
              node.key,
              this.screensReferenceService.getPropName(nodeType)
            )
          );
          this.pageModalEvents.push({ modelId: node.key, event: ModelEventType.EMBEDDED_LIST_PAGE_REMOVED });
        }
        // Handle query view deletion
        else if (nodeType === 'queryview') {
          this.handleQueryViewDeletion(node);
          this.pageModalEvents.push({ modelId: node.key, event: ModelEventType.EMBEDDED_LIST_PAGE_REMOVED });
        }
        // Handle standard datagrid deletion
        else if (nodeType === 'standarddatagrid') {
          this.handleStandardDatagridDeletion(node);
          this.pageModalEvents.push({ modelId: node.data.id, event: ModelEventType.EMBEDDED_LIST_PAGE_REMOVED });
        }
        // Handle button deletion
        else if (nodeType === 'button') {
          this.updateConditonalRef(node);
          this.handleButtonDeletion(node);
        }
      });
      // Remove all selected nodes and reverse the order so parent removal doesn't invalidate child references.
      [...selectedNodes].reverse().forEach((n: any) => n.remove());
      this.saveFancyTree('deleteNode');
      this.debounceSaveTree('deleteNode');
    } else if (node.data) {
      if (removeFromNodeOnly) {
        node.remove();
        this.saveFancyTree('deleteNode');
        this.debounceSaveTree('deleteNode');
        return;
      }
    }
    /* Empty the properties pane after deleting the node */
    this.store.dispatch(setPropertiesData({ propertiesData: null }));
  }

  removeConfiguredFields(fi, ids, nodeType, sameTypNodes) {
    const config = JSON.parse(fi?.configuredFields?.config || '{}') || {};
    let idString = '';
    ids.map((id) => {
      idString += `${id},`;
    });
    if (nodeType === 'grid') {
      config.tbl = config?.tbl?.filter((el) => !ids.includes(el));
    } else if (nodeType === 'form') {
      config.form = config?.form?.filter((el) => !ids.includes(el));
    } else if (nodeType === 'searchField') {
      config.searchField = config?.searchField?.filter((el) => !ids.includes(el));
    } else if (nodeType === 'quickFilter') {
      config.quickFilter = config?.quickFilter?.filter((el) => !ids.includes(el));
    } else if (nodeType === 'tableSearch') {
      config.tableSearch = config?.tableSearch?.filter((el) => !ids.includes(el));
    } else if (nodeType === 'captionBar') {
      config.captionBar = config?.captionBar?.filter((el) => !ids.includes(el));
    }

    const dataToSend = { ...fi?.configuredFields };
    dataToSend.config = JSON.stringify(config);
    this.waitForCongFlsRes = true;
    let fieldSids: any[] = [];
    const keys = Object.keys(config);
    keys.forEach((key) => {
      if (Array.isArray(config[key])) {
        fieldSids = [...fieldSids, ...config[key]];
      }
    });
    const uniqFldSids = uniq(fieldSids);
    this.screensResData = { ...this.screensResData, ...{ fieldIds: uniqFldSids } };
    sameTypNodes.map((node: any) => {
      this.removeNodeFromValidationService(node);
      if (node && node?.parent) {
        node.remove();
      }
    });
    this.dmConfig = dataToSend;
    sameTypNodes.map((node: any) => {
      if(node.parent){ // to avoid error in case of already deleted node
        node?.remove();
      }
    });
    this.saveFancyTree('deleteNode');
    this.debounceSaveTree('deleteNode');
  }

  getConfigFields(sameTypNodes, nodeType, idsToRemove, nodeToRemove) {
    this.isLoadingScreens = true;
    this.store.dispatch(setFieldsInfoForTable({ fieldsInfo: [] }));
    const getFIApiConstants = this.isFromModernize
      ? { ...ApiConstants.getFieldForPagesInterim }
      : { ...ApiConstants.getFieldForPages };
    const tableId = this.currentSelectedItem.tableId;
    const screenId = this.currentSelectedItem.sid;
    if (this.isFromModernize) {
      getFIApiConstants.url = `${getFIApiConstants.url}${screenId}/${tableId}`;
    } else {
      getFIApiConstants.url = `${getFIApiConstants.url}${tableId}/${screenId}/${this.appId}`;
    }
    // send queryparam as element to get searchable fields for both sql and nosql
    let qp = '';
    switch (nodeType) {
      case 'searchField':
      case 'tableSearch':
        qp = 'tablesearch';
        break;
      case 'quickFilter':
        qp = 'quickfilter';
        break;
    }
    if (qp) {
      let queryParams = new HttpParams();
      queryParams = queryParams.append('element', qp);
      getFIApiConstants.url = `${getFIApiConstants.url}?${queryParams}`;
    }
    this.store.dispatch(
      getFieldsInfoForTable({
        getFIApiConstants
      })
    );
    let fiForSelectScreen;
    fiForSelectScreen = this.store.select(fiForSelectedScreen).subscribe((fi: any) => {
      if (fi?.configuredFields) {
        if (idsToRemove?.length) {
          for (const node in idsToRemove) {
            this.removeConfiguredFields(fi, idsToRemove, nodeToRemove, sameTypNodes);
          }
        }
        if (fiForSelectScreen) {
          fiForSelectScreen.unsubscribe();
        }
      }
    });
    this.unSubList.fisub = fiForSelectScreen;
    this.addToSubscriptionsList(fiForSelectScreen);
  }

  getIdsToRemove(idsToRemove, node) {
    if (node.children && node.children.length) {
      node.children.forEach((_node: any) => {
        if (_node.type.toLowerCase() === 'formfield') {
          idsToRemove.push(_node.key ? _node.key : _node.data.id);
        } else if (_node.children && _node.children.length) {
          this.getIdsToRemove(idsToRemove, _node);
        }
      });
    }
    return idsToRemove;
  }

  removeReferenceOnFieldDel(id, nodeType) {
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    const nodeToDel = tree.getNodeByKey(id);
    this.referencesTasks.deletedReference.push({
      sid: this.util.constructSidForRef({
        appId: this.appId,
        modelId: this.currentSelectedItem.sid,
        referredAppId: nodeToDel?.data?.properties?.fkId ? nodeToDel?.data?.properties?.fkAppId : this.appId,
        referredModelId: id,
        propertyName: this.screensReferenceService.getPropName(nodeType)
      })
    });
    if (nodeToDel?.data?.properties) {
      const lkConfig = nodeToDel.data.properties?.lookupConfiguration;
      const adInfo = this.util.enrichAdInfo(
        { menu: nodeToDel.data?.id },
        {
          props: nodeToDel.data?.properties,
          detailPageId: nodeToDel.data?.properties?.detailPage?.sid || this.currentSelectedItem?.sid,
          lookupConfig: lkConfig
        }
      );
      if (lkConfig?.lookupToForeignkey) {
        const fk = this.foreignKeys?.find((d) => d.sid === lkConfig?.lookupToForeignkey);
        this.referencesTasks.deletedReference.push(
          this.util.createObjForDelRef(
            this.currentSelectedItem.sid,
            lkConfig?.lookupToForeignkey,
            utilEnum.propertyName.LOOKUP_TO_FOREIGN_KEY,
            this.util.updateAdInfoForLookup(adInfo, 'LOOKUP_TO_FOREIGNKEY'),
            undefined,
            fk?.appId
          )
        );
      }
      if (lkConfig?.lookupToQueryView) {
        this.referencesTasks.deletedReference.push(
          this.util.createObjForDelRef(
            this.currentSelectedItem.sid,
            lkConfig?.lookupToQueryView,
            utilEnum.propertyName.LOOKUP_TO_QUERY_VIEW,
            this.util.updateAdInfoForLookup({ ...adInfo, menu: nodeToDel.data?.id }, 'LOOKUP_TO_QUERYVIEW'),
            undefined,
            lkConfig?.appId ? lkConfig.appId : this.appId
          )
        );
      }
      if (lkConfig?.lookupDefinition) {
        this.referencesTasks.deletedReference.push(
          this.util.createObjForDelRef(
            this.currentSelectedItem.sid,
            lkConfig?.lookupDefinition,
            utilEnum.propertyName.LOOKUP_DEFINITION,
            this.util.updateAdInfoForLookup({ ...adInfo, menu: nodeToDel.data?.id }, 'LOOKUP_DEFINITION'),
            undefined,
            lkConfig?.appId ? lkConfig.appId : this.appId
          )
        );
        this.screenLookupDefinitionDetails = [
          {
            lookupDefinitionId: lkConfig.lookupDefinition,
            referredAppId: lkConfig?.appId ? lkConfig.appId : this.appId,
            referredTableId: lkConfig?.tableId,
            action: GlobalConstants.delete
          }
        ];
        this.referencesTasks.deletedReference.push(
          this.util.createObjForDelRef(
            this.currentSelectedItem.sid,
            lkConfig?.lookupDefinition,
            utilEnum.propertyName.LOOKUP_DEFINITION,
            { menu: nodeToDel.data?.id }
          )
        );
      }
      if (lkConfig?.outputMapping) {
        this.screensReferenceService.createOrDelRefForMapping(
          lkConfig?.outputMapping,
          null,
          'outputMapping',
          nodeToDel,
          'tableField',
          this.util.updateAdInfoForLookup(adInfo, 'tableField', 'outputMapping'),
          undefined,
          undefined,
          this.getReferenceContext()
        );
        this.screensReferenceService.createOrDelRefForMapping(
          lkConfig?.outputMapping,
          null,
          'outputMapping',
          nodeToDel,
          'lookupField',
          this.util.updateAdInfoForLookup(adInfo, 'lookupField', 'outputMapping'),
          undefined,
          undefined,
          this.getReferenceContext()
        );
      }
      if (lkConfig?.inputMapping && lkConfig?.lookupType === lookupTypes.QUERY_VIEW) {
        this.screensReferenceService.createOrDelRefForMapping(
          lkConfig?.inputMapping,
          null,
          'inputMapping',
          nodeToDel,
          'tableField',
          this.util.updateAdInfoForLookup(adInfo, 'tableField', 'inputMapping'),
          undefined,
          undefined,
          this.getReferenceContext()
        );
        this.screensReferenceService.createOrDelRefForMapping(
          lkConfig?.inputMapping,
          null,
          'inputMapping',
          nodeToDel,
          'lookupField',
          this.util.updateAdInfoForLookup(adInfo, 'lookupField', 'inputMapping'),
          undefined,
          undefined,
          this.getReferenceContext()
        );
      }
      if (lkConfig?.executeOn && lkConfig?.lookupType === lookupTypes.QUERY_VIEW) {
        this.screensReferenceService.createOrDelRefForExecuteOnEventFlds(
          lkConfig?.executeOn,
          null,
          nodeToDel,
          this.util.updateAdInfoForLookup(adInfo, 'EXECUTE_ON_MAPPING'),
          this.getReferenceContext()
        );
      }
    }
  }

  updateConfigAfterDelete(node: any, selectedNodes: any) {
    const nodeType = node.type.toLowerCase();
    let nodeToRemove = '';
    const sameTypNodes = selectedNodes.filter((node) => {
      return node.type.toLowerCase() === nodeType;
    });
    let idsToRemove = sameTypNodes.map((_node: any) => {
      return _node.key ? _node.key : _node.data.id;
    });
    switch (nodeType) {
      case 'gridcolumn':
        nodeToRemove = 'grid';
        break;
      case 'formfield':
        nodeToRemove = 'form';
        break;
      case 'captionitem':
        nodeToRemove = 'captionBar';
        break;
      case 'searchfield':
        nodeToRemove = 'tableSearch';
        break;
      case 'filterfield':
        nodeToRemove = 'quickFilter';
        break;
      case 'formsection':
        idsToRemove = [];
        nodeToRemove = 'form';
        if (node.children && node.children.length) {
          idsToRemove = this.getIdsToRemove([], node);
        }
        break;
      case 'tabview':
      case 'tab':
        idsToRemove = [];
        nodeToRemove = 'form';
        if (node.children && node.children.length) {
          idsToRemove = this.getIdsToRemove([], node);
        }
        break;
    }
    idsToRemove = this.updateIdsAndConfigFields(node, sameTypNodes, nodeType, idsToRemove, nodeToRemove);
    if (idsToRemove && idsToRemove?.length != 0) {
      idsToRemove.forEach((id) => {
        this.removeReferenceOnFieldDel(id, nodeType);
      });
    }
  }
  updateIdsAndConfigFields(node, sameTypNodes, nodeType, idsToRemove, nodeToRemove) {
    if (node.children && node.children.length) {
      idsToRemove = this.getIdsToRemove([], node);
    }
    if (idsToRemove.length === 0) {
      return;
    }
    this.getConfigFields(sameTypNodes, nodeType, idsToRemove, nodeToRemove);

    return idsToRemove;
  }
  createFields(e: any, type) {
    const formObj = this.appForm.getRawValue();
    this.appForm = new FormGroup({
      name: new FormControl('')
    });
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    let node = tree.getActiveNode();
    if (!node) {
      node = this.currNode;
    }
    let fields: string[];
    if (!formObj.name) {
      this.currNode = null;
      this.errorFlag = false;
      this.errorMessage = '';
      this.errorFlag = true;
      this.errorMessage = 'Please fill Mandatory Field';
      return;
    }
    const name = formObj.name.trim();
    fields = name.split(',');
    const children: any[] = [];
    const errorfields: any[] = [];
    const nodeTypeName = startCase(camelCase(type || 'Item'));
    fields.forEach((e) => {
      const title = e.trim().replace(/\s\s+/g, ' ');
      const myRe = RegexPatternConstants.alphanumericNameWithUnderscore;
      const array = myRe.exec(title);
      if (!array) {
        errorfields.push(title);
        this.showMessage(
          'error',
          this.translate.instant('ALPHANUMERIC_CHARACTERS_ALLOWED_ITEMS', {
            titles: errorfields,
            nodeType: nodeTypeName
          })
        );
        return;
      }
      const id = uuidv4();
      /* that.currNode.editCreateNode("over", {
        title: e,
        type: "MENU_ITEM",
        id: id,
        new: true,
        key: id
      }); */
      let nodeObj: any = {
        title: e.trim(),
        type: type === 'menu' ? 'MENU_ITEM' : 'tabItem',
        id: id,
        new: true,
        key: id,
        data: {
          properties: {
            label: e.trim(),
                accessControl: this.isFromModernize ? ['all'] : [this.allRoles?.find((role) => role.name === 'App Admin')?.sid].filter(Boolean),
                      ...(this.isFromModernize && type === 'menu' ? { onClick: 'navigate_to_page' } : {}),
            ...(type === 'menu' && {
              icon: {
                icon: {
                  label: 'grid-01',
                  value: 'grid-01.svg'
                },
                iconColor: '#000000',
                iconSize: '13px',
                type: utilEnum.IconType.SYSTEM_ICON
              }
            })
          }
        }
      };
      // Assign HTML properties (dataKey, elementId, styleClass) with siblings context for deduplication
      nodeObj = this.assignHtmlPropsToNodeWithSiblings(nodeObj, node, children);
      this.pageSection.createdPageSectionMap = { ...this.pageSection.createdPageSectionMap, ...{ [id]: e.trim() } };
      children.push(nodeObj);
    });
    node.addChildren(children);
    node.setExpanded();
    if (errorfields.length > 0) {
      this.appForm.patchValue({ name: errorfields.join() });
      // Only keep modal open if NO valid items were created (all entries are invalid)
      if (children.length === 0) {
        return;
      }
    }
    // Reset form and close modal
    this.appForm = new FormGroup({
      name: new FormControl('')
    });
    this.showMenuPopup = false;
    this.showTabsPopup = false;
    this.saveFancyTree('createFields');
    this.debounceSaveTree('createFields');
  }

  /**
   * Creates a Tab View node with user-provided tab view name and tab names.
   * Handles the tabViewCreate event from the AddTabViewDialogComponent.
   * @param event - The event containing tabViewName and tabNames
   */
  onTabViewCreate(event: { tabViewName: string; tabNames: string[] }) {
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    let node = tree.getActiveNode();
    if (!node) {
      node = this.currNode;
    }

    const tabViewName = event.tabViewName;
    const tabViewNameLower = tabViewName.toLowerCase();
    const validTabNames = event.tabNames;

    // Create Tab View with tabs
    this.getDefaultValues('tabView');
    const tabViewId = uuidv4();

    const children: any[] = [];
    const tabTitlesForTracking: string[] = [];

    validTabNames.forEach((tabName: string) => {
      const tabId = uuidv4();
      this.getDefaultValues('tab');
      children.push({
        title: tabName,
        id: tabId,
        new: true,
        key: tabId,
        type: 'tab',
        folder: true,
        data: {
          properties: {
            ...this.formDefaultValues,
            label: tabName
          }
        }
      });
      this.pageSection.createdPageSectionMap = { ...this.pageSection.createdPageSectionMap, ...{ [tabId]: tabName } };
      tabTitlesForTracking.push(tabName.toLowerCase());
    });

    const OVER = 'over';
    const nodeConfig = {
      type: 'tabView',
      title: tabViewName,
      id: tabViewId,
      new: true,
      key: tabViewId,
      folder: true,
      children: children,
      data: {
        properties: this.formDefaultValues
      }
    };

    // Use addNode instead of editCreateNode to avoid entering edit mode
    const nodeWithHtmlProps = this.assignHtmlPropsToNode(nodeConfig, node);
    node.addNode(nodeWithHtmlProps, OVER);

    // Track tab view and tab titles
    this.tabViewTitles.push(tabViewNameLower);
    this.tabTitles[tabViewNameLower] = tabTitlesForTracking;
    this.pageSection.createdPageSectionMap = {
      ...this.pageSection.createdPageSectionMap,
      ...{ [tabViewId]: tabViewName }
    };

    // Expand and scroll to the created node
    setTimeout(() => {
      $.ui.fancytree.getTree(this.getTreeSelector()).activateKey(tabViewId).setExpanded();
      if (children.length > 0) {
        const lastChild = children[children.length - 1];
        const childNode = $.ui.fancytree.getTree(this.getTreeSelector()).getNodeByKey(lastChild.key);
        if (childNode) {
          childNode.makeVisible({ scrollIntoView: true });
        }
      }
      this.rearrageTreeLegIndicator(50);
    }, 100);

    // Close dialog and save
    this.showTabViewPopup = false;
    this.saveFancyTree('createTabView');
    this.debounceSaveTree('createTabView');
  }

  populateOptionSuffix(table) {
    if (
      this.activeScreen?.pageType === 'list' &&
      this.activeScreen?.pageTableType !== 'QUERY_VIEW' &&
      !table.searchable &&
      this.techStack?.textSearch == GlobalConstants.searchDbEs
    ) {
      return `${GlobalConstants.notSearchable}`;
    } else if (
      this.activeScreen?.pageType === 'list' &&
      this.activeScreen?.pageTableType !== 'QUERY_VIEW' &&
      !table.indexed &&
      this.techStack?.textSearch == GlobalConstants.searchDbRdbms
    ) {
      return `${GlobalConstants.notIndexed}`;
    }

    return '';
  }

  getAllProps() {
    this.handleNodeClick(null, { node: { type: 'any' } });
    const allPropSub = this.store.select(allPropertiesData).subscribe((props: any) => {
      if (props) {
        this.allProps = props;
      }
    });
    this.addToSubscriptionsList(allPropSub);
  }

  resetProperties() {
    this.store.dispatch(setPropertiesData({ propertiesData: null }));
    this.store.dispatch(setScreenValues({ screenValues: null }));
  }

  formPickListForListandDetailPages(tableId, pageType) {
    this.currentTableSid = tableId;
    const isRdbmsSearch = this.techStack?.textSearch === GlobalConstants.searchDbRdbms;
    const isElasticSearch = this.techStack?.textSearch === GlobalConstants.searchDbEs;

    // Check for non-QUERY_VIEW page types
    if (this.activeScreen?.pageTableType !== 'QUERY_VIEW') {
      // Fetch index data
      if (isRdbmsSearch) {
        const indexSub = this.bs
          .get(ApiConstants.getIndex, { appId: this.appId, orgId: this.orgId, tableId: this.currentTableSid })
          .subscribe({
            next: (indexData) => {
              if (indexData) {
                this.indexedFields = indexData?.map((item) => item.fields)?.flat();
              }
            },
            error: (err) => console.error('Error fetching index data:', err)
          });
        this.addToSubscriptionsList(indexSub);
      }

      // Fetch searchable fields (only for ElasticSearch)
      if (isElasticSearch) {
        if (this.activeScreen?.pageType == 'list') {
          const refTblSub = forkJoin({
            fields: this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId }) || [],
            referredTableFieldInfo:
              this.bs[ApiConstants.getSearchableFieldsByTableId.method](ApiConstants.getSearchableFieldsByTableId, {
                tableId: tableId
              }) || {},
            searchableFields: this.bs.get(ApiConstants.getSearchableIndexFields, { tableId }) || {}
          }).subscribe({
            next: ({ fields, referredTableFieldInfo, searchableFields }) => {
              const searchableData = this.util.getSearchableReferredTableFields(referredTableFieldInfo, tableId);
              const currentTableFields = Array.isArray(fields) ? fields : [];
              this.processFieldInfo(
                [
                  ...currentTableFields,
                  ...(Array.isArray(searchableData?.referredTableFields) ? searchableData.referredTableFields : [])
                ],
                searchableData?.searchableFields
              );
            },
            error: (e) => {
              console.log(e);
            }
          });
          this.addToSubscriptionsList(refTblSub);
        } else {
          const searchableFieldsSub = this.bs.get(ApiConstants.getSearchableIndexFields, { tableId }).subscribe({
            next: (searchableData) => {
              if (searchableData) {
                this.processSearchableFields(searchableData, tableId, pageType);
              }
            },
            error: (err) => console.error('Error fetching searchable fields:', err)
          });
          this.addToSubscriptionsList(searchableFieldsSub);
        }
      }
    }
    // Always fetch field info regardless of page type
    if (!isElasticSearch || this.activeScreen?.pageTableType === 'QUERY_VIEW') {
      const fieldInfoSub = this.bs.get(ApiConstants.getFieldInfo, { tableId }).subscribe({
        next: (fieldInfoData) => {
          if (fieldInfoData) {
            // Pass null for searchable fields when not ElasticSearch
            this.processFieldInfo(fieldInfoData, null);
          }
        },
        error: (err) => console.error('Error fetching field info:', err)
      });
      this.addToSubscriptionsList(fieldInfoSub);
    }
  }

  // Process searchable fields
  processSearchableFields(searchableData, tableId, pageType) {
    const searchableProp = searchableData;

    const fieldInfoSub = this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId }).subscribe({
      next: (data) => {
        this.processFieldInfo(data, searchableProp);
      }
    });
    this.addToSubscriptionsList(fieldInfoSub);
  }

  // Process field info and populate picklist
  processFieldInfo(data, searchableProp) {
    const isRdbmsSearch = this.techStack?.textSearch === GlobalConstants.searchDbRdbms;

    const picklist: any = {
      fields: [],
      tables: [],
      indexedFields: this.indexedFields || [],
      primaryFields: [],
      fieldsWithType: [],
      noImgFAFields: [],
      allFields: [],
      lookupFields: [],
      searchableFields: [],
      fieldsWithDetails: [],
      buttonFields: [],
      gridFields: [],
      transientFields: []
    };
    try {
      if (data) {
        const primaryFields = data
          .filter((fld) => {
            return (
              (fld.f_type.toLowerCase() === 'number' ||
                fld.f_type.toLowerCase() === 'string' ||
                fld.f_type.toLowerCase() === 'dropdown' ||
                fld.f_type.toLowerCase() === 'lookup' ||
                fld.f_type.toLowerCase() === 'datetime' ||
                fld.f_type.toLowerCase() === 'checkboxgroup' ||
                fld.f_type.toLowerCase() === 'checkbox' ||
                fld.f_type.toLowerCase() === 'currency' ||
                fld.f_type.toLowerCase() === 'date' ||
                fld.f_type.toLowerCase() === 'double' ||
                fld.f_type.toLowerCase() === 'email' ||
                fld.f_type.toLowerCase() === 'json' ||
                fld.f_type.toLowerCase() === 'radio' ||
                fld.f_type.toLowerCase() === 'color') &&
              !fld.f_hasMultiVal
            );
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        let fields;
        if (!isRdbmsSearch) {
          fields = data
            .filter((fld) => {
              return Object.values(searchableProp)?.some((prop) => prop === fld.sid);
            })
            .map((fld) => {
              return { sid: fld.sid, name: fld.name };
            });
        } else {
          fields = data.map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        }
        let buttonFields;
        buttonFields = data
          .filter((fld) => {
            return fld.f_sysF !== true;
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        let lookupFields;
        if (this.activeScreen?.pageType === 'detail') {
          lookupFields = data
            .filter((fld) => {
              return (
                (isRdbmsSearch || Object.values(searchableProp)?.some((prop) => prop === fld.sid)) &&
                !fld.f_hasMultiVal &&
                this.currentScreenFieldIds.includes(fld.sid) &&
                fld.f_type.toLowerCase() !== 'image carousel' &&
                fld.f_type.toLowerCase() !== 'file attachments' &&
                fld.f_type.toLowerCase() !== 'complex datatype'
              );
            })
            .map((fld) => {
              return { sid: fld.sid, name: fld.name };
            });
        } else if (this.activeScreen?.pageType === 'list') {
          lookupFields = data
            .filter((fld) => {
              return (
                (isRdbmsSearch || Object.values(searchableProp)?.some((prop) => prop === fld.sid)) &&
                !fld.f_hasMultiVal &&
                fld.f_type.toLowerCase() !== 'image carousel' &&
                fld.f_type.toLowerCase() !== 'file attachments' &&
                fld.f_type.toLowerCase() !== 'complex datatype'
              );
            })
            .map((fld) => {
              return { sid: fld.sid, name: fld.name };
            });
        }
        const noImgFAFields = data
          .filter((fld) => {
            return (
              fld.f_type.toLowerCase() !== 'image carousel' &&
              fld.f_type.toLowerCase() !== 'file attachments' &&
              fld.f_type.toLowerCase() !== 'checkboxgroup' &&
              fld.f_type.toLowerCase() !== 'complex datatype' &&
              !fld.f_sysF
            );
          })
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        const fieldsWithType = data.map((fld) => {
          return { sid: fld.sid, name: fld.name, type: fld.f_type };
        });
        picklist.noImgFAFields = noImgFAFields;
        picklist.fieldsWithType = fieldsWithType;
        picklist.fields = fields;
        picklist.lookupFields = lookupFields;
        picklist.primaryFields = primaryFields;
        picklist.allFields = data.map((fld) => {
          return { sid: fld.sid, name: fld.name };
        });
        this.cloneGridChildren = cloneDeep(this.gridChildrenFlds);
        picklist.searchableFields = data
          .filter(
            (fld) =>
              (isRdbmsSearch || Object.values(searchableProp)?.some((prop) => prop === fld.sid)) &&
              this.cloneGridChildren.find((f) => f.id == fld.sid)
          )
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
        picklist.fieldsWithDetails = [...data];
        picklist.buttonFields = buttonFields;
        picklist.gridFields = this.cloneGridChildren.map((fld) => {
          return { sid: fld.id, name: fld.label, fkTableSid: fld.fkTableSid, fkId: fld.fkId, fkAppId: fld.fkAppId };
        });
        picklist.transientFields = data
          .filter((fld) => fld.f_transientField)
          .map((fld) => {
            return { sid: fld.sid, name: fld.name };
          });
      }
      this.currentPicklist = { ...picklist };
      this.store.dispatch(propertyActions.setPickupProperties({ picklist }));
      this.store.dispatch(setFieldsForTable({ tblFields: data }));
    } catch (e) {
      console.error(e);
      this.store.dispatch(propertyActions.setPickupProperties({ picklist }));
    }
  }

  handleNodeClick(event: any, data: any, reload = false) {
    if (this.isPendingSave) {
      this.saveFancyTreeData();
    }
    // Optimization (RR2023-35463): Skip resetting properties and showing loaders during a silent reload
    // to prevent the UI from blinking after adding fields/columns.
    if (!reload) {
      this.resetProperties();
    }
    this.currentSelectedTreeNode = data.node;
    const fetchType = data.node.type;
    if (fetchType === 'grid' && data.node.children) {
      const children: any[] = [];
      data.node.children.map((child: any) => {
        children.push({
          id: child.key,
          label: this.fieldIdMap[child.key] || child.title,
          fkTableSid: child.data?.properties?.fkTableSid || null,
          fkId: child.data?.properties?.fkId || null,
          fkAppId: child.data?.properties?.fkAppId || null
        });
      });
      this.gridChildrenFlds = cloneDeep(children);
      this.store.dispatch(setCurrentNodeData({ curNodeData: this.gridChildrenFlds }));
    } else {
      this.store.dispatch(setCurrentNodeData({ curNodeData: null }));
    }

    this.getDefaultValues(fetchType);
    const apiConstants: any = {
      ...ApiConstants.getAppNavigationProperties,
      ...{
        fetchType
      },
      ...{
        screen: true
      }
    };
    // Optimization (RR2023-35463): Only trigger the global property loader if this is a fresh click,
    // not a data refresh after adding columns, to prevent UI flicker.
    if (!reload) {
      this.store.dispatch(triggerLoading({ triggerPropLoading: true }));
    }
    this.store.dispatch(getPropertiesData({ propPaneApiConstants: apiConstants }));

    /* Update label, data and field based on field Id. This is to handle rename */

    const _id = data.node.key;
    let newLabel = '';
    let newField = '';
    if (_id && this.fieldIdMap) {
      newLabel = this.fieldIdMap[_id];
      newField = camelCase(newLabel);
    }
    // Fallback to node title if fieldIdMap lookup fails (e.g., for fields added in modernize mode)
    if (!newLabel && data.node.title) {
      newLabel = data.node.title;
      newField = camelCase(newLabel);
    }

    let _properties = { ...this.formDefaultValues, ...data.node?.data?.properties };
    if (Object.prototype.hasOwnProperty.call(_properties, 'label') && _properties.label && newLabel) {
      _properties.label = _properties?.label ? _properties?.label : newLabel;
    }

    if (Object.prototype.hasOwnProperty.call(_properties, 'data') && newLabel) {
      _properties.data = newLabel;
    }

    if (Object.prototype.hasOwnProperty.call(_properties, 'field') && newField) {
      _properties.field = newField;
    }
    if (data.node.type === 'menuGroup' || data.node.type === 'MENU_GROUP') {
      this.iconSize = '18px';
    } else if (data.node.type === 'menuItem' || data.node.type === 'MENU_ITEM') {
      const parent = data.node?.parent;
      if (parent) {
        if (parent.type === 'leftMenu' || parent.type === 'APP_MENU') {
          this.iconSize = '18px';
        } else {
          this.iconSize = '16px';
        }
      }
    } else {
      this.iconSize = '13px';
    }
    if (Object.prototype.hasOwnProperty.call(_properties, 'groupOnColumn')) {
      const fname = _properties.groupOnColumn?.name;
      if (fname) {
        const newFname = this.fieldIdMap[_properties.groupOnColumn.sid];
        _properties.groupOnColumn = { ..._properties.groupOnColumn, ...{ name: newFname ? newFname : fname } };
      }
    }
    // update latest page name and page table type for page properties
    const pageProps = ['page', 'pageName', 'detailPage'];
    pageProps.forEach((pgPrp) => {
      if (Object.prototype.hasOwnProperty.call(_properties, pgPrp) && _properties[pgPrp]) {
        const pg = this.allSelectedScreens?.userGenScreens?.find((p) => p.sid === _properties[pgPrp]?.sid)
          || this.allSelectedScreens?.sysGenScreens?.find((p) => p.sid === _properties[pgPrp]?.sid);
        _properties[pgPrp] = {
          ..._properties[pgPrp],
          ...{ name: this.fieldIdMap[_properties[pgPrp].sid] || pg?.pageName},
          ...{ pageTableType: pg?.pageTableType ? pg.pageTableType : pageTableType.TRANSACTIONAL }
        };
      }
    });
    // update latest field name in sortOn
    if (_properties?.sortField) {
      _properties.sortField.name = this.fieldIdMap[_properties.sortField.sid];
    }
    _properties.infiniteScroll = !!_properties?.infiniteScroll;
    if (this.isRDBMS) {
      const fieldId = data?.node?.key;
      const isFK = this.foreignKeys.find((fk) => fk.mappings.find((m) => m.child === fieldId));
      if (isFK) {
        _properties = { ..._properties, ...{ type: 'foreignkey' } };
      } else {
        _properties = { ..._properties, ...{ type: null } };
      }
    }
    let pgIdForDefFiL;
    // Set both current (data source) and parent context ids
    this.qbService.setQueryBuilderContext({
      currentContextTableId: this.currentTableSid,
      parentContextTableId: this.currentTableSid
    });

    if (fetchType === 'standardDatagrid') {
      pgIdForDefFiL = data?.node?.data.id;
      this.qbService.setQueryBuilderContext({
        currentContextTableId: _properties?.standardGridTableId,
        parentContextTableId: this.currentTableSid
      });

      this.qbService.configureQueryBuilder(
        this.appUserTableId,
        _properties?.standardGridTableId,
        this.tableIdMap[_properties?.standardGridTableId]
      );
    } else if (fetchType === 'childList') {
      pgIdForDefFiL = data?.node?.data.id;
      this.qbService.setQueryBuilderContext({
        currentContextTableId: this.currentSelectedTreeNode?.data?.tableId,
        parentContextTableId: this.currentTableSid
      });

      this.qbService.configureQueryBuilder(
        this.appUserTableId,
        this.currentSelectedTreeNode?.data?.tableId,
        this.tableIdMap[this.currentSelectedTreeNode?.data?.tableId]
      );
    } else {
      this.qbService.configureQueryBuilder(this.appUserTableId, this.currentTableSid, this.currentTableName);
    }

    if (fetchType === 'gridColumn') {
      _properties = { ..._properties, ...{ pageTableType: this.currentSelectedItem.pageTableType } };
      if (
        Object.prototype.hasOwnProperty.call(_properties, 'gridColumnDetailPage') &&
        Object.prototype.hasOwnProperty.call(_properties.gridColumnDetailPage ?? {}, 'sid')
      ) {
        _properties.gridColumnDetailPage = {
          ..._properties.gridColumnDetailPage,
          ...{ name: this.tableIdMap[_properties?.gridColumnDetailPage?.sid] }
        };
      } else {
        _properties.gridColumnDetailPage = null;
      }
    }
    if (pgIdForDefFiL) {
      this.isLoadingScreens = true;
      const scrApi = this.isFromModernize ? ApiConstants.getScreenInterim : ApiConstants.getScrById;
      const scrParams = this.isFromModernize ? { screenSid: pgIdForDefFiL } : { sid: pgIdForDefFiL };
      const scrSub = this.bs.get(scrApi, scrParams).subscribe({
        next: (res: any) => {
          try {
            this.isLoadingScreens = false;
            const order = JSON.parse(res.contentAttachment);
            // Support both flat [pageView > children] and nested [page > pageView > children] structures
            const defFilSid = order[0]?.children[0]?.children[2]?.data?.properties?.defaultFilter
              ?? order[0]?.children[2]?.data?.properties?.defaultFilter;
            //page/pageview/table
            const gridNode = this.util.findNodeByKeyValue(order, 'type', 'grid');
            if (defFilSid && !_properties?.defaultFilter) {
              _properties = { ..._properties, ...{ defaultFilter: defFilSid } };
            }
          } catch (e) {
            console.error(e);
          }
          this.store.dispatch(
            setScreenValues({
              screenValues: {
                currentNode: data.node?.data?.id,
                screenValues: _properties
              }
            })
          );
        },
        error: (err: any) => {
          this.isLoadingScreens = false;
          this.store.dispatch(
            setScreenValues({
              screenValues: {
                currentNode: data.node?.data?.id,
                screenValues: _properties
              }
            })
          );
        }
      });
      this.addToSubscriptionsList(scrSub);
    } else {
      let currentNode = data.node?.data?.id;
      // use node.key for fields node because in old data, node.data.id and node.key is different
      if (
        fetchType === 'searchField' ||
        fetchType === 'filterField' ||
        fetchType === 'captionItem' ||
        fetchType === 'formField'
      ) {
        currentNode = data.node.key;
      }
      this.store.dispatch(
        setScreenValues({
          screenValues: {
            currentNode: currentNode,
            screenValues: _properties
          }
        })
      );
    }
    // get fields, tabledata, page variables for uitype queryMap
    if (fetchType === 'grid' ||
       (fetchType === 'gridColumn' &&
        this.activeScreen?.pageTableType === 'QUERY_VIEW' &&
        _properties?.gridColumnDetailPage) ||
      fetchType === 'queryView' ||
      fetchType === 'standardDatagrid' ||
      ((fetchType === 'button' || fetchType === 'customButton') && _properties?.pageName)
    ) {
      this.store.dispatch(setQueryMapData({ queryMapData: null }));
      this.getInfoForPagesOnNodeClick(_properties, fetchType, data);
    }
  }

  getInfoForPagesOnNodeClick(_properties, fetchType, data) {
    let apiCallSub;
    this.isLoadingScreens = true;
    const isRdbmsSearch = this.techStack?.textSearch === GlobalConstants.searchDbRdbms;
    const detailPage =
      this.allSelectedScreens?.userGenScreens?.find((screen) => screen.sid == _properties?.detailPage?.sid) ||
      this.allSelectedScreens?.sysGenScreens?.find((screen) => screen.sid == _properties?.detailPage?.sid);
    const navPage =
      this.allSelectedScreens?.userGenScreens?.find((screen) => screen.sid == _properties?.pageName?.sid) ||
      this.allSelectedScreens?.sysGenScreens?.find((screen) => screen.sid == _properties?.pageName?.sid);

    switch (fetchType) {
      // get query view table's data and list page content attachment
      // get current table and query view table fields and page variables
      case 'queryView':
        apiCallSub = forkJoin({
          fields: this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId }),
          queryViewtableData: this.bs.get(ApiConstants.getDatamodelTableData, {
            sid: _properties?.queryViewTableId
          }),
          queryViewFields: this.bs.get(ApiConstants.getFieldInfo, { tableId: _properties?.queryViewTableId }),
          queryviewScreenData: this.bs.get(ApiConstants.getScrById, { sid: data?.node?.data?.id }),
          pageVariables: this.bs.get(ApiConstants.getPageVariables, {
            orgId: this.activeScreen?.orgId,
            appId: this.appId,
            pageSid: this.activeScreen?.sid
          }),
          queryViewPageVariables: this.bs.get(ApiConstants.getPageVariables, {
            orgId: this.activeScreen?.orgId,
            appId: this.appId,
            pageSid: data?.node?.data?.id
          })
        });
        break;
      case 'standardDatagrid':
        // get current table and standard grid table fields and page variables
        // get standard grid's indexed fields if it is RDBMS Search app
        // get standard grid's searchable and related table fields if it is Elastic Search app
        if (isRdbmsSearch) {
          apiCallSub = forkJoin({
            fields: this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId }),
            dataGridFields: this.bs.get(ApiConstants.getFieldInfo, { tableId: _properties?.standardGridTableId }),
            indexedFields: this.bs.get(ApiConstants.getIndex, {
              appId: this.appId,
              orgId: this.orgId,
              tableId: _properties?.standardGridTableId
            }),
            pageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: this.activeScreen?.sid
            }),
            dataGridPageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: data?.node?.data?.id
            })
          });
        } else {
          apiCallSub = forkJoin({
            fields: this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId }),
            dataGridFields: this.bs.get(ApiConstants.getFieldInfo, { tableId: _properties?.standardGridTableId }),
            searchableData: this.bs.get(ApiConstants.getSearchableFieldsByTableId, {
              tableId: _properties?.standardGridTableId
            }),
            pageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: this.activeScreen?.sid
            }),
            dataGridPageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: data?.node?.data?.id
            })
          });
        }
        break;

      case 'gridColumn':
        // get current table and gridcolumn's detail page table's fields and page variables
        apiCallSub = forkJoin({
          fields: this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId }),
          detailPageFields: this.bs.get(ApiConstants.getFieldInfo, {
            tableId: _properties?.gridColumnDetailPage?.tableId
          }),
          pageVariables: this.bs.get(ApiConstants.getPageVariables, {
            orgId: this.activeScreen?.orgId,
            appId: this.appId,
            pageSid: this.activeScreen?.sid
          }),
          detailPageVariables: this.bs.get(ApiConstants.getPageVariables, {
            orgId: this.activeScreen?.orgId,
            appId: this.appId,
            pageSid: _properties.gridColumnDetailPage?.sid
          })
        });
        break;

      case 'grid':
        // Without detail page, transactional table - only current table fields are required
        // Without detail page, query table - current table fields, page variables, table data required for parameterMappingforQueryview
        let callsList: any = {
          fields: this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId })
        };
        if (this.activeScreen?.pageTableType === 'QUERY_VIEW') {
          callsList = {
            ...callsList,
            tableData: this.bs.get(ApiConstants.getDatamodelTableData, { sid: this.activeScreen?.tableId }),
            pageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: this.activeScreen?.sid
            })
          };
        }
        if (detailPage?.tableId) {
          // With detail page - current table fields, page variables are required for detail page parameters
          callsList = {
            ...callsList,
            detailPageFields: this.bs.get(ApiConstants.getFieldInfo, { tableId: detailPage?.tableId }),
            pageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: this.activeScreen?.sid
            }),
            detailPageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: _properties.detailPage?.sid
            })
          };

          // tableDate required if detail page is query view for detail page mapping
          if (detailPage?.pageTableType === 'QUERY_VIEW' && detailPage?.tableId !== this.activeScreen?.tableId) {
            callsList = {
              ...callsList,
              detailPagetableData: this.bs.get(ApiConstants.getDatamodelTableData, { sid: detailPage?.tableId })
            };
          }
        }

        // get indexed fields/ searchable fields(includes referred fields) for the list page
        if (isRdbmsSearch) {
          callsList = {
            ...callsList,
            indexedFields: this.bs.get(ApiConstants.getIndex, {
              appId: this.appId,
              orgId: this.orgId,
              tableId: this.activeScreen?.tableId
            })
          };
        } else {
          callsList = {
            ...callsList,
            searchableData: this.bs.get(ApiConstants.getSearchableFieldsByTableId, {
              tableId: this.activeScreen?.tableId
            })
          };
        }
        apiCallSub = forkJoin(callsList);
        break;

      case 'customButton':
      case 'button':
        let btncallsList = {};
        btncallsList = {
          ...btncallsList,
          ...{
            fields: this.bs.get(ApiConstants.getFieldInfo, { tableId: this.activeScreen?.tableId }),
            navigatedPageFields: this.bs.get(ApiConstants.getFieldInfo, { tableId: navPage?.tableId }),
            pageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: this.activeScreen?.sid
            }),
            navigatedPageVariables: this.bs.get(ApiConstants.getPageVariables, {
              orgId: this.activeScreen?.orgId,
              appId: this.appId,
              pageSid: _properties.pageName?.sid
            })
          }
        };

        // get referred table fields if the list page is used for navigation
        if (this.activeScreen?.pageTableType !== 'QUERY_VIEW' && this.activeScreen?.pageType === 'list') {
          btncallsList = {
            ...btncallsList,
            searchableListData: this.bs.get(ApiConstants.getSearchableFieldsByTableId, {
              tableId: this.activeScreen?.tableId
            })
          };
        }
        if (this.activeScreen?.pageTableType !== 'QUERY_VIEW' && navPage?.pageType === 'detail') {
          btncallsList = {
            ...btncallsList,
            searchableDetailData: this.bs.get(ApiConstants.getSearchableFieldsByTableId, {
              tableId: this.activeScreen?.tableId
            })
          };
        }
        apiCallSub = forkJoin(btncallsList);
        break;
    }
    const screenInfo = apiCallSub.subscribe({
      next: (value: any) => {
        let queryMap = cloneDeep(value);
        if (queryMap) {
          if (queryMap.indexedFields) {
            queryMap = {
              ...queryMap,
              ...{ indexedFields: queryMap.indexedFields?.map((item) => item.fields)?.flat() }
            };
            this.indexedFields = queryMap.indexedFields;
          }
          if (queryMap.searchableData) {
            const ListTableId = fetchType == 'grid' ? this.activeScreen?.tableId : _properties?.standardGridTableId;
            queryMap = {
              ...queryMap,
              ...this.util.getSearchableReferredTableFields(queryMap.searchableData, ListTableId)
            };
            this.processFieldInfo(
              [...queryMap.fields, ...(queryMap?.referredTableFields || [])],
              queryMap.searchableFields
            );
          } else if (fetchType == 'grid') {
            this.processFieldInfo(queryMap.fields, null);
          }
          if (queryMap.searchableListData) {
            const fieldInfo = this.util.getSearchableReferredTableFields(
              queryMap.searchableListData,
              this.activeScreen?.tableId
            );
            queryMap = {
              ...queryMap,
              ...{
                searchableFields: fieldInfo.searchableFields,
                referredSrcTableFields: fieldInfo.referredTableFields
              }
            };
          }
          if (queryMap.searchableDetailData) {
            const fieldInfo = this.util.getSearchableReferredTableFields(
              queryMap.searchableDetailData,
              navPage?.tableId
            );
            queryMap = {
              ...queryMap,
              ...{
                searchableFields: fieldInfo.searchableFields,
                referredDetTableFields: fieldInfo.referredTableFields
              }
            };
          }
          this.isLoadingScreens = false;
          this.store.dispatch(setQueryMapData({ queryMapData: queryMap }));
        }
        if (screenInfo) {
          screenInfo.unsubscribe();
        }
      },
      error: (e) => {
        this.isLoadingScreens = false;
        console.log(e);
      }
    });
    this.addToSubscriptionsList(screenInfo);
  }

  processTreeData(d) {
    const data: any[] = [];
    if (d.title === 'root') {
      d.children.forEach((element) => {
        data.push(element);
      });
    }
    return data;
  }

  /**
   * Gets the current tree structure as an array of ScreenNode objects.
   * Used for identifier validation and generation.
   * @returns Array of ScreenNode objects representing the current tree
   */
  getCurrentTreeNodes(): ScreenNode[] {
    try {
      const tree = $.ui.fancytree.getTree(this.getTreeSelector());
      if (tree) {
        const d = tree.toDict(true);
        return this.processTreeData(d) as ScreenNode[];
      }
    } catch (e) {
      console.warn('Could not get tree nodes:', e);
    }
    return [];
  }

  /**
   * Assigns Html Properties (identifier and styleClass) to a node object before it's added to the tree.
   * Delegates to IdentifierService for context-aware generation.
   *
   * @param nodeObj - The node object to assign identifier to
   * @param parentNode - Optional parent node (used to determine prefix for page-level nodes)
   * @returns The node object with identifier and styleClass assigned
   */
  assignHtmlPropsToNode(nodeObj: any, parentNode?: any): any {
    const currentNodes = this.getCurrentTreeNodes();
    return this.identifierService.assignHtmlPropsToNode(nodeObj, currentNodes, parentNode);
  }

  /**
   * Assigns Html Properties to a node, including already-processed siblings for deduplication.
   * Used when creating multiple nodes in a batch (e.g., Add Child Menus).
   *
   * @param nodeObj - The node object to assign identifier to
   * @param parentNode - The parent node for context
   * @param processedSiblings - Array of already-processed sibling nodes in the same batch
   * @returns The node object with identifier and styleClass assigned
   */
  assignHtmlPropsToNodeWithSiblings(nodeObj: any, parentNode: any, processedSiblings: any[]): any {
    const currentNodes = this.getCurrentTreeNodes();
    // Include processed siblings so their identifiers are considered for deduplication
    const nodesWithSiblings = [...currentNodes, ...processedSiblings];
    return this.identifierService.assignHtmlPropsToNode(nodeObj, nodesWithSiblings, parentNode);
  }

  /**
   * Updates both identifier and styleClass of a node based on its label when label is entered/changed.
   * Delegates to IdentifierService for context-aware generation.
   *
   * @param node - The FancyTree node to update
   */
  updateHtmlPropsFromLabel(node: any): void {
    const currentNodes = this.getCurrentTreeNodes();
    this.identifierService.updateHtmlPropsFromLabel(node, currentNodes);
  }

  /**
   * Updates pageView and grid (for list pages) elementIds when page is renamed.
   * Only updates elementId; title and label remain unchanged.
   * Works directly with pageData.contentAttachment to avoid cross-page contamination.
   * @param pageData - The page data object containing contentAttachment
   * @param newPageName - The new page name
   */
  updatePageElementIdsOnRename(pageData: any, newPageName: string): void {
    if (!pageData.contentAttachment || !newPageName?.trim()) {
      return;
    }

    // Parse the page's own contentAttachment (not the active tree in UI)
    const treeNodes = JSON.parse(pageData.contentAttachment);
    if (!Array.isArray(treeNodes) || treeNodes.length === 0) {
      return;
    }

    // Update pageView node using utility method for robust tree traversal
    const pageViewNode = this.util.findNodeByKeyValue(treeNodes, 'key', 'pageView');
    if (pageViewNode?.data?.properties) {
      this.identifierService.updateHtmlPropsOnFieldRename(
        pageViewNode as ScreenNode,
        newPageName,
        treeNodes as ScreenNode[]
      );
    }

    // Update grid node for list pages only
    if (pageData.pageType === 'list') {
      const gridNode = this.util.findNodeByKeyValue(treeNodes, 'key', 'table');
      if (gridNode?.data?.properties) {
        const gridLabel = `${newPageName} table`;
        this.identifierService.updateHtmlPropsOnFieldRename(
          gridNode as ScreenNode,
          gridLabel,
          treeNodes as ScreenNode[]
        );
      }
    }

    // Update the contentAttachment with modified nodes
    pageData.contentAttachment = JSON.stringify(treeNodes);
  }

  /**
   * Creates a node with automatic Html Properties (identifier and styleClass) assignment.
   * These properties are grouped under "Html Properties" in the property pane.
   * @param parentNode - The parent node where the new node will be created
   * @param mode - The creation mode ('over', 'after', 'before')
   * @param nodeConfig - The node configuration object to create
   */
  createNodeWithHtmlProps(parentNode: any, mode: string, nodeConfig: any): void {
    // Pass the parent node for prefix determination (captionBar -> cb_, tableSearch -> ts_, etc.)
    const nodeWithHtmlProps = this.assignHtmlPropsToNode(nodeConfig, parentNode);
    parentNode.editCreateNode(mode, nodeWithHtmlProps);
  }

  /**
   * Removes a node and its children from the validation service and title tracking.
   * Called when deleting nodes to ensure validation state stays in sync.
   * Handles: validatable types (button, buttongroup, formsection, etc.), tabview, and tab.
   * @param node - The FancyTree node being deleted
   */
  removeNodeFromValidationService(node: any): void {
    if (!node) {
      return;
    }

    const nodeType = node.type?.toLowerCase();

    this.removeFromTabViewTracking(nodeType, node);
    this.removeFromTabTracking(nodeType, node);

    // Recursively remove children
    node.children?.forEach((child: any) => this.removeNodeFromValidationService(child));
  }

  private removeFromTabViewTracking(nodeType: string, node: any): void {
    if (nodeType !== 'tabview') {
      return;
    }
    const titleLower = node.title?.toLowerCase();
    if (!titleLower) {
      return;
    }
    const index = this.tabViewTitles.indexOf(titleLower);
    if (index > -1) {
      this.tabViewTitles.splice(index, 1);
    }
    delete this.tabTitles[titleLower];
  }

  private removeFromTabTracking(nodeType: string, node: any): void {
    if (nodeType !== 'tab' || !node.parent) {
      return;
    }
    const parentTitle = node.parent.title?.toLowerCase();
    const titleLower = node.title?.toLowerCase();
    const tabList = this.tabTitles[parentTitle];
    if (!parentTitle || !titleLower || !tabList) {
      return;
    }
    const index = tabList.indexOf(titleLower);
    if (index > -1) {
      tabList.splice(index, 1);
    }
  }

  /**
   * Updates child tab identifiers when a TabView is named.
   * Child tabs get prefixed identifiers based on parent TabView name.
   * e.g., TabView "Demo" with Tab 1 → identifier: demo_tab_1
   * @param tabViewNode - The TabView FancyTree node
   */
  updateTabViewChildIdentifiers(tabViewNode: any): void {
    if (!tabViewNode || tabViewNode.type?.toLowerCase() !== 'tabview') {
      return;
    }

    const tabViewLabel = tabViewNode.title;
    if (!tabViewLabel) {
      return;
    }

    const children = tabViewNode.children;
    if (!children || !Array.isArray(children)) {
      return;
    }

    const currentNodes = this.getCurrentTreeNodes();
    children.forEach((childNode: any) => {
      if (childNode.type?.toLowerCase() === 'tab') {
        // Use identifier service to generate prefixed identifiers for each tab
        this.identifierService.updateHtmlPropsFromLabel(childNode, currentNodes);
      }
    });
  }

  getAllTranslationLabels(data: any, labels: any = []) {
    data.map((d: any) => {
      if (d?.data?.properties?.label) {
        labels.push(d.data.properties.label);
      }
      if (d?.data?.properties?.pageTitle) {
        labels.push(d.data.properties.pageTitle);
      }
      if (d?.data?.properties?.subTitle) {
        labels.push(d.data.properties.subTitle);
      }
      if (d?.data?.properties?.createButtonLabel) {
        labels.push(d.data.properties.createButtonLabel);
      }
      if (d?.data?.properties?.tooltipMessage) {
        labels.push(d.data.properties.tooltipMessage);
      }
      // Confirmation dialog properties for buttons
      // modeller.json: only 'show_confirmation' and 'get_additional_info' have confirmation properties
      const beforeAction = d?.data?.properties?.beforeAction;
      if (beforeAction === 'show_confirmation' || beforeAction === 'get_additional_info') {
        if (d?.data?.properties?.confirmationTitle) {
          labels.push(d.data.properties.confirmationTitle);
        }
        if (d?.data?.properties?.confirmationText) {
          labels.push(d.data.properties.confirmationText);
        }
        if (d?.data?.properties?.confirmationButtonText) {
          labels.push(d.data.properties.confirmationButtonText);
        }
        if (d?.data?.properties?.cancelButtonText) {
          labels.push(d.data.properties.cancelButtonText);
        }
      }
      if (d?.type === 'homeTile' && d?.data?.properties?.description) {
        labels.push(d.data.properties.description);
      }
      if (d?.key === 'appTitle' || d?.type === 'APP_NAME') {
        if (d?.data?.properties?.title) {
          labels.push(d.data.properties.title);
        }
        if (d?.data?.properties?.mobileTitle) {
          labels.push(d.data.properties.mobileTitle);
        }
      }
      if (this.currentSelectedTreeNode?.data?.id !== d?.data?.id && d?.selected) {
        d.selected = false;
      }
      if (d?.children) {
        this.getAllTranslationLabels(d.children, labels);
      }
    });
    return labels;
  }
  setLastSelectedNodeAsFalse(data: any) {
    data.map((d: any) => {
      d.selected = false;
      if (d?.children) {
        this.setLastSelectedNodeAsFalse(d.children);
      }
    });
    return data;
  }
  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  resetRefObj() {
    this.referencesTasks = { addedReference: [], deletedReference: [] };
    this.pageModalEvents = [];
    this.pageSection = { createdPageSectionMap: {}, updatedPageSectionMap: {}, deletedPageSections: [] };
    this.updatedObject = null;
  }

  saveFancyTreeData(from?: string, queryBuilderIdToDelete?: string) {
    if (this.pendingService.isPending.getValue()) {
      this.debounceSaveTree(from);
      return;
    }
    console.log(this.currentSelectedItem.pageName);
    const screenData = this.taskstoSave;
    this.taskstoSave = null;
    if (!screenData) {
      return;
    }
    const permitUpdate = false;
    const dataToSave = cloneDeep(JSON.stringify(this.setLastSelectedNodeAsFalse(JSON.parse(screenData?.orders))));
    const labelsToTranslate: any = uniq(this.getAllTranslationLabels(JSON.parse(dataToSave)));
    labelsToTranslate.push(this.currentSelectedItem.pageName);
    if (permitUpdate === false) {
      let dataMap = {
        fileContent: dataToSave,
        fieldsToTranslate: labelsToTranslate,
        modifiedDate: this.screensResData.modifiedDate,
        tabId: this.tabId,
        defaultDetailPageEnabled: false
      };
      if (
        this.activeScreen?.pageType === 'detail' &&
        this.currentSelectedTreeNode?.data?.id === 'PAGE' &&
        this.currentSelectedTreeNode?.data?.properties?.defaultDetailPageEnabled
      ) {
        dataMap.defaultDetailPageEnabled = true;
      }
      if (this.dataMapParams) {
        dataMap = { ...dataMap, ...this.dataMapParams };
      }
      let updatedData: any = {
        dataMap: dataMap,
        screenId: this.currentSelectedItem.sid,
        tableId: this.currentSelectedItem?.tableId,
        appId: this.appId
      };
      if (this.screenLookupDefinitionDetails) {
        updatedData = { ...updatedData, ...{ screenLookupDefinitionDetails: this.screenLookupDefinitionDetails } };
      }
      if (this.dmConfig) {
        updatedData = { ...updatedData, ...{ dataModelConfigured: this.dmConfig } };
      }
      if ((this.referencesTasks.addedReference.length || this.referencesTasks.deletedReference.length) && !this.isFromModernize) {
        updatedData = { ...updatedData, ...this.referencesTasks };
      }
      if (this.pageModalEvents.length) {
        updatedData = { ...updatedData, pageModalEvents: this.pageModalEvents };
      }
      if (
        Object.keys(this.pageSection.createdPageSectionMap).length ||
        Object.keys(this.pageSection.updatedPageSectionMap).length ||
        this.pageSection.deletedPageSections.length
      ) {
        updatedData = { ...updatedData, ...this.pageSection };
      }
      if (this.updatedObject) {
        updatedData = { ...updatedData, ...this.updatedObject };
      }
      if (queryBuilderIdToDelete) {
        updatedData = { ...updatedData, ...{ queryBuilderIdToDelete: queryBuilderIdToDelete } };
      }

      this.resetRefObj();
      if (this.isFromModernize) {
        const updateApiCons = { ...ApiConstants.updateScreenContentInterim };
        this.store.dispatch(
          ScreenInterimActions.updateScnAndDMConfigInterim({
            updateApiCons,
            updatedData
          })
        );
      } else {
        const updateApiCons = { ...ApiConstants.updateScreenAndDMCOnfig };
        this.store.dispatch(
          updateScnAndDMCOnfig({
            updateApiCons,
            updatedData
          })
        );
      }
      this.isPendingSave = false;
      const successSelector = this.isFromModernize ? confAndFileCntSveSuccInterim : confAndFileCntntSveSucc;
      const saveSuccessSub = this.store.select(successSelector).subscribe((data) => {
        if (data) {
          this.isLoadingScreens = false;
          this.pendingService.isPending.next(false);
          this.screensResData = { ...this.screensResData, ...{ modifiedDate: data.screen.modifiedDate } };
          this.waitForCongFlsRes = false;
          const temp: any[] = [];
          let picklist: any = {
            fields: [],
            tables: [],
            primaryFields: [],
            noImgFAFields: [],
            allFields: [],
            lookupFields: [],
            searchableFields: []
          };
          if (data?.screen?.fieldIds) {
            if (data?.screen?.fieldIds.length > this.currentPicklist?.searchableFields.length) {
              this.currentPicklist.searchableFields = [
                ...this.currentPicklist.searchableFields,
                ...this.currentPicklist.allFields.filter(
                  (allflds: any) =>
                    data?.screen?.fieldIds.includes(allflds.sid) &&
                    !this.currentPicklist.searchableFields.some((fld: any) => fld.sid === allflds.sid)
                )
              ];
              picklist = { ...this.currentPicklist };
              this.store.dispatch(propertyActions.setPickupProperties({ picklist }));
            }
          }
          if (data.sysGen) {
            this.allSelectedScreens.sysGenScreens.forEach((d) => {
              if (d.sid === data.screenId) {
                d = { ...d, contentAttachment: data.dataMap.fileContent };
              }
              temp.push(d);
            });
            this.allSelectedScreens.sysGenScreens = temp;
          } else {
            this.allSelectedScreens.userGenScreens.forEach((d) => {
              if (d.sid === data.screenId) {
                d = { ...d, contentAttachment: data.dataMap.fileContent };
              }
              temp.push(d);
            });
            this.allSelectedScreens.userGenScreens = temp;
            this.allSelectedScreens.userGenScreens = uniqBy(this.allSelectedScreens.userGenScreens, 'sid');
          }
          if (saveSuccessSub) {
            saveSuccessSub.unsubscribe();
          }
        }
      });
      this.addToSubscriptionsList(saveSuccessSub);
      const failureSelector = this.isFromModernize ? confAndFileCntSveFailInterim : confAndFileCntntSveFail;
      const saveFailureSub = this.store.select(failureSelector).subscribe((data) => {
        if (data) {
          this.isLoadingScreens = false;
          this.pendingService.isPending.next(false);
          this.waitForCongFlsRes = false;
          if (saveFailureSub) {
            saveFailureSub.unsubscribe();
          }
          this.reloadCurrentRoute();
        }
      });
      this.addToSubscriptionsList(saveFailureSub);
      this.dataMapParams = null;
      this.screenLookupDefinitionDetails = null;
      //this.dmConfig = null;  //commented to retain dmConfig until next change
      this.debounceSaveTree?.cancel();
    }
  }

  debounceSaveTree = debounce(this.saveFancyTreeData.bind(this), 1000);

  setCurDataToScreens(data: any) {
    let sysGen = this.allSelectedScreens?.sysGenScreens;
    let userGen = this.allSelectedScreens?.userGenScreens;
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    const d = tree.toDict(true);
    const dataFromTree = this.processTreeData(d);

    let temp: any[] = [];
    userGen = userGen.map((sc: any) => {
      if (sc.sid === this.currentSelectedItem.sid) {
        sc = { ...sc, ...{ contentAttachment: JSON.stringify(dataFromTree) } };
      }
      temp.push(d);
      return sc;
    });
    this.allSelectedScreens.userGenScreens = temp;
    this.allSelectedScreens.userGenScreens = uniqBy(this.allSelectedScreens.userGenScreens, 'sid');
    temp = [];
    sysGen = sysGen.map((sc: any) => {
      if (sc.sid === this.currentSelectedItem.sid) {
        sc = { ...sc, ...{ contentAttachment: JSON.stringify(dataFromTree) } };
      }
      temp.push(d);
      return sc;
    });
    this.allSelectedScreens.sysGenScreens = temp;
  }

  saveFancyTree(data: string, id?: string) {
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    const d = tree.toDict(true);
    const dataFromTree = this.processTreeData(d) as { key?: string }[];
    if (dataFromTree?.length && dataFromTree[0]?.key) {
      if (typeof dataFromTree[0]?.key === 'string' && dataFromTree[0]?.key?.toLowerCase() === 'nodata') {
        this.refreshActiveScreen(null);
        return;
      }
    }
    const dataToSave = { orders: JSON.stringify(dataFromTree), screenId: this.currentSelectedItem.sid };
    this.taskstoSave = dataToSave;
    let params = {};
    if ((data === 'updateFieldsToTable' || data === 'deleteNode') && this.screensResData) {
      params = { ...params, ...{ fieldIds: this.screensResData?.fieldIds } };
    }
    if ((data === 'screenid' || data === 'deletescreenid') && this.screensResData) {
      if (data === 'deletescreenid') {
        this.updScrIds(id, 'delete');
      }
      params = { ...params, ...{ screenIds: this.screensResData?.screenIds } };
    }
    if ((data === 'custom component' || data === 'customComponentdelete') && this.screensResData) {
      if (data === 'customComponentdelete') {
        this.updCusComIds(id, 'delete');
      }
      params = { ...params, ...{ componentIds: this.screensResData?.componentIds } };
    }
    // Merge new params into any existing dataMapParams instead of overwriting
    this.dataMapParams = { ...this.dataMapParams, ...params };
    //update contentAttachment of current screen which is used in properties pane
    this.currentSelectedItem = { ...this.currentSelectedItem, ...{ contentAttachment: JSON.stringify(dataFromTree) } };
    this.selectedScreen.emit(this.currentSelectedItem);
  }

  updScrIds(id, operation) {
    const order = this.taskstoSave ? this.taskstoSave?.orders : this.screensResData.contentAttachment;
    if (operation === 'add') {
      if (order && !order.includes(id)) {
        if (this.screensResData.screenIds) {
          const ids = [...this.screensResData.screenIds, id];
          this.screensResData = { ...this.screensResData, ...{ screenIds: ids } };
        } else {
          this.screensResData = { ...this.screensResData, ...{ screenIds: [id] } };
        }
      }
    } else if (operation === 'delete') {
      if (order && !order.includes(id) && this.screensResData.screenIds) {
        const i = this.screensResData.screenIds.indexOf(id);
        if (i > -1) {
          const ids = [...this.screensResData.screenIds];
          ids.splice(i, 1);
          this.screensResData = { ...this.screensResData, ...{ screenIds: ids } };
        }
      }
    }
  }

  checkForButtonVisibilityChange(data) {
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    const selectedNode = tree.getSelectedNodes();
    if (
      selectedNode?.[0]?.data &&
      data.visibility !== 'conditional' &&
      selectedNode?.[0]?.data?.properties.conditionForButtonVisiblity
    ) {
      this.referencesTasks.deletedReference.push(
        this.util.createObjForDelRef(
          this.currentSelectedItem.sid,
          JSON.parse(selectedNode?.[0]?.data?.properties?.conditionForButtonVisiblity).sid,
          utilEnum.propertyName.BUTTON_VISIBILITY_CONDITIONAL,
          { menu: selectedNode?.[0]?.data?.id, path: this.screensReferenceService.getAdditionalPath(selectedNode?.[0]) }
        )
      );
    }
  }

  updateQuickfilterOnParamMap(props) {
    const params = props?.parameterMappingForQueryList;
    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    const quickFlNode = tree.getNodeByKey('quickFilter');
    quickFlNode.children
      ?.filter((childNode) => childNode?.data?.properties?.mandatory)
      .forEach((filterNode) => {
        let prps = filterNode?.data?.properties;
        const mParam = params.find((p) => p.listField.sid === filterNode.key);
        prps = { ...prps, ...{ staticValue: mParam?.staticValue } };
        filterNode.data = { ...filterNode.data, ...{ properties: prps } };
      });
  }

  updateQuickfilterOnDefFilter(node, props) {
    const olddata = node.data.properties;
    // unsubscribe if there are any subscriptions available
    Object.keys(this.unSubList)?.forEach((k) => {
      if (k && typeof this.unSubList[k]?.unsubscribe === 'function') {
        this.unSubList[k].unsubscribe();
      }
    });
    const adInfo = this.util.enrichAdInfo(
      { menu: node.data?.id },
      {
        props: props,
        node: node,
        detailPageId: props.detailPage?.sid || props?.gridColumnDetailPage?.sid || this.currentSelectedItem?.sid
      }
    );
    const getFIApiConstants = this.isFromModernize
      ? { ...ApiConstants.getFieldForPagesInterim }
      : { ...ApiConstants.getFieldForPages };
    if (this.isFromModernize) {
      getFIApiConstants.url = `${getFIApiConstants.url}${this.currentSelectedItem.sid}/${this.currentSelectedItem.tableId}?element='quickfilter'`;
    } else {
      getFIApiConstants.url = `${getFIApiConstants.url}${this.currentSelectedItem.tableId}/${this.currentSelectedItem.sid}/${this.appId}?element='quickfilter'`;
    }
    this.isLoadingScreens = true;
    const fieldsAndSearchInfo$ = forkJoin({
      data: this.bs.get(getFIApiConstants),
      searchableFieldsData: this.bs.get(ApiConstants.getSearchableFieldsByTableId, {
        tableId: this.currentSelectedItem.tableId
      })
    });
    fieldsAndSearchInfo$.subscribe({
      next: ({ data, searchableFieldsData }) => {
        // Handle the response data
        try {
          const tree = $.ui.fancytree.getTree(this.getTreeSelector());
          const quickFlNode = tree.getNodeByKey('quickFilter');
          this.curContextMenuNode = {
            quickFlNode,
            configuredFields: (data as any)?.configuredFields
          };
          let filterFlds: any[] = [];
          const config = JSON.parse((data as any)?.configuredFields?.config || '{}');
          if (props.defaultFilter) {
            const defFilt = JSON.parse(props.defaultFilter);
            props.defaultFilter = defFilt.sid;
            if (defFilt?.query) {
              const qry = JSON.parse(defFilt?.query);
              if (qry.rules) {
                filterFlds = qry.rules.map((r) => r.lhs.fieldId);
                qry.rules.forEach((rule) => {
                  let fld: any = null;
                  if (data && typeof data === 'object' && Array.isArray((data as any).fields)) {
                    fld = (data as any).fields.find((f: any) => f.sid === rule?.lhs?.fieldId);
                  }
                  if (!fld) {
                    fld = this.util
                      .getSearchableReferredTableFields(searchableFieldsData, this.currentSelectedItem.tableId)
                      ?.referredTableFields?.find((f: any) => f.sid === rule?.lhs?.fieldId);
                  }
                  const ruleNode = quickFlNode?.children?.find((n) => n.key === rule?.lhs?.fieldId);
                  let displayAs;
                  switch (fld?.f_type?.toLowerCase()) {
                    case 'date':
                      displayAs = fld.f_type.toLowerCase() + (rule.operator === Operators.ISBETWEEN ? 'range' : '');
                      break;
                    case 'datetime':
                      displayAs = `${fld.f_type.toLowerCase()}range`;
                      break;
                    case 'number':
                    case 'double':
                    case 'currency':
                      displayAs = fld.f_type.toLowerCase() + (rule.operator === Operators.ISBETWEEN ? ' range' : '');
                      break;
                    case 'dropdown':
                    case 'radio':
                      displayAs = rule.operator === Operators.HASANYOF ? 'multi select dropdown' : 'single dropdown';
                      break;
                    case 'string':
                      displayAs = 'string';
                      break;
                  }
                  if (ruleNode) {
                    let ruleNodeProps = ruleNode?.data?.properties;
                    ruleNodeProps = {
                      ...ruleNodeProps,
                      ...{
                        fromDefaultFilter: true,
                        viewInPages: rule.allowView,
                        editInPages: rule.allowEdit,
                        updatedFromDefaultFilter: Object.prototype.hasOwnProperty.call(
                          ruleNodeProps,
                          'addedFromDefaultFilter'
                        )
                          ? undefined
                          : true,
                        displayAs: displayAs ? displayAs : ruleNodeProps?.displayAs,
                        ruleOperator: rule.operator,
                        ruleFieldType: rule.fieldType
                      }
                    };
                    ruleNode.data = {
                      ...ruleNode.data,
                      ...{ properties: ruleNodeProps }
                    };
                  } else if (fld) {
                    this.getDefaultValues('filterField');
                    const id = rule?.lhs?.fieldId;
                    if (!this.fieldIdMap[id] && fld.name) {
                      this.fieldIdMap = { ...this.fieldIdMap, [id]: fld.name };
                    }
                    const nodeObj = {
                      title: this.fieldIdMap[id],
                      type: 'filterField',
                      key: id,
                      id: id,
                      data: {
                        properties: {
                          ...this.formDefaultValues,
                          data: fld.name,
                          field: fld.f_fieldId, //eg: firstName
                          type: fld.f_hasFK ? 'foreignkey' : undefined,
                          fromDefaultFilter: true,
                          viewInPages: rule.allowView,
                          editInPages: rule.allowEdit,
                          addedFromDefaultFilter: true,
                          displayAs: displayAs,
                          ruleOperator: rule.operator,
                          ruleFieldType: rule.fieldType,
                          fkTableSid: fld.fkTableSid,
                          fkId: fld.fkId,
                          fkAppId: fld.fkAppId
                        }
                      }
                    };
                    // Assign dataKey, styleClass and elementId for filterField
                    this.assignHtmlPropsToNode(nodeObj, quickFlNode);
                    quickFlNode.addNode(nodeObj, 'over');
                    this.referencesTasks.addedReference.push(
                      this.util.createReference(
                        this.currentSelectedItem.sid,
                        utilEnum.modelType.PAGE,
                        nodeObj.key,
                        utilEnum.modelType.FIELD,
                        this.appId,
                        this.screensReferenceService.getAdditionalPath(quickFlNode),
                        this.screensReferenceService.getPropName('filterfield'),
                        false
                      )
                    );
                    config.quickFilter = [...new Set([...config.quickFilter, id])];
                    const dataToSend = {
                      ...this.curContextMenuNode?.configuredFields,
                      ...{
                        config: JSON.stringify(config),
                        tableId: this.currentSelectedItem.tableId,
                        screenId: this.currentSelectedItem.sid
                      }
                    };
                    this.dmConfig = dataToSend;
                  }
                });
              }
            }
            // send reference only if query builder is newly added. For filter, even copy is not allowed
            if (!olddata?.defaultFilter) {
              this.referencesTasks.addedReference.push(
                this.util.createReference(
                  this.currentSelectedItem.sid,
                  utilEnum.modelType.PAGE,
                  defFilt?.sid,
                  utilEnum.modelType.QUERY_BUILDER,
                  this.appId,
                  this.screensReferenceService.getAdditionalPath(node),
                  utilEnum.propertyName.DEFAULT_FILTER,
                  true
                )
              );
            }
          }
          let queryBuilderIdToDelete;
          if (olddata?.defaultFilter) {
            // send delete reference only if query builder is deleted.
            if (!props.defaultFilter) {
              this.referencesTasks.deletedReference.push(
                this.util.createObjForDelRef(
                  this.currentSelectedItem.sid,
                  olddata?.defaultFilter,
                  utilEnum.propertyName.DEFAULT_FILTER
                )
              );
              queryBuilderIdToDelete = olddata?.defaultFilter;
            }
          }
          // remove properties from quick filter if it is not part of quick filter
          if (quickFlNode?.children) {
            const qfDefNodes = quickFlNode?.children?.filter((qn) => qn?.data?.properties?.fromDefaultFilter);
            qfDefNodes?.forEach((n: any) => {
              if (n?.data?.properties?.fromDefaultFilter && !filterFlds.includes(n?.key)) {
                const dt = n?.data?.properties;
                if (Object.prototype.hasOwnProperty.call(dt, 'addedFromDefaultFilter')) {
                  config.quickFilter = config?.quickFilter?.filter((el) => el !== n.key);
                  const dataToSend = {
                    ...this.curContextMenuNode?.configuredFields,
                    ...{
                      config: JSON.stringify(config),
                      tableId: this.currentSelectedItem.tableId,
                      screenId: this.currentSelectedItem.sid
                    }
                  };
                  this.dmConfig = dataToSend;
                  this.removeReferenceOnFieldDel(n.key, n?.type?.toLowerCase());
                  n.remove();
                } else {
                  delete dt.fromDefaultFilter;
                  delete dt.viewInPages;
                  delete dt.editInPages;
                  delete dt.updatedFromDefaultFilter;
                  delete dt.operator;
                  delete dt.fieldType;
                  n.data = { ...n.data, ...{ properties: dt } };
                }
              }
            });
          }
          node.properties = props;
          node.data.properties = props;
          this.isLoadingScreens = true;
          this.saveFancyTree('listenForPropertyChanges');
          this.saveFancyTreeData('listenForPropertyChanges', queryBuilderIdToDelete);
        } catch (e) {
          console.log(e);
          this.isLoadingScreens = false;
        }
      },
      error: (error) => {
        this.isLoadingScreens = false;
      }
    });
    this.unSubList.fisub = fieldsAndSearchInfo$;
    this.addToSubscriptionsList(fieldsAndSearchInfo$);
  }

  flattenGroups(arr: any[]): any[] {
    const result: any[] = [];
    for (const item of arr) {
      if (item.type === 'group' && Array.isArray(item.items)) {
        result.push(...item.items);
      } else {
        result.push(item);
      }
    }
    return result;
  }

  hasPropertyChanged(oldData, data, prpName) {
    return (oldData[prpName] || data[prpName]) && !isEqual(oldData[prpName], data?.[prpName]);
  }

  private getMappingDedupeKey(field: any): string | null {
    const name = field?.name?.trim();
    if (name) {
      return name.replace(/\*$/, '').toLowerCase();
    }
    return field?.sid || null;
  }

  private findDuplicateMappingField(mappings: any[], key: string): any | null {
    if (!Array.isArray(mappings)) {
      return null;
    }
    const seen = new Set<string>();
    for (const map of mappings) {
      const field = map?.[key];
      const dedupeKey = this.getMappingDedupeKey(field);
      if (!dedupeKey) {
        continue;
      }
      if (seen.has(dedupeKey)) {
        return field;
      }
      seen.add(dedupeKey);
    }
    return null;
  }

  private validateDuplicateMappingArray(mappings: any[], key: string, elementTitle: string): boolean {
    const dupField = this.findDuplicateMappingField(mappings, key);
    if (!dupField) {
      return false;
    }
    this.zone.run(() => {
      this.showMessage(
        'error',
        this.translate
          .instant('LIST_FLD_ERR')
          .replace('{field}', dupField?.name || '')
          .replace('{elementTitle}', elementTitle)
      );
    });
    return true;
  }

  private validateDuplicateMappingsList(mappings: { mappings: any[]; key: string; title: string }[]): boolean {
    for (const entry of mappings) {
      if (this.validateDuplicateMappingArray(entry.mappings, entry.key, entry.title)) {
        return true;
      }
    }
    return false;
  }

  listenForPropertyChanges() {
    this.valueChangeListener = this.currentProperties$.pipe(distinctUntilChanged()).subscribe(async (data: any) => {
      if (
        data &&
        this.currentSelectedTreeNode &&
        (data.currentNode === this.currentSelectedTreeNode.data.id ||
          data.currentNode === this.currentSelectedTreeNode.key)
      ) {
        // Get the tree instance
        const tree = $.ui.fancytree.getTree(this.getTreeSelector());

        const menuMap = {
          LEFT_MENU: {
            menuType: 'rightMenu',
            errorMessage: this.translate.instant('CHANGE_RIGHT_MENU_TYPE')
          },
          RIGHT_MENU: {
            menuType: 'leftMenu',
            errorMessage: this.translate.instant('CHANGE_LEFT_MENU_TYPE')
          }
        };

        if (data?.menuType === 'float' && menuMap[data.currentNode]) {
          const { menuType, errorMessage } = menuMap[data.currentNode];

          if (data?.menuType === tree.getNodeByKey(menuType)?.data?.properties?.menuType) {
            this.zone.run(() => {
              this.showMessage('error', errorMessage);
            });
            return;
          }
        }

        if (data.pageLimit || data.childPageLimit) {
          const pgLimit = data.pageLimit ? data.pageLimit : data.childPageLimit;
          const myRe = /^[0-9]*$/g; // Alphanumeric characters characters only allowed
          const array = myRe.exec(pgLimit);
          if (!array) {
            this.zone.run(() => {
              this.showMessage('error', this.translate.instant('PAGELIMIT_NUM'));
            });
            return;
          }
          const pL = Number(pgLimit);
          if (!pL) {
            this.zone.run(() => {
              this.showMessage('error', this.translate.instant('PAGELIMIT_MIN'));
            });
            return;
          }
          if (pL > this.pageLimitMax) {
            this.zone.run(() => {
              this.showMessage('error', this.translate.instant('PAGELIMIT_MAX'));
              pgLimit.val(null);
            });
            return;
          }
        }
        if (data.detailPagePopupWidth) {
          data = { ...data, ...{ detailPagePopupWidth: Number(data.detailPagePopupWidth) } };
          if (data.detailPagePopupWidth < 30 || data.detailPagePopupWidth > 100) {
            this.zone.run(() => {
              this.showMessage('error', this.translate.instant('DET_PG_POP_WID'));
            });
            return;
          }
        }
        const node: any = $.ui.fancytree.getTree(this.getTreeSelector())?.getActiveNode();
        const olddata = node.data.properties;
        let props = cloneDeep(data);
        if (
          this.validateDuplicateMappingsList([
            { mappings: props?.detailPageMapping?.queryMap, key: 'tableField', title: 'Detail View Parameter Mapping' },
            { mappings: props?.detailPageParameters, key: 'detailField', title: 'Detail Page Parameters' },
            { mappings: props?.navigatePageValueMapping, key: 'targetKey', title: 'Pass Values To The Page' },
            { mappings: props?.parameterMapping, key: 'detailField', title: 'Data Grid Mapping' },
            { mappings: props?.queryViewMapping, key: 'tableField', title: 'Query View Mapping' },
            { mappings: props?.detailPageMapping, key: 'tableField', title: 'Detail Page Mapping' },
            { mappings: props?.holdValueParams, key: 'detailField', title: 'Hold Value Params' },
            {
              mappings: props?.queryViewMappingPageVariables,
              key: 'tableField',
              title: 'Query View Mapping for Page Variables'
            },
            {
              mappings: props?.parameterMappingPageVariables,
              key: 'detailField',
              title: 'Data Grid - Page Variables'
            },
            {
              mappings: props?.lookupConfiguration?.inputMapping,
              key: 'tableField',
              title: 'Lookup Input Mapping'
            },
            {
              mappings: props?.lookupConfiguration?.outputMapping,
              key: 'tableField',
              title: 'Lookup Output Mapping'
            }
          ])
        ) {
          return;
        }
        const diffObj =
          node.key === 'appTitle' && $.isEmptyObject(olddata) ? data : this.util.getDifKeyValObj(olddata, data, '');
        if (diffObj && Object.keys(diffObj)?.length) {
          let resetPrps = false;
          for (const prp in props) {
            if (props[prp] === '' && this.currentSelectedTreeNode?.type?.toLowerCase() !== 'htmlcontainer') {
              props[prp] = null;
            }
          }
          if (!node) {
            return;
          }

          const nType = node.type.toLowerCase();
          const adInfo = this.util.enrichAdInfo(
            { menu: node.data?.id },
            {
              props: props,
              node: node,
              detailPageId:
                props.pageName?.sid ||
                props.detailPage?.sid ||
                props?.gridColumnDetailPage?.sid ||
                this.currentSelectedItem?.sid,
              lookupConfig: props.lookupConfiguration
            }
          );

          // Handle button action/beforeAction property resets (before image upload)
          if (node.type === 'button') {
            if (this.hasPropertyChanged(olddata, props, 'action')) {
              props.pageName = null;
              props.navigatePageValueMapping = null;
              props.service = null;
            }
          }

          // logic to upload icon along with contentattachment if there is any upload detected in diffObj
          const curNodeTypProps = this.allProps?.[node.type]
            ? this.flattenGroups(this.allProps?.[node.type]?.properties || [])
            : [];
          const imgPropName = curNodeTypProps
            .filter((p) => p.uiType == 'iconselector' || p.uiType == 'imageselector' || p.uiType == 'pwaimageselector')
            .map((ip) => ip.name)
            .find((propname) => Object.keys(diffObj).includes(propname));
          if (imgPropName) {
            const formData = new FormData();
            // Remove pageTableType from page properties (added by dropdown for filtering, should not persist)
            const pageProps = ['page', 'pageName', 'detailPage', 'gridColumnDetailPage'];
            pageProps.forEach((pgPrp) => {
              if (props[pgPrp]?.pageTableType) {
                delete props[pgPrp].pageTableType;
              }
            });
            node.properties = props;
            node.data.properties = props;
            this.saveFancyTree('listenForPropertyChanges');
            const file = this.appGlobalService.get('fileUpload');
            const dataToSave = cloneDeep(
              JSON.stringify(this.setLastSelectedNodeAsFalse(JSON.parse(this.taskstoSave?.orders)))
            );
            const dataMap = {
              contentAttachment: dataToSave,
              modifiedDate: this.screensResData.modifiedDate,
              tabId: this.tabId
            };
            if (file) {
              const uploadUrl = `/${environment.apihost}/screens/attachment/upload`;
              const headers = {
                'x-rappit-application': this.appGlobalService.get('appId'),
                'x-rappit-organization': this.appGlobalService.get('orgId')
              };
              const appendCommonFields = (fd: FormData, f: File) => {
                fd.append('files', f);
                let iconId: any = null;
                if (f && f.name && props[imgPropName]?.icon && Array.isArray(props[imgPropName].icon)) {
                  const iconObj = props[imgPropName].icon.find((item) => item.fileName === f.name);
                  if (iconObj && iconObj.id) {
                    iconId = iconObj.id;
                  }
                }
                if (!iconId) {
                  const icon = props[imgPropName]?.icon;
                  iconId = Array.isArray(icon) ? icon.map((item) => item.id).join(',') : icon?.id;
                }
                fd.append('sid', iconId);
                fd.append('modelName', 'screens');
                fd.append('modelKey', this.currentSelectedItem.sid);
                fd.append('appId', this.appGlobalService.get('appId'));
                fd.append('orgId', this.appGlobalService.get('orgId'));
                fd.append('fieldName', f.name || file.fieldName);
                fd.append('fileDesc', '');
                fd.append('elementName', node.title);
                fd.append('propertyName', Object.keys(diffObj)[0]);
                dataMap.modifiedDate = this.screensResData.modifiedDate;
                fd.append('screenInfo', JSON.stringify(dataMap));
              };

              if (Array.isArray(file)) {
                // Track upload promises
                const uploadPromises: Promise<any>[] = [];
                for (let i = 0; i < file.length; i++) {
                  const f = file[i];
                  const fd = new FormData();
                  appendCommonFields(fd, f);
                  if (i < file.length - 1) {
                    fd.append('saveScreenRecord', 'false');
                    const uploadPromise = this.http.post(uploadUrl, fd, { headers }).toPromise();
                    uploadPromises.push(uploadPromise);
                  } else {
                    Promise.all(uploadPromises)
                      .then(() => {
                        fd.append('saveScreenRecord', 'true');
                        const uploadSub = this.http
                          .post(uploadUrl, fd, { headers })
                          .toPromise()
                          .then((data: any) => {
                            this.screensResData = { ...this.screensResData, modifiedDate: data.modifiedDate };
                          });
                        this.addToSubscriptionsList(uploadSub);
                      })
                      .catch((error: any) => {
                        this.isLoadingScreens = false;
                        this.loader.hide();
                        this.showMessage('error', this.translate.instant('ATTACHMENT_UPLOAD_FAILED'));
                      });
                  }
                }
              } else {
                appendCommonFields(formData, file);
                const uploadSub = this.http.post(uploadUrl, formData, { headers }).subscribe((data: any) => {
                  this.screensResData = { ...this.screensResData, modifiedDate: data.modifiedDate };
                });
                this.addToSubscriptionsList(uploadSub);
              }
              this.appGlobalService.write('fileUpload', null);
              return;
            }
            // handle clearing the old image
            if (olddata?.[imgPropName]) {
              const oldIcon = olddata?.[imgPropName]?.icon;
              const oldSid = Array.isArray(oldIcon) ? oldIcon.map((i) => i.id)?.join(',') : oldIcon?.id;
              if (oldSid) {
                const dataToSend = {
                  sid: oldSid,
                  elementName: node.title,
                  propertyName: Object.keys(diffObj)[0],
                  parentElementName: node?.parent?.title,
                  elementIndex: node?.parent?.children?.indexOf(node),
                  screens: { ...this.currentSelectedItem, ...dataMap }
                };
                const deleteUploadSub = this.http
                  .delete(`/${environment.apihost}/screens/attachment`, {
                    body: {
                      ...dataToSend
                    },
                    headers: {
                      'x-rappit-application': this.appGlobalService.get('appId'),
                      'x-rappit-organization': this.appGlobalService.get('orgId')
                    }
                  })
                  .subscribe((data: any) => {
                    this.screensResData = { ...this.screensResData, ...{ modifiedDate: data.modifiedDate } };
                  });
                this.addToSubscriptionsList(deleteUploadSub);
                return;
              }
            }
          }

          // enableLookup confirmation (async - requires user interaction)
          if ((props.enableLookup || olddata?.enableLookup) && olddata?.enableLookup !== props.enableLookup) {
            if (olddata?.enableLookup) {
              const confirmed = await this.handleLookupDisableConfirmation(props, olddata, data);
              if (!confirmed) {
                return;
              }
            }
          }

          // Process all reference changes in a single service call
          const queryViewConfigurationId = node.data?.properties?.queryViewConfigurationId;
          const stdGridConfigurationId = node.data?.properties?.stdGridConfigurationId;
          const propertyChangeInput: PropertyChangeInput = {
            data,
            props,
            olddata,
            node,
            nType,
            adInfo,
            queryViewConfigurationId,
            stdGridConfigurationId,
            hasPropertyChanged: this.hasPropertyChanged.bind(this),
            tree
          };
          const refResult = this.screensReferenceService.processAllReferenceChanges(
            propertyChangeInput,
            this.getReferenceContext()
          );
          props = refResult.props;
          resetPrps = refResult.resetPrps || resetPrps;
          if (refResult.screenLookupDefinitionDetails?.length) {
            this.screenLookupDefinitionDetails = refResult.screenLookupDefinitionDetails;
          }

          // Track detailPage navigation property changes
          if ((props.detailPage || olddata?.detailPage) && props.detailPage?.sid !== olddata?.detailPage?.sid) {
            if (olddata?.detailPage?.sid) {
              this.pageModalEvents.push({
                modelId: olddata.detailPage.sid,
                event: ModelEventType.NAVIGATE_TO_DETAIL_PAGE_REMOVED
              });
            }
            if (props.detailPage?.sid) {
              this.pageModalEvents.push({
                modelId: props.detailPage.sid,
                event: ModelEventType.NAVIGATE_TO_DETAIL_PAGE_ADDED
              });
            }
          }

          // Track showDetailPageAs property changes
          if (
            this.hasPropertyChanged(olddata, props, 'showDetailPageAs') &&
            (props.detailPage?.sid || olddata?.detailPage?.sid)
          ) {
            const detailPageSid = props.detailPage?.sid || olddata?.detailPage?.sid;
            this.pageModalEvents.push({
              modelId: detailPageSid,
              event: ModelEventType.LIST_PAGE_NAVIGATION_PROPS_UPDATED,
              oldValue: olddata?.showDetailPageAs,
              newValue: props.showDetailPageAs
            });
            if (props.groupOnColumn) {
              this.referencesTasks.addedReference.push(
                this.util.createReference(
                  this.currentSelectedItem.sid,
                  utilEnum.modelType.PAGE,
                  props.groupOnColumn.sid,
                  utilEnum.modelType.FIELD,
                  this.appId,
                  this.screensReferenceService.getAdditionalPath(node),
                  utilEnum.propertyName.GROUP_ON_COLUMN,
                  false
                )
              );
            }
            if (olddata?.groupOnColumn) {
              this.referencesTasks.deletedReference.push(
                this.util.createObjForDelRef(
                  this.currentSelectedItem.sid,
                  olddata?.groupOnColumn.sid,
                  utilEnum.propertyName.GROUP_ON_COLUMN
                )
              );
            }
          }
          if (
            (props.groupsOnColumn || olddata?.groupsOnColumn) &&
            !isEqual(props.groupsOnColumn, olddata?.groupsOnColumn)
          ) {
            const oldGrpCols = olddata?.groupsOnColumn?.split(',');
            const newGrpCols = props.groupsOnColumn?.split(',');
            const dataTorem = oldGrpCols?.filter((f) => !newGrpCols?.includes(f));
            const dataToSave = newGrpCols?.filter((f) => !oldGrpCols?.includes(f));
            if (dataToSave?.length) {
              dataToSave.forEach((sid) => {
                this.referencesTasks.addedReference.push(
                  this.util.createReference(
                    this.currentSelectedItem.sid,
                    utilEnum.modelType.PAGE,
                    sid,
                    utilEnum.modelType.FIELD,
                    this.appId,
                    this.screensReferenceService.getAdditionalPath(node),
                    utilEnum.propertyName.GROUPS_ON_COLUMN,
                    false
                  )
                );
              });
            } else if (dataTorem?.length) {
              dataTorem.forEach((sid) => {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    sid,
                    utilEnum.propertyName.GROUPS_ON_COLUMN
                  )
                );
              });
            }

            if (
              Array.isArray(this.gridChildrenFlds) &&
              this.gridChildrenFlds.length > 0 &&
              props.groupsOnColumn?.length
            ) {
              // Update groupsOnColumnInfo to reflect the current newGrpCols
              props.groupsOnColumnInfo = this.gridChildrenFlds
                .filter((fld) => props.groupsOnColumn?.includes(fld.id))
                .map((fld) => ({
                  sid: fld.id,
                  fkTableSid: fld.fkTableSid,
                  fkId: fld.fkId,
                  fkAppId: fld.fkAppId
                }));
            }
          }
          if ((props.fields || olddata?.fields) && !isEqual(props.fields, olddata?.fields)) {
            const oldFields = olddata?.fields?.split(',');
            const newFields = props.fields?.split(',');
            const dataTorem = oldFields?.filter((f) => !newFields?.includes(f));
            const dataToSave = newFields?.filter((f) => !oldFields?.includes(f));
            if (dataToSave?.length) {
              dataToSave.forEach((sid) => {
                this.referencesTasks.addedReference.push(
                  this.util.createReference(
                    this.currentSelectedItem.sid,
                    utilEnum.modelType.PAGE,
                    sid,
                    utilEnum.modelType.FIELD,
                    this.appId,
                    this.screensReferenceService.getAdditionalPath(node),
                    utilEnum.propertyName.PAGE_FIELDS,
                    false,
                    { menu: node.data?.id, path: this.screensReferenceService.getAdditionalPath(node) }
                  )
                );
              });
            }
            if (dataTorem?.length) {
              dataTorem.forEach((sid) => {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(this.currentSelectedItem.sid, sid, utilEnum.propertyName.PAGE_FIELDS, {
                    menu: node.data?.id,
                    path: this.screensReferenceService.getAdditionalPath(node)
                  })
                );
              });
            }

            // Update fieldsInfo to reflect the current newGrpCols
            const gridChildren = tree.getNodeByKey('table')?.children;
            if (Array.isArray(gridChildren) && this.gridChildrenFlds.length > 0 && props.fields?.length) {
              props.fieldsInfo = gridChildren
                .filter((fld) => props.fields?.includes(fld.key))
                .map((fld) => ({
                  sid: fld.key,
                  fkTableSid: fld.data?.properties?.fkTableSid,
                  fkId: fld.data?.properties?.fkId,
                  fkAppId: fld.data?.properties?.fkAppId
                }));
            }
          }
          if ((props.service || olddata?.service) && !isEqual(props.service, olddata?.service)) {
            if (props.service) {
              this.referencesTasks.addedReference.push(
                this.util.createReference(
                  this.currentSelectedItem.sid,
                  utilEnum.modelType.PAGE,
                  props.service.sid,
                  utilEnum.modelType.SERVICE,
                  this.appId,
                  this.screensReferenceService.getAdditionalPath(node),
                  utilEnum.propertyName.SERVICE,
                  false,
                  { menu: node.data?.id }
                )
              );
              if (props.service.apiGroupId) {
                this.referencesTasks.addedReference.push(
                  this.util.createReference(
                    this.currentSelectedItem.sid,
                    utilEnum.modelType.PAGE,
                    props.service.apiGroupId,
                    utilEnum.modelType.APIGROUP,
                    this.appId,
                    this.screensReferenceService.getAdditionalPath(node),
                    utilEnum.propertyName.APIGROUP_SERVICE_BUTTON,
                    false,
                    { menu: node.data?.id }
                  )
                );
              }
            }
            if (olddata?.service) {
              this.referencesTasks.deletedReference.push(
                this.util.createObjForDelRef(
                  this.currentSelectedItem.sid,
                  olddata?.service.sid,
                  utilEnum.propertyName.SERVICE,
                  { menu: node.data?.id }
                )
              );
              if (olddata?.service.apiGroupId) {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    olddata?.service.apiGroupId,
                    utilEnum.propertyName.APIGROUP_SERVICE_BUTTON,
                    { menu: node.data?.id }
                  )
                );
              }
            }
          }
          if ((props.alignColumns || olddata?.alignColumns) && !isEqual(props.alignColumns, olddata?.alignColumns)) {
            const oldAlignCols = olddata?.alignColumns?.raw?.map((r) => r.id);
            const newAligncols = props.alignColumns?.raw?.map((r) => r.id);
            const dataTorem = oldAlignCols?.filter((f) => !newAligncols?.includes(f));
            const dataToSave = newAligncols?.filter((f) => !oldAlignCols?.includes(f));
            if (dataToSave?.length) {
              dataToSave.forEach((sid) => {
                this.referencesTasks.addedReference.push(
                  this.util.createReference(
                    this.currentSelectedItem.sid,
                    utilEnum.modelType.PAGE,
                    sid,
                    utilEnum.modelType.FIELD,
                    this.appId,
                    this.screensReferenceService.getAdditionalPath(node),
                    utilEnum.propertyName.ALIGN_COLUMNS,
                    false
                  )
                );
              });
            }
            if (dataTorem?.length) {
              dataTorem.forEach((sid) => {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(this.currentSelectedItem.sid, sid, utilEnum.propertyName.ALIGN_COLUMNS)
                );
              });
            }
          }
          if (
            (props.accessControl || olddata?.accessControl) &&
            !isEqual(props.accessControl, olddata?.accessControl)
          ) {
            let oldAcc;
            if (olddata && olddata.accessControl == null) {
              oldAcc = null;
            } else if (olddata && olddata.accessControl != null) {
              oldAcc = [...olddata.accessControl];
            } else {
              oldAcc = [];
            }
            let newAcc = [...props.accessControl];
            const changingToAll = newAcc.includes('all') && !oldAcc?.includes('all');
            if (oldAcc?.includes('all') || newAcc.includes('all')) {
              const roles = this.allRoles?.map((role) => role.sid) || [];
              if (oldAcc.includes('all')) {
                oldAcc = roles;
              }
              if (newAcc.includes('all')) {
                newAcc = roles;
              }
            }
            let rolesTorem;
            if (oldAcc == null) {
              rolesTorem = null;
            } else {
              rolesTorem = oldAcc?.filter((f) => !newAcc?.includes(f));
            }
            const rolesToSave = newAcc?.filter((f) => !oldAcc?.includes(f));
            if (rolesToSave?.length) {
              rolesToSave.forEach((sid) => {
                if (sid !== 'all') {
                  this.referencesTasks.addedReference.push(
                    this.util.createReference(
                      this.currentSelectedItem.sid,
                      utilEnum.modelType.PAGE,
                      sid,
                      utilEnum.modelType.ROLE,
                      this.allRoles[0]?.appId,
                      this.screensReferenceService.getAdditionalPath(node),
                      utilEnum.propertyName.ACCESS_CONTROL,
                      undefined,
                      {
                        menu: node.data?.id
                      }
                    )
                  );
                }
              });
            }
            if (rolesTorem?.length && rolesTorem !== null) {
              rolesTorem.forEach((sid) => {
                if (
                  nType === 'menuitem' ||
                  nType === 'tabitem' ||
                  nType === 'hometile' ||
                  nType === 'menugroup' ||
                  nType === 'tabgroup'
                ) {
                  this.referencesTasks.deletedReference.push(
                    this.util.createObjForDelRef(
                      this.currentSelectedItem.sid,
                      sid,
                      utilEnum.propertyName.ACCESS_CONTROL,
                      { menu: node.data?.id }
                    )
                  );
                } else {
                  this.referencesTasks.deletedReference.push(
                    this.util.createObjForDelRef(
                      this.currentSelectedItem.sid,
                      sid,
                      utilEnum.propertyName.ACCESS_CONTROL
                    )
                  );
                }
              });
            }
          }
          try {
            if (
              (props.conditionForButtonEnable || olddata?.conditionForButtonEnable) &&
              props.conditionForButtonEnable !== olddata?.conditionForButtonEnable
            ) {
              if (props.conditionForButtonEnable) {
                this.referencesTasks.addedReference.push(
                  this.util.createReference(
                    this.currentSelectedItem.sid,
                    utilEnum.modelType.PAGE,
                    JSON.parse(props.conditionForButtonEnable).sid,
                    utilEnum.modelType.QUERY_BUILDER,
                    this.appId,
                    this.screensReferenceService.getAdditionalPath(node),
                    utilEnum.propertyName.BUTTON_ENABLED_CONDITIONAL,
                    true,
                    { path: this.screensReferenceService.getAdditionalPath(node), menu: node.data?.id }
                  )
                );
              }
              if (olddata?.conditionForButtonEnable) {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    JSON.parse(olddata?.conditionForButtonEnable).sid,
                    utilEnum.propertyName.BUTTON_ENABLED_CONDITIONAL,
                    { path: this.screensReferenceService.getAdditionalPath(node), menu: node.data?.id }
                  )
                );
              }
            }
            if (
              (props.conditionForButtonVisiblity || olddata?.conditionForButtonVisiblity) &&
              props.conditionForButtonVisiblity !== olddata?.conditionForButtonVisiblity
            ) {
              if (props.conditionForButtonVisiblity) {
                this.referencesTasks.addedReference.push(
                  this.util.createReference(
                    this.currentSelectedItem.sid,
                    utilEnum.modelType.PAGE,
                    JSON.parse(props.conditionForButtonVisiblity).sid,
                    utilEnum.modelType.QUERY_BUILDER,
                    this.appId,
                    this.screensReferenceService.getAdditionalPath(node),
                    utilEnum.propertyName.BUTTON_VISIBILITY_CONDITIONAL,
                    true,
                    { path: this.screensReferenceService.getAdditionalPath(node), menu: node.data?.id }
                  )
                );
              }
              if (olddata?.conditionForButtonVisiblity) {
                this.referencesTasks.deletedReference.push(
                  this.util.createObjForDelRef(
                    this.currentSelectedItem.sid,
                    JSON.parse(olddata?.conditionForButtonVisiblity).sid,
                    utilEnum.propertyName.BUTTON_VISIBILITY_CONDITIONAL,
                    { path: this.screensReferenceService.getAdditionalPath(node), menu: node.data?.id }
                  )
                );
              }
            }
          } catch (e) {
            console.error(e);
          }
          if ((props.action || olddata?.action) && props.action !== olddata?.action) {
            if (props.action && props.action.includes('-')) {
              this.referencesTasks.addedReference.push(
                this.util.createReference(
                  this.currentSelectedItem.sid,
                  utilEnum.modelType.PAGE,
                  props.action,
                  utilEnum.modelType.ACL_CUSTOM_ACTION,
                  this.appId,
                  this.screensReferenceService.getAdditionalPath(node),
                  utilEnum.propertyName.PAGE_ACTION,
                  false,
                  { menu: node.data?.id }
                )
              );
            }
            if (olddata?.action && olddata?.action.includes('-')) {
              this.referencesTasks.deletedReference.push(
                this.util.createObjForDelRef(
                  this.currentSelectedItem.sid,
                  olddata?.action,
                  utilEnum.propertyName.PAGE_ACTION,
                  { menu: node.data?.id }
                )
              );
            }
          }

          // Component-specific handling for parameterMappingForQueryList pageSection
          if (
            (props.parameterMappingForQueryList || olddata?.parameterMappingForQueryList) &&
            !isEqual(props.parameterMappingForQueryList, olddata?.parameterMappingForQueryList)
          ) {
            this.updateQuickfilterOnParamMap(props);
            const paramMaps = props.parameterMappingForQueryList?.filter((m) => m.staticValue);
            const oldParamMaps = olddata?.parameterMappingForQueryList?.filter((m) => m.staticValue);
            // create or update or delete metainfo for staticValue
            paramMaps
              ?.filter(
                (m) =>
                  m.staticValue?.value !=
                  oldParamMaps?.find((o) => o?.listField?.sid === m.listField?.sid)?.staticValue?.value
              )
              .forEach((s) => {
                if (oldParamMaps?.find((o) => o?.listField?.sid === s.listField?.sid)) {
                  this.pageSection.updatedPageSectionMap = {
                    ...this.pageSection.updatedPageSectionMap,
                    ...{ [s.staticValue?.valueSid]: s.staticValue?.value }
                  };
                } else {
                  this.pageSection.createdPageSectionMap = {
                    ...this.pageSection.createdPageSectionMap,
                    ...{ [s.staticValue?.valueSid]: s.staticValue?.value }
                  };
                }
                // send the updated param Object in the payload
                this.updatedObject = {
                  parameterMapping: s
                };
              });
            oldParamMaps
              ?.filter((m) => !paramMaps?.find((o) => o?.listField?.sid === m.listField?.sid))
              .forEach((s) => {
                this.pageSection.deletedPageSections = [
                  ...this.pageSection.deletedPageSections,
                  s?.staticValue?.valueSid
                ];
              });
          }

          if (
            node.type === 'grid' &&
            (props.defaultFilter || olddata?.defaultFilter) &&
            props.defaultFilter !== olddata?.defaultFilter
          ) {
            this.updateQuickfilterOnDefFilter(node, props);
          } else {
            if ((node.type === 'childList' || node.type === 'standardDatagrid') && Object.prototype.hasOwnProperty.call(props, 'defaultFilter')) {
              const prpCpy = cloneDeep(props);
              delete prpCpy.defaultFilter;
              props = { ...prpCpy };
            }
            if (node.type === 'gridColumn' && Object.prototype.hasOwnProperty.call(props, 'pageTableType')) {
              const prpCpy = cloneDeep(props);
              delete prpCpy.pageTableType;
              props = { ...prpCpy };
              if (
                (props.gridColumnDetailPage || olddata?.gridColumnDetailPage) &&
                props.gridColumnDetailPage?.sid !== olddata?.gridColumnDetailPage?.sid
              ) {
                if (olddata?.gridColumnDetailPage) {
                  this.referencesTasks.deletedReference.push(
                    this.util.createObjForDelRef(
                      this.currentSelectedItem.sid,
                      olddata?.gridColumnDetailPage.sid,
                      this.screensReferenceService.getPropName('gridColumnDetailPage'),
                      { menu: node.data?.id }
                    )
                  );
                }
                if (props.gridColumnDetailPage) {
                  this.referencesTasks.addedReference.push(
                    this.util.createReference(
                      this.currentSelectedItem.sid,
                      utilEnum.modelType.PAGE,
                      props.gridColumnDetailPage.sid,
                      utilEnum.modelType.PAGE,
                      this.appId,
                      this.screensReferenceService.getAdditionalPath(node),
                      this.screensReferenceService.getPropName('gridColumnDetailPage'),
                      false,
                      this.util.updateAdInfoForMapping({ ...adInfo, menu: node.data?.id }, 'gridColumnDetailPage')
                    )
                  );
                }
                // reset the properties if detail page is changed
                props.detailPageMapping = null;
                props.tooltipMessage = null;
                props.enableRecordCreation = true;
                props.holdValueParams = null;
                // refresh property pane if there is a change in detail page
                resetPrps = true;
              }
              if (props.gridColumnDetailPage) {
                const detPage = props.gridColumnDetailPage;
                delete detPage.name;
                props = { ...props, ...{ gridColumnDetailPage: detPage } };
              }
              if (
                (props.detailPageMapping || olddata?.detailPageMapping) &&
                !isEqual(props.detailPageMapping, olddata?.detailPageMapping)
              ) {
                this.screensReferenceService.createOrDelRefForMapping(
                  olddata?.detailPageMapping,
                  props.detailPageMapping,
                  'detailViewParams',
                  node,
                  'tableField',
                  this.util.updateAdInfoForMapping(
                    { ...adInfo, menu: node.data?.id },
                    'tableField',
                    'detailViewParams'
                  ),
                  undefined,
                  undefined,
                  this.getReferenceContext()
                );
                this.screensReferenceService.createOrDelRefForMapping(
                  olddata?.detailPageMapping,
                  props.detailPageMapping,
                  'detailViewParams',
                  node,
                  'lookupField',
                  this.util.updateAdInfoForMapping(
                    { ...adInfo, menu: node.data?.id },
                    'lookupField',
                    'detailViewParams'
                  ),
                  undefined,
                  undefined,
                  this.getReferenceContext()
                );
              }
              if (
                (props.holdValueParams || olddata?.holdValueParams) &&
                !isEqual(props.holdValueParams, olddata?.holdValueParams)
              ) {
                this.screensReferenceService.createOrDelRefForMapping(
                  olddata?.holdValueParams,
                  props.holdValueParams,
                  'holdValueParams',
                  node,
                  'detailField',
                  this.util.updateAdInfoForMapping(adInfo, 'detailField', 'holdValueParams'),
                  undefined,
                  undefined,
                  this.getReferenceContext()
                );
                this.screensReferenceService.createOrDelRefForMapping(
                  olddata?.holdValueParams,
                  props.holdValueParams,
                  'holdValueParams',
                  node,
                  'listField',
                  this.util.updateAdInfoForMapping(adInfo, 'listField', 'holdValueParams'),
                  undefined,
                  undefined,
                  this.getReferenceContext()
                );
              }
            }

            // Remove pageTableType from page properties (added by dropdown for filtering, should not persist)
            const pageProps = ['page', 'pageName', 'detailPage', 'gridColumnDetailPage'];
            pageProps.forEach((pgPrp) => {
              if (props[pgPrp]?.pageTableType) {
                delete props[pgPrp].pageTableType;
              }
            });
            node.properties = props;
            node.data.properties = props;
            if (resetPrps) {
              this.handleNodeClick(null, { node: node });
            }
            this.saveFancyTree('listenForPropertyChanges');
            this.isPendingSave = true;
            this.debounceSaveTree('listenForPropertyChanges');
          }
        }
      }
    });
    this.addToSubscriptionsList(this.valueChangeListener);
  }

  /**
   * Creates the ReferenceContext object needed by ScreensReferenceService methods
   */
  private getReferenceContext(): ReferenceContext {
    return {
      referencesTasks: this.referencesTasks,
      currentSelectedItem: this.currentSelectedItem,
      appId: this.appId,
      allRoles: this.allRoles,
      foreignKeys: this.foreignKeys,
      allSelectedScreens: this.allSelectedScreens,
      screenLookupDefinitionDetails: this.screenLookupDefinitionDetails,
      pageSection: this.pageSection,
      updatedObject: this.updatedObject,
      gridChildrenFlds: this.gridChildrenFlds
    };
  }

  getAllScreens() {
    //  this.isLoadingScreens = true;
    this.loader.show();
    if (this.isFromModernize) {
      this.getAllScreensInterim();
      return;
    }
    const apiConstants = ApiConstants.getAllScreens;
    this.store.dispatch(
      getScreens({
        getScreensApiConstants: apiConstants
      })
    );
    const fieldIdMapping = this.store.select(metaInfo);
    this.allScreens$ = this.store.select(allScreens);
    const allScreensSub = combineLatest(fieldIdMapping, this.allScreens$).subscribe((data: any) => {
      //this.allScreens$ = this.store.select(allScreens).subscribe((scs: any) => {
      if (!data[0] || !data[1] || data[1].length === 0) {
        return;
      }

      this.fieldIdMap = data[0];
      this.tableIdMap = data[0];

      this.appUserTableId = this.appGlobalService.get('appTableId');
      const scs = data[1];
      if (scs && scs.length) {
        //this.allSelectedScreens = [...this.allSelectedScreens, ...scs];
        let allScreens: any[] = [];
        if (this.allSelectedScreens?.sysGenScreens) {
          allScreens = [
            ...(this.allSelectedScreens?.sysGenScreens ?? {}),
            ...(this.allSelectedScreens?.userGenScreens ?? {}),
            ...scs
          ];
        } else {
          allScreens = [...scs];
        }
        let sysGenScreens: any[] = [];
        let userGenScreens: any[] = [];
        const hasLanding = false;
        allScreens.map((as: any) => {
          if (as.sysGen) {
            sysGenScreens.push(as);
          } else {
            userGenScreens.push(as);
          }
        });
        const sysGenPageNames = ['App Navigation', 'Home Page', 'Application User Detail', 'Application User List'];
        sysGenScreens = uniqBy(sysGenScreens, 'pageName');
        sysGenScreens.sort((a: any, b: any) => {
          return sysGenPageNames.indexOf(a.pageName) - sysGenPageNames.indexOf(b.pageName);
        });
        userGenScreens = uniqBy(orderBy(userGenScreens, ['pageName'], ['asc']), 'pageName');
        userGenScreens = uniqBy(userGenScreens, 'sid');
        this.allSelectedScreens.sysGenScreens = sysGenScreens;
        this.allSelectedScreens.userGenScreens = userGenScreens;
        const navigationPage: any[] = sysGenScreens.filter((x: any) => x.pageName === 'App Navigation');
        if (navigationPage.length > 0) {
          this.navigationPageSid = navigationPage[0]?.sid;
        }
        if (this.updatedPageData && this.updatedPageData.length > 0) {
          this.allSelectedScreens.userGenScreens.forEach((scr) => {
            if (
              this.updatedPageData.findIndex((pg) => {
                return pg.sid === scr.sid;
              }) > -1
            ) {
              scr =
                this.updatedPageData[
                this.updatedPageData.findIndex((pg) => {
                  return pg.sid === scr.sid;
                })
                ];
            }
            // Perform operations on each item
          });
          // const index = this.allSelectedScreens.userGenScreens.findIndex((fld) => { return fld.sid === this.updatedPageData.sid});
          // if (index > -1) {
          //   this.allSelectedScreens.userGenScreens[index]=this.updatedPageData;
          //   //  this.store.dispatch(setSelectedScreens({ selectedScreens: [...this.allSelectedScreens] }));
          // }
        }
        //this.isLoadingScreens = false;
        this.loader.hide();
        this.triggeredScreenCreation = false;
      }
    });
    this.addToSubscriptionsList(allScreensSub);
    let landScrSub = this.store.select(landScrId).subscribe((id) => {
      if (id && this.allSelectedScreens) {
        const modScr = { sysGenScreens: [], userGenScreens: [] };
        modScr.sysGenScreens = (this.allSelectedScreens.sysGenScreens || []).map((scr) => {
          if (scr.sid === id) {
            scr = { ...scr, landingPage: true };
          } else {
            scr = { ...scr, landingPage: false };
          }
          return scr;
        });
        modScr.userGenScreens = (this.allSelectedScreens.userGenScreens || []).map((scr) => {
          if (scr.sid === id) {
            scr = { ...scr, landingPage: true };
          } else {
            scr = { ...scr, landingPage: false };
          }
          return scr;
        });
        this.loader.hide();
        this.allSelectedScreens = { ...modScr };
        this.allSelectedScreens.userGenScreens = [...this.allSelectedScreens.userGenScreens.filter((fld) => !fld[0])];
        console.log(this.allSelectedScreens);
      }
    });
    this.addToSubscriptionsList(landScrSub);
  }

  getAllScreensInterim() {
    this.isLoadingPagesList = true;
    const fieldIdMapping = this.store.select(metaInfo);
    const fieldIdSub = fieldIdMapping.subscribe((data: any) => {
      if (data) {
        this.fieldIdMap = data;
        this.tableIdMap = data;
      }
    });
    this.addToSubscriptionsList(fieldIdSub);
    this.store.dispatch(
      ScreenInterimActions.getScreensInterim({
        getScreensInterimApiConstants: ApiConstants.getAllScreensInterim,
        payloadWithPathVariables: {
          generationId: this.generationId,
          start: 0,
          length: this.pageLimitMax,
          order: [],
          removeUrlVariables: ['generationId']
        }
      })
    );
    const interimScreensSub = this.store.select(allInterimScreens).subscribe((scs: any) => {
      if (!scs || scs.length === 0) {
        this.loader.hide();
        this.isLoadingPagesList = false;
        return;
      }
      const allInterim = uniqBy(orderBy(scs, ['pageName'], ['asc']), 'sid');
      const sysGenScreens = allInterim.filter((s: any) => s.sysGen === true || s.pageType === 'appNavigation' || s.pageType === 'app_navigation');
      const userGenScreens = allInterim.filter((s: any) => !s.sysGen && s.pageType !== 'appNavigation' && s.pageType !== 'app_navigation');
      this.allSelectedScreens.sysGenScreens = sysGenScreens;
      this.allSelectedScreens.userGenScreens = userGenScreens;
      this.loader.hide();
      this.isLoadingPagesList = false;
      this.triggeredScreenCreation = false;
    });
    this.addToSubscriptionsList(interimScreensSub);
  }

  loadStructureInterim(event: any, screen: any, type?: string) {
    const activeElement = document.activeElement as HTMLElement;
    if (
      activeElement &&
      ['INPUT', 'TEXTAREA'].includes(activeElement.tagName) &&
      activeElement.closest('.properties-pane')
    ) {
      activeElement.blur();
    }
    try {
      this.activeScreen = screen;
      this.currentSelectedItem = screen;
      this.selectedScreen.emit(this.currentSelectedItem);

      if (this.pendingService.isPending.getValue()) {
        this.isLoadingScreens = true;
        this.debounceStructure(event, screen, type);
        return;
      }
      this.debounceSaveTree.cancel();

      if (this.isPendingSave) {
        this.saveFancyTreeData();
      }
      $(':ui-fancytree').fancytree('destroy');
      this.store.dispatch(setPropertiesData({ propertiesData: null }));
      this.store.dispatch(ScreenInterimActions.setScreenStructureInterim({ screenStructureInterim: null }));
      this.selectedNodeTitle = '';
      const currTableId = this.currentSelectedItem.tableId;
      this.currentTableName = this.tableIdMap[currTableId];
      this.appUserTableId = this.appUserTableId ? this.appUserTableId : this.appGlobalService.get('appTableId');
      this.qbService.configureQueryBuilder(this.appUserTableId, currTableId, this.currentTableName);
      this.currentTableName = this.tableIdMap[currTableId];

      this.taskstoSave = null;
      this.isLoadingScreens = true;
      const interimApi: any = { ...ApiConstants.getScreenInterim, showErrorMsg: false };
      this.store.dispatch(
        ScreenInterimActions.getScreenStructureInterim({
          getScreenStructureInterimApiConstants: interimApi,
          sid: { screenSid: screen.sid }
        })
      );

      // Unsubscribe previous structure subscription to avoid stuck loaders
      if (this.activeStructureSub) {
        this.activeStructureSub.unsubscribe();
        this.activeStructureSub = null;
      }
      const screenSub$ = this.store.select(selectedScreenInterim);
      const loadScreenSub = screenSub$.subscribe((data: any) => {
        if (this.processScreenInterimData(data, screen.sid)) {
          loadScreenSub?.unsubscribe();
          this.activeStructureSub = null;
        }
      });
      this.activeStructureSub = loadScreenSub;
      this.addToSubscriptionsList(loadScreenSub);
    } catch (e) {
      console.error(e);
      this.isLoadingScreens = false;
      this.loader.hide();
    }
  }

  private processScreenInterimData(data: any, screenSid: string): boolean {
    if (!data) {
      return false;
    }
    // Handle error marker from failed API calls — clear loader and stop waiting
    if (data._error) {
      this.isLoadingScreens = false;
      this.loader.hide();
      // Re-fetch the screens list so stale entries (deleted/regenerated pages) are removed
      if (this.isFromModernize && this.generationId) {
        this.store.dispatch(
          ScreenInterimActions.getScreensInterim({
            getScreensInterimApiConstants: ApiConstants.getAllScreensInterim,
            payloadWithPathVariables: {
              generationId: this.generationId,
              start: 0,
              length: this.pageLimitMax,
              order: [],
              removeUrlVariables: ['generationId']
            }
          })
        );
      }
      return true;
    }
    const screenData = data;
    if (this.currentSelectedItem?.pageType == 'list' || this.currentSelectedItem?.pageType == 'detail') {
      this.formPickListForListandDetailPages(screenData?.tableId, screenData?.pageType);
    }
    this.currentScreenFieldIds = screenData.fieldIds ? [...screenData.fieldIds] : [];
    if (!screenData?.sid || screenData.sid !== screenSid) {
      return false;
    }
    try {
      let structure = screenData.contentAttachment ? JSON.parse(screenData.contentAttachment) : null;
      this.screensResData = screenData;
      if (structure === undefined) {
        this.isLoadingScreens = false;
        this.loader.hide();
        return false;
      }
      if (structure === null) {
        structure = [
          {
            title: 'No Data to Display',
            key: 'noData'
          }
        ];
      }
      if ($('.fancytree-edit-input')) {
        $('.fancytree-edit-input').off('keydown');
      }
      this.initTree(structure);
      this.isLoadingScreens = false;
      this.loader.hide();
      if (structure[0].key !== 'loadingData') {
        this.tabViewTitles = [];
        this.tabTitles = {};
        this.getAllTitlesInfo(structure);
      }
      return true;
    } catch (e) {
      console.error('Error processing screen interim structure:', e);
      this.isLoadingScreens = false;
      this.loader.hide();
      return true;
    }
  }

  deleteScreenInterimById(sid) {
    this.store.dispatch(
      ScreenInterimActions.deleteScreenInterim({
        deleteScreenInterimApi: ApiConstants.deleteScreenInterim,
        screenId: { screenId: sid }
      })
    );
    const deletedInterimSub = this.store.select(deletedScreenInterimId).subscribe((deletedId: any) => {
      if (deletedId && deletedId?.screenId === sid) {
        this.allSelectedScreens.userGenScreens = this.allSelectedScreens.userGenScreens.filter(
          (sc: any) => sc.sid !== sid
        );
        this.isLoadingScreens = false;
        this.resetPropertyPane();
        // Reload active screen's tree structure to pick up cascading changes
        // (e.g. backend removes deleted page's standard datagrid/child grid references from other screens,
        // and clears the deleted page's menu item from appNavigation)
        if (this.activeScreen && this.activeScreen.sid !== sid) {
          this.loadStructureInterim(null, this.activeScreen);
        }
        deletedInterimSub?.unsubscribe();
      }
    });
    this.addToSubscriptionsList(deletedInterimSub);

    // Also handle delete failure so the loader doesn't get stuck
    const deleteFailSub = this.actions$.pipe(
      ofType(ScreenInterimActions.deleteScreenInterimFailure),
      take(1)
    ).subscribe((action: any) => {
      if (action?.screenId?.screenId === sid) {
        this.isLoadingScreens = false;
        this.loader.hide();
      }
    });
    this.addToSubscriptionsList(deleteFailSub);
  }

  resetPropertyPane() {
    setTimeout(() => {
      this.store.dispatch(setPropertiesData({ propertiesData: null }));
    }, 10);
  }

  adjustPanelSizes(type: string) {
    /* if (type==='in') {
      this.panelSizes = [20, 20, 1, 59];
    } else if (type==='out') {
      this.panelSizes = [30, 30, 30, 10];
    } */
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    //this.setPageHeight();
    this.deboucedPgeHeight();
  }

  setPageHeight() {
    const headerHt = $('#vbHeader').outerHeight();
    let pageHeaderHt = $('#vbPageHeader').outerHeight();
    pageHeaderHt = pageHeaderHt ? pageHeaderHt : 0;
    const windowHt = $(window).height();

    // console.log(windowHt - (headerHt + pageHeaderHt));
    const pageHeight = windowHt ?? 0 - (headerHt ?? 0 + pageHeaderHt + 40);
    const div = this.splitter?.el?.nativeElement?.querySelector('.p-splitter');
    if (div) {
      div.style.height = `${pageHeight}px`;
    }
  }

  deboucedPgeHeight = debounce(this.setPageHeight.bind(this), 500);

  openInNewWindow() {
    const win = window.open();
    if (win) {
      win.document.write(
        '<iframe src="./assets/quickpreview/index.html" frameborder="0" id="protoIframe" style="width: 100%; height: 100vh;" allowfullscreen ></iframe>',
        '_self',
        'toolbar=0,scrollbars=1,resizable=0,location=0,menubar=0,status=0,titlebar=0,height=700,width=500'
      );
    }
  }

  showVisualizer() {
    this.isShowVisualizer = !this.isShowVisualizer;
    if (this.isShowVisualizer) {
      this.showPreview = true;
      this.isSlideInLeft = false;
      const appDataSub = this.store.select(appDataWithId).subscribe((appdata: any) => {
        // console.log(appdata);
        if (appdata) {
          this.store.dispatch(
            getSidBasedApps({
              apiConstants: ApiConstants.getAppById,
              sid: appdata
            })
          );
          let selectApp$;
          selectApp$ = this.store.select(appData).subscribe((appdata: any) => {
            if (appdata && appdata.prototypingAppUrl) {
              if (selectApp$) {
                selectApp$.unsubscribe();
              }
              // console.log(appdata);
            }
          });
        }
      });
      this.addToSubscriptionsList(appDataSub);
    } else {
      this.isSlideInLeft = true;
    }
  }

  formQueryBuilderProperties(fields, qbProperties) {
    fields.forEach((e) => {
      if (!e.name) {
        return;
      }
      let type = e.f_type.toLowerCase();
      let qbType = '';
      const fieldObj: any = { name: e.name, sid: e.sid };
      let operators: ['=', '!='];
      if (type === 'lookup') {
        qbType = 'string';
        fieldObj.nullable = true;
      } else if (type === 'dropdown' || type === 'radio' || type === 'checkbox') {
        if (e.allowedValues) {
          qbType = 'category';
          const options: any[] = [];
          const allowedValues = JSON.parse(e.allowedValues)?.values;
          allowedValues.forEach((value) => {
            const obj: any = {};
            obj.name = value;
            obj.value = value;
            options.push(obj);
          });
          fieldObj.options = options;
        } else {
          qbType = 'string';
        }
      } else if (type === 'date') {
        fieldObj.defaultValue = () => new Date();
        qbType = 'date';
      } else if (type === 'datetime') {
        qbType = 'time';
        fieldObj.defaultValue = () => new Date();
      } else if (type === 'number') {
        qbType = 'number';
      } else {
        qbType = 'string';
        fieldObj.nullable = true;
      }
      if (qbType) {
        type = qbType;
      }
      const field = { ...fieldObj, type: type, entity: e.tableId };
      qbProperties.push(field);
      this.qbFields[e.sid] = field;
    });
  }
  formCustomQBproperties() {
    const custom: any = {
      name: 'Custom',
      sid: 'custom'
    };
    const fieldObj = { name: 'Custom', sid: 'custom', type: 'string', entity: 'custom' };
    custom.fields = fieldObj;
    this.qbFields[fieldObj.sid] = fieldObj;
    return custom;
  }

  configureQueryBuilderProperties(fields?: any) {
    this.qbFields = {};
    const entities = {};
    const groupedFields: any[] = [];
    if (fields) {
      const tableFields: any[] = [];
      this.formQueryBuilderProperties(fields, tableFields);
      const tableId = fields[0].tableId;
      entities[tableId] = { name: this.currentTableName };
      const obj = { name: this.currentTableName, sid: tableId, fields: tableFields };
      groupedFields.push(obj);
    }

    /** Application user table is selected for ACl */
    const appUserFields = [];
    this.formQueryBuilderProperties(this.appUserFields, appUserFields);
    const tableName = 'Application User';
    entities[this.appUserTableId] = { name: tableName };
    const appUserObj = { name: tableName, sid: this.appUserTableId, fields: appUserFields };
    groupedFields.push(appUserObj);

    const customFields = this.formCustomQBproperties();
    const qbPropertiesUpdate = {
      groupedFields: groupedFields,
      entities: entities,
      fields: this.qbFields,
      groupedInputFields: [...groupedFields, customFields]
    };
    this.store.dispatch(setQBProperties({ qbProperties: qbPropertiesUpdate }));
  }
  getAppUrl() {
    const appDataSub = this.store.select(selectedAppData).subscribe((app: any) => {
      if (app?.name) {
        const appId = {
          appId: app.sid
        };
        if (!app?.prototypingAppUrl) {
          this.store.dispatch(
            getGeneratedAppUrl({
              apiConstants: ApiConstants.getAppById,
              sid: app.sid
            })
          );
          this.store.select(genUrl).subscribe((genUrl: any) => {
            if (genUrl?.prototypingAppUrl) {
              this.prototypingAppUrl = genUrl.prototypingAppUrl;
              this.genAppUrl = true;
            } else {
              this.prototypingAppUrl = '';
              this.genAppUrl = false;
            }
          });
        } else {
          this.genAppUrl = true;
          this.prototypingAppUrl = app.prototypingAppUrl;
        }
        if (!this.disallowEdit) {
          this.genAppUrl = true;
        }
      }
    });
    this.addToSubscriptionsList(appDataSub);
  }

  setLandingScreen(screen) {
    const apiConstants = { ...ApiConstants.landingScreen };
    apiConstants.url += `/${this.appId}/${screen.sid}/${this.tabId}`;
    this.loader.show();
    this.store.dispatch(
      setLandngScreen({
        apiConstants
      })
    );
  }
  /**
   * to handle contextmenu click 3dots
   */
  contextMenuClick() {
    $('.p-contextmenu.p-component').css('display', 'none');
  }

  hasTilesMenuItems(screen: any): boolean {
    if (this.pageViewMode !== 'tiles') {
      return false;
    }

    const isAppNavigation = screen?.pageName === 'App Navigation' && screen?.sysGen;
    const canMarkLanding = !screen?.landingPage && !this.disallowEdit && !this.isFromModernize && !isAppNavigation;
    const canManagePage = !this.disallowEdit && !this.isFromModernize && !screen?.sysGen;

    return canMarkLanding || canManagePage;
  }

  showLandingPageMenu(evt: Event, screen) {
    const isAppNavigation = screen.pageName === 'App Navigation' && screen.sysGen;
    const canMarkLanding = !screen.landingPage && !this.disallowEdit && !this.isFromModernize && !isAppNavigation;
    const canManagePage = !this.disallowEdit && !this.isFromModernize && !screen?.sysGen;

    // Keep list-view menu behavior unchanged.
    if (this.pageViewMode !== 'tiles') {
      if (!canMarkLanding) {
        this.ctxtItems = [];
        evt.preventDefault();
        return;
      }
      this.ctxtItems = [
        {
          label: this.translate.instant('MARK_AS_LANDING_PAGE'),
          icon: 'pi pi-home tiles-menu-icon tiles-menu-icon--muted',
          command: () => {
            this.setLandingScreen(screen);
          }
        }
      ];
    } else {
      const items: MenuItem[] = [];

      if (canMarkLanding) {
        items.push({
          label: this.translate.instant('MARK_AS_LANDING_PAGE'),
          icon: 'pi pi-home tiles-menu-icon tiles-menu-icon--muted',
          command: () => {
            this.setLandingScreen(screen);
          }
        });
      }

      if (canManagePage) {
        items.push({
          label: this.translate.instant('WHERE_USED'),
          icon: 'pi pi-search tiles-menu-icon tiles-menu-icon--muted',
          command: () => {
            this.showWhereUsed(evt, screen);
          }
        });
        items.push({
          label: this.translate.instant('EDIT'),
          icon: 'pi pi-pencil tiles-menu-icon tiles-menu-icon--muted',
          command: () => {
            this.editScreen(evt, screen);
          }
        });
        items.push({
          label: this.translate.instant('DELETE'),
          icon: 'pi pi-trash tiles-menu-icon tiles-menu-icon--danger',
          styleClass: 'tiles-menu-item-danger',
          command: () => {
            this.deleteScreen(evt, screen);
          }
        });
      }

      this.ctxtItems = items;
      if (this.ctxtItems.length === 0) {
        evt.preventDefault();
        return;
      }
    }

    $('.p-contextmenu').css('visibility', '');
    this.ctxtmenu.show(evt);
    evt.stopPropagation();
    evt.preventDefault();
  }

  getTemplates() {
    this.store.dispatch(
      getTemplates({
        apiConstants: ApiConstants.getTemplates
      })
    );
    const temSub = this.store.select(templatesData).subscribe((data: any) => {
      this.seletedTemplate = data.find((d) => d.selected);
    });
    this.subscriptions.push(temSub);
  }
  getQueryTbls() {
    this.store.dispatch(setTablesForQuery({ queryTables: null }));
    this.store.dispatch(getTablesForQuery({ queryTblsApiConstants: ApiConstants.getAllTables }));
  }

  ngOnInit(): void {
    this.appId = this.appGlobalService.get('appId');
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['origin'] === 'companion' && params['msgId']) {
        this.originQueryParams = {
          origin: params['origin'],
          msgId: params['msgId']
        };
        // Activate visualizer mode instead of regular designer mode
        this.isShowVisualizer = true;
      } else {
        this.isShowVisualizer = false;
      }
    });
    if (!this.isFromModernize) {
      const selectedAppSub = this.store.select(selectedAppData).subscribe((app: any) => {
        if (app) {
          this.applicationType = app.applicationType;
          if ([utilEnum.ApplicationTypes.SUITE, utilEnum.ApplicationTypes.MEMBER].indexOf(this.applicationType) > -1) {
            this.sharedDbId = app.sharedDb;
            this.suiteId = app.suiteId;
            if (this.suiteId) {
              const techSub = this.bs['get'](ApiConstants.getTechnologyStackBySuiteId, {
                suiteid: this.suiteId,
                shareddbid: this.sharedDbId
              }).subscribe((techStackData: any) => {
                this.techStack = techStackData;
                if (techStackData && techStackData.transactionDb == GlobalConstants.transactionDbRdbms) {
                  this.isRDBMS = true;
                }
              });
              this.addToSubscriptionsList(techSub);
              const suiteId = { suiteId: this.suiteId };
              this.store.dispatch(
                getMsScreenData({ msScrDataApiConstants: ApiConstants.getScreensForMemAndSuiteApp, suiteId })
              );
              const msScreenDataSub = this.store.select(msScreenData).subscribe((res: any) => {
                // intentional no-op
              });
              this.addToSubscriptionsList(msScreenDataSub);
            }
          } else {
            const techSub = this.bs['get'](ApiConstants.getTechnologyStackByAppId, { appId: this.appId }).subscribe(
              (techStackData: any) => {
                this.techStack = techStackData;
                if (techStackData && techStackData.transactionDb == GlobalConstants.transactionDbRdbms) {
                  this.isRDBMS = true;
                }
              });
            this.addToSubscriptionsList(techSub);
            // getMsScreenData is intentionally not dispatched for Independent apps to avoid 405 errors (missing suiteId)
          }
        }
      });
      this.addToSubscriptionsList(selectedAppSub);
    }
    this.appId = this.appGlobalService.get('appId');
    this.orgId = this.appGlobalService.get('orgId');
    this.userName = `${this.appGlobalService.get('userRoles')?.firstName} ${this.appGlobalService.get('userRoles')?.lastName}`;
    window.addEventListener('scroll', this.scroll, true);
    this.tabId = this.appGlobalService.get('tabId');
    //this.isLoadingScreens = true;
    this.util.setService(false);
    this.loader.show();
    if (!this.util.checkEditPermission('pages')) {
      this.disallowEdit = true;
    }

    this.getAllProps();
    if (!this.isFromModernize) {
      this.getQueryTbls();
    }
    this.resetPropertyPane();
    this.getAllScreens();
    this.getTemplates();
    this.initialLoad = true;

    const fsLoginInitiatedSub = this.store.select(fsLoginInitiated).subscribe((fsLogin: any) => {
      //console.log("fsLogin " + fsLogin);
      if (fsLogin) {
        this.attachScreenInfoListner();
      } else {
        this.unSubscribeListener();
      }
    });

    this.subscriptions.push(fsLoginInitiatedSub);
    const scrSub = this.store.select(updatedScreenData).subscribe((screenData: any) => {
      //console.log("fsLogin " + fsLogin);
      if (screenData && screenData?.screen?.fieldIds) {
        this.currentScreenFieldIds = [...(screenData?.screen?.fieldIds ?? {})];
      }
    });
    this.addToSubscriptionsList(scrSub);

    // Refresh screen structure after page variable deletion to update contentAttachment
    const deletePageVarSub = this.store
      .select(deletePageVariableSuccess)
      .pipe(skip(1))
      .subscribe((response: any) => {
        if (response?.pageVariableSid && this.currentSelectedItem?.sid) {
          const api: any = { ...ApiConstants.getScrById };
          this.store.dispatch(
            getScreenStructure({ getScreenStructureApiConstants: api, sid: { sid: this.currentSelectedItem.sid } })
          );

          // Subscribe to get the refreshed screen data and reinitialize the tree
          const refreshScreenSub = this.store
            .select(selectedScreen)
            .pipe(skip(1))
            .subscribe((data: any) => {
              if (data && data.sid === this.currentSelectedItem?.sid) {
                const structure = data.contentAttachment ? JSON.parse(data.contentAttachment) : null;
                this.screensResData = data;
                this.currentScreenFieldIds = data.fieldIds ? [...data.fieldIds] : [];
                if (structure) {
                  if ($('.fancytree-edit-input')) {
                    $('.fancytree-edit-input').off('keydown');
                  }
                  this.initTree(structure);
                  this.tabViewTitles = [];
                  this.tabTitles = {};
                  this.getAllTitlesInfo(structure);
                }
                if (refreshScreenSub) {
                  refreshScreenSub.unsubscribe();
                }
              }
            });
        }
      });
    this.addToSubscriptionsList(deletePageVarSub);
    this.listenForPropertyChanges();
    if (!this.isFromModernize) {
      this.getAppUrl();
    }
    this.appForm = new FormGroup({
      name: new FormControl('')
    });

    this.createScreenForm = new FormGroup({
      screenType: new FormControl('fromTable', [Validators.required]),
      tableName: new FormControl(''),
      pageName: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z0-9_]*[a-zA-Z0-9]$/)]),
      pageType: new FormControl('', [Validators.required])
    });

    this.items = [
      {
        label: 'Generate Pages',
        icon: this.isBetaAccessPrivilegeConsumable ? 'pi pi-bolt' : 'pi pi-file-plus',
        command: () => {
          this.createScreens();
        }
      },
      {
        label: 'Create Page',
        icon: this.isBetaAccessPrivilegeConsumable ? 'pi pi-file' : 'pi pi-file-plus',
        command: () => {
          this.createScreen();
        }
      }
    ];

    $('body').addClass('screens-overlay');
    const genSub = this.store.select(genUrl).subscribe((appData: any) => {
      if (appData?.prototypingAppUrl) {
        this.genAppUrl = true;
      }
    });
    this.addToSubscriptionsList(genSub);
    const apiConstants = ApiConstants.getRolesData;
    this.store.dispatch(
      getRoles({
        apiConstants,
        filter: {
          start: 0,
          length: 1000
        }
      })
    );
    const rolesSub = this.store.select(rolesTable).subscribe((allTables: any) => {
      if (allTables) {
        this.allRoles = cloneDeep(allTables.rolesTable);
      }
    });
    this.addToSubscriptionsList(rolesSub);

    this.listenUserInfo();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initTree([
        {
          title: 'No Data to Display',
          key: 'noData'
        }
      ]);
    }, 100);
    this.setPageHeight();
    const _this = this;
    $(`${this.getTreeSelector()} *`).on('click', function () {
      _this.rearrageTreeLegIndicator();
    });
  }

  ngOnDestroy(): void {
    this.util.destroyFancyTreeSubscriptions($(this.getTreeSelector()));
    window.removeEventListener('scroll', this.scroll, true);
    // All subscription will get cleard using Autounsubscribe decorator
    this.unSubscribeListener();
    this.valueChangeListener.unsubscribe();
    this.debounceSaveTree.cancel();
    if (this.taskstoSave) {
      this.saveFancyTreeData('ondestroy');
    }
    this.store.dispatch(
      setSelectedScreens({
        selectedScreens: []
      })
    );
    this.store.dispatch(setScreenStructure({ selectedScreenStructure: null }));
    this.store.dispatch(ScreenInterimActions.setScreenStructureInterim({ screenStructureInterim: null }));
    this.store.dispatch(setPropertiesData({ propertiesData: null }));
    let treeSelector = this.getTreeSelector();
    $(`${treeSelector} tr`).off('click');
    $(`${treeSelector} tr`).find('#filter').off('keyup');
    $(`${treeSelector} tr`).find('#filter').off('search');
    $(`${treeSelector} .fancytree-edit-input`).off('keydown');
    $(`${treeSelector}`).fancytree('destroy');
    $(`${treeSelector} tr`).off();
    $(`${treeSelector} tr`).remove();
    $(`${treeSelector}`).remove();
    if (this.splitter?.el?.nativeElement) {
      $(this.splitter.el?.nativeElement).remove();
    }
    $('body').removeClass('screens-overlay');
  }

  clearFilter(par?: any) {
    if (par === 'dialog') {
      this.fieldSearch = '';
      if (this.referredFields.length) {
        this.searchTbl.filterGlobal('', 'contains');
      }
    } else if (par === 'pagedesign') {
      this.pageDesignSearchTerm = '';
    } else {
      this.searchTerm = '';
    }

    const tree = $.ui.fancytree.getTree(this.getTreeSelector());
    tree.clearFilter();
  }

  getDefaultValues(actionModulerType: any) {
    this.formDefaultValues = {};
    this.formDefaultValues = this.util.getDefaultValues(
      actionModulerType,
      this.filteredDefaultValues,
      this.formDefaultValues,
      this.allProps
    );
  }

  public resizeStartHandler(e) {
    this.sizes = [...e.sizes];
  }

  public resizeEndHandler(e) {
    if (e.sizes.some((size) => size > this.maxSize)) {
      this.panelSizes = [...this.sizes];
    }
  }

  rearrageTreeLegIndicator(timeout = 0) {
    setTimeout(() => {
      $('.fancytree-folder').each((i, item: any) => {
        const vl: any = $(item).find('.vertical-line');
        const ftnode = item.ftnode;
        if (ftnode.children && ftnode.expanded) {
          const linkNode = ftnode.children[ftnode.children.length - 1];
          const linkRowLine: any = $(linkNode.tr).find('.horizondal-line');
          if (linkRowLine && linkRowLine.offset()) {
            vl.css('display', 'block');
            const vlTop = vl?.offset()?.top ?? 0;
            const hrTop = linkRowLine?.offset()?.top ?? 0;
            vl.css('height', `${hrTop - vlTop - 0}px`);
            vl.css('display', 'block');
          }
          ftnode.children.forEach((child) => {
            const childNode = $(child.tr).find('.horizondal-line');
            $(childNode)
              .removeClass()
              .addClass(`horizondal-line level${ftnode.getLevel() + 1}`);
          });
        } else {
          vl.css('display', 'none');
        }
      });
    }, timeout);
  }
  /**
   *
   * @param event
   * method to trigger context menu on left click
   */
  openContextMenu(event) {
    try {
      $(event.currentTarget).parent().parent().parent().find('.fancytree-title').contextMenu();
      $('.context-menu-list').css('visibility', 'hidden');
      setTimeout(() => {
        $('.context-menu-list').css('left', event.clientX);
        $('.context-menu-list').css('visibility', 'visible');
      }, 0);
    } catch (e) {
      console.error(e);
    }
  }

  private hasContextMenuItems(node: any): boolean {
    try {
      const tree = $.ui.fancytree.getTree(this.getTreeSelector());
      const menuFn = tree?.options?.contextMenu?.menu;
      if (node && typeof menuFn === 'function') {
        const menu = menuFn(node);
        return !!menu && typeof menu === 'object' && Object.keys(menu).length > 0;
      }
    } catch {
      return true;
    }
    return true;
  }
  opencontextMenuItems(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  attachScreenInfoListner() {
    const version = this.appGlobalService.get('appVersion');
    const queryObject = {
      collectionName: `ScreenActions_${version}`,
      filter: [
        {
          field: 'appId',
          operator: '==',
          value: this.appId
        }
      ]
    };

    this.unSubscribeListener();
    try {
      const fsSub1 = this.fsService.fireService(queryObject).subscribe(
        (res) => {
          if (!this.initialLoad) {
            const data = res
              .filter((obj) => !obj.payload.doc.metadata.hasPendingWrites && !obj.payload.doc.metadata.fromCache)
              .map((dt) => {
                const rec = dt.payload.doc.data();
                if (this.activeScreen && rec.sid === this.activeScreen.sid) {
                  this.updateActiveScreen(rec);
                } else if (rec.ScreenActionStatus === 'CREATED') {
                  this.loadCreatedScreen(rec);
                } else if (rec.ScreenActionStatus === 'DELETED') {
                  this.allSelectedScreens.userGenScreens = this.allSelectedScreens.userGenScreens.filter(
                    (e) => e.sid !== rec.sid
                  );
                  this.allSelectedScreens.sysGenScreens = this.allSelectedScreens.sysGenScreens.filter(
                    (e) => e.sid !== rec.sid
                  );
                  let screenData =
                    this.allSelectedScreens.sysGenScreens.length > 0 ? this.allSelectedScreens.sysGenScreens : [];
                  if (this.allSelectedScreens.userGenScreens.length > 0) {
                    screenData = [...screenData, ...this.allSelectedScreens.userGenScreens];
                  }
                  this.store.dispatch(setSelectedScreens({ selectedScreens: screenData }));
                  this.store.dispatch(setScreenStructure({ selectedScreenStructure: null }));
                } else if (rec.ScreenActionStatus === 'UPDATED') {
                  this.updateScreen(rec);
                }
                return { sid: rec.sid };
              });
          } else {
            this.initialLoad = false;
          }
        },
        (error) => {
          console.error(error);
        }
      );
      this.attachScreenListnerSubscription.push(fsSub1);
    } catch (e) {
      console.error(e);
    }
  }

  unSubscribeListener() {
    if (this.attachScreenListnerSubscription) {
      this.attachScreenListnerSubscription.forEach((sub) => {
        if (typeof sub.unsubscribe === 'function') {
          sub.unsubscribe();
        }
      });
    }
  }

  loadCreatedScreen(screen) {
    const api: any = { ...ApiConstants.getScrById };
    const screenSub$ = this.store.select(selectedScreen);
    const loadScreenSub = screenSub$.subscribe((data: any) => {
      if (data) {
        if (data.sysGen) {
          this.allSelectedScreens.sysGenScreens.push(data);
          this.allSelectedScreens.sysGenScreens = uniqBy(
            orderBy(this.allSelectedScreens.sysGenScreens, ['pageName'], ['asc']),
            'pageName'
          );
        } else {
          if (!this.allSelectedScreens.userGenScreens) {
            this.allSelectedScreens.userGenScreens = [];
          }
          this.allSelectedScreens.userGenScreens.push(data);
          this.allSelectedScreens.userGenScreens = uniqBy(
            orderBy(this.allSelectedScreens.userGenScreens, ['pageName'], ['asc']),
            'pageName'
          );
          this.allSelectedScreens.userGenScreens = uniqBy(this.allSelectedScreens.userGenScreens, 'sid');
        }
        if (loadScreenSub) {
          loadScreenSub.unsubscribe();
        }
      }
    });
    this.addToSubscriptionsList(loadScreenSub);
  }

  refreshActiveScreen(event: any) {
    this.blockedDocument = false;
    this.activeScreen = null;
    this.currentSelectedItem = null;
    setTimeout(() => {
      this.getAllScreens();
    }, 1000);
    this.currentSelectedItem = null;
    this.selectedScreen.emit(this.currentSelectedItem);
    this.selectedNodeTitle = '';
    const structure = [
      {
        title: 'No Data to Display',
        key: 'noData'
      }
    ];
    this.initTree(structure);
  }

  reloadSelectedScreen() {
    if (this.activeScreen && this.isFromModernize) {
      this.loadStructureInterim(null, this.activeScreen);
    }
  }

  getConfidenceClass(value: number | null): string {
    if (!value) return 'ai-none';
    if (value <= 0.2) return 'ai-very-low';
    if (value <= 0.4) return 'ai-low';
    if (value <= 0.6) return 'ai-moderate';
    if (value <= 0.8) return 'ai-high';
    return 'ai-very-high';
  }

  updateScreen(screen) {
    const api: any = { ...ApiConstants.getScrById };
    this.store.dispatch(getScreenStructure({ getScreenStructureApiConstants: api, sid: { sid: screen.sid } }));
    const screenSub$ = this.store.select(selectedScreen);
    const loadScreenSub = screenSub$.subscribe((data: any) => {
      if (data) {
        if (data.sysGen) {
          this.allSelectedScreens.sysGenScreens.forEach((d) => {
            if (d.sid === data.sid && !this.util.isEqualIgnoreCase(data, d, ['modifiedDate'])) {
              d = data;
            }
          });
        } else {
          this.allSelectedScreens.userGenScreens.forEach((d) => {
            if (d.sid === data.sid && !this.util.isEqualIgnoreCase(data, d, ['modifiedDate'])) {
              d = data;
            }
          });
        }
        // update in allScreens array if there is a change in contentAttachment of any screens
        const screenData = [...this.allSelectedScreens.sysGenScreens, ...this.allSelectedScreens.userGenScreens];
        this.store.dispatch(setSelectedScreens({ selectedScreens: screenData }));
        if (loadScreenSub) {
          loadScreenSub.unsubscribe();
        }
      }
    });
    this.addToSubscriptionsList(loadScreenSub);
  }

  updateActiveScreen(screen) {
    if (screen.ScreenActionStatus === 'DELETED') {
      this.allSelectedScreens.userGenScreens = this.allSelectedScreens.userGenScreens.filter(
        (e) => e.sid !== screen.sid
      );
      this.allSelectedScreens.sysGenScreens = this.allSelectedScreens.sysGenScreens.filter((e) => e.sid !== screen.sid);
      let screenData = this.allSelectedScreens.sysGenScreens.length > 0 ? this.allSelectedScreens.sysGenScreens : [];
      if (this.allSelectedScreens.userGenScreens.length > 0) {
        screenData = [...screenData, ...this.allSelectedScreens.userGenScreens];
      }
      if (this.activeScreen?.sid === screen.sid) {
        this.store.dispatch(setSelectedScreens({ selectedScreens: screenData }));
        this.store.dispatch(setScreenStructure({ selectedScreenStructure: null }));
        this.refreshActiveScreen({});
        return;
      }
    }
    if (screen.tabId === this.tabId) {
      return;
    }

    const api: any = { ...ApiConstants.getScrById };

    this.store.dispatch(getScreenStructure({ getScreenStructureApiConstants: api, sid: { sid: screen.sid } }));
    const screenSub$ = this.store.select(selectedScreen);
    const loadScreenSub = screenSub$.subscribe((data: any) => {
      if (data) {
        if (data.sysGen) {
          this.allSelectedScreens.sysGenScreens.forEach((d) => {
            if (
              d.sid === data.sid &&
              !this.util.isEqualIgnoreCase(data, d, ['modifiedDate']) &&
              this.userName !== this.util.getNameFromAppMetaInfo(data.modifiedBy)
            ) {
              this.blockedDocument = true;
              this.blockedMessage = `${this.util.getNameFromAppMetaInfo(data.modifiedBy)} changed something, Please refresh and continue.`;
            }
          });
        } else {
          this.allSelectedScreens.userGenScreens.forEach((d) => {
            if (d.sid === data.sid && !this.util.isEqualIgnoreCase(data, d, ['modifiedDate'])) {
              this.blockedDocument = true;
              if (this.userName !== this.util.getNameFromAppMetaInfo(data.modifiedBy)) {
                this.blockedMessage = `${this.util.getNameFromAppMetaInfo(
                  data.modifiedBy
                )} changed something, Please refresh and continue.`;
              } else {
                this.blockedMessage = `${this.util.getNameFromAppMetaInfo(
                  data.modifiedBy
                )} has changed something in another session, Please refresh and continue to view changes.`;
              }
            }
          });
        }
        if (loadScreenSub) {
          loadScreenSub.unsubscribe();
        }
      }
    });
    this.addToSubscriptionsList(loadScreenSub);
  }
  toggle(event) {
    if (
      !this.cm?.containerViewChild?.nativeElement?.style?.display ||
      this.cm?.containerViewChild?.nativeElement?.style?.display === 'none'
    ) {
      //Open contextual menu
      setTimeout(() => {
        this.cm.position();
        if (this.cm?.containerViewChild?.nativeElement?.style) {
          this.cm.containerViewChild.nativeElement.style.display = 'block';
          this.cm.containerViewChild.nativeElement.style.visibility = 'visible';
        }
      }, 0);
    } else {
      //close contextual menu
      setTimeout(() => {
        if (
          this.cm &&
          this.cm.containerViewChild &&
          this.cm.containerViewChild.nativeElement &&
          this.cm.containerViewChild.nativeElement.style
        ) {
          this.cm.containerViewChild.nativeElement.style.display = 'none';
        }
      }, 0);
    }
  }

  scroll = (event): void => {
    console.log('scroll');
    const el: any = $('.p-contextmenu');
    const length = el.length;
    for (let i = 0; i < length; i++) {
      $(el[i]).css('visibility', 'hidden');
    }
  };

  // Restrict creation of a third level menu group
  // Allow if ancestor is left/rightMenu else allow only 2 nested menu group
  canHaveMenuGroup(node: any) {
    let nodeCopy = node;

    while (nodeCopy) {
      if (nodeCopy.type === 'leftMenu' || nodeCopy.type === 'rightMenu') {
        return true;
      }

      nodeCopy = nodeCopy.parent;
    }

    if (node.type === 'menuGroup' && node.parent?.type === 'menuGroup') {
      return false;
    }
    return true;
  }
  getParentTabView(node) {
    if (node?.type === 'tabView') {
      return node;
    }
    let parentNode = node.parent;
    while (parentNode && parentNode?.type !== 'tabView') {
      parentNode = parentNode?.parent;
    }
    return parentNode;
  }

  getAllTitlesInfo(structure: any) {
    if (this.activeScreen?.pageType === 'detail') {
      structure.forEach((e) => {
        const title = this.removeExtraWhiteSpace(e.title).trim().toLowerCase();
        const nodeType = e.type;
        if (nodeType === 'tabView') {
          if (!this.tabViewTitles.includes(title)) {
            this.tabViewTitles.push(title);
          }
          this.currentTabParent = title;
        } else if (nodeType === 'tab') {
          if (!this.tabTitles[this.currentTabParent]) {
            this.tabTitles[this.currentTabParent] = [title];
          } else if (!this.tabTitles[this.currentTabParent].includes(title)) {
            this.tabTitles[this.currentTabParent].push(title);
          }
        }
        if (e.children) {
          this.getAllTitlesInfo(e.children);
        }
      });
    }
  }

  removeExtraWhiteSpace(str: string) {
    return str.replace(/\s\s+/g, ' ');
  }

  openDropdownMenu(event: SplitButton, eventClick: MouseEvent): void {
    setTimeout(() => {
      event.onDropdownButtonClick(eventClick);
    }, 0);
  }

  listenUserInfo() {
    const userDataSub = this.store.select(userData).subscribe((userInfo: any) => {
      if (userInfo) {
        // Update menu item icons based on beta access
        if (this.items?.length) {
          this.items[0].icon = this.isBetaAccessPrivilegeConsumable ? 'pi pi-bolt' : 'pi pi-file-plus';
          this.items[1].icon = this.isBetaAccessPrivilegeConsumable ? 'pi pi-file' : 'pi pi-file-plus';
        }
      }
    });
    this.addToSubscriptionsList(userDataSub);
  }

  private handleLookupDisableConfirmation(props: any, olddata: any, data: any): Promise<boolean> {
    // Show confirmation popup when disabling lookup
    return new Promise((resolve) => {
      this.confirmationDialogService.confirm({
        message: this.translate.instant('ENABLE_LOOKUP_UNCHECK_CONFIRMATION'),
        accept: () => {
          // User confirmed - continue with disabling lookup
          if (props.lookupConfiguration) {
            props.lookupConfiguration = null;
          }
          resolve(true);
        },
        reject: () => {
          // User cancelled - revert the enableLookup value
          props.enableLookup = olddata.enableLookup;
          props.lookupConfiguration = olddata.lookupConfiguration;
          props.autoFillLookup = olddata.autoFillLookup;
          this.store.dispatch(
            setScreenValues({
              screenValues: {
                currentNode: data.currentNode,
                screenValues: props
              }
            })
          );
          resolve(false);
        }
      });
    });
  }
}


